import projectsimage1 from "../../../assets/images/projectsimage1.webp"
import projectsimage2 from "../../../assets/images/projectsimage2.webp"
import projectsimage3 from "../../../assets/images/projectsimage3.jpg"
import projectsimage4 from "../../../assets/images/projectsimage4.jpg"
import projectsimage5 from "../../../assets/images/projectsimage5.webp"
import projectsimage6 from "../../../assets/images/projectsimage6.webp"
import projectsimage7 from "../../../assets/images/projectsimage7.jpg"
import projectsimage8 from "../../../assets/images/projectsimage8.webp"
import projectsimage9 from "../../../assets/images/projectsimage9.webp"
import projectsimage10 from "../../../assets/images/projectsimage10.webp"
import projectsimage11 from "../../../assets/images/projectsimage11.jpg"
import projectsimage12 from "../../../assets/images/projectsimage12.jpg"
import projectsimage13 from "../../../assets/images/projectsimage13.jpg"
import projectsimage14 from "../../../assets/images/projectsimage14.jpg"
import projectsimage15 from "../../../assets/images/projectsimage15.jpg"
import projectsimage16 from "../../../assets/images/projectsimage16.jpg"
import projectsimage17 from "../../../assets/images/projectsimage17.jpg"
import projectsimage18 from "../../../assets/images/projectsimage18.webp"
import projectsimage19 from "../../../assets/images/projectsimage19.webp"
import projectsimage20 from "../../../assets/images/projectsimage20.webp"
import projectsimage21 from "../../../assets/images/projectsimage21.jpg"
import projectsimage22 from "../../../assets/images/projectsimage22.jpg"
import projectsimage23 from "../../../assets/images/projectsimage23.webp"
import projectsimage24 from "../../../assets/images/projectsimage24.jpg"
import projectsimage25 from "../../../assets/images/projectsimage25.webp"
import projectsimage26 from "../../../assets/images/projectsimage26.webp"
import projectsimage27 from "../../../assets/images/projectsimage27.webp"
import projectsimage28 from "../../../assets/images/projectsimage28.jpg"
import projectsimage29 from "../../../assets/images/projectsimage29.jpg"
import projectsimage30 from "../../../assets/images/projectsimage30.jpg"
import projectsimage31 from "../../../assets/images/projectsimage31.jpg"
import projectsimage32 from "../../../assets/images/projectsimage32.jpg"
import projectsimage33 from "../../../assets/images/projectsimage33.webp"
import projectsimage34 from "../../../assets/images/projectsimage34.webp"
import projectsimage35 from "../../../assets/images/projectsimage35.jpg"
import projectsimage36 from "../../../assets/images/projectsimage36.webp"
import projectsimage37 from "../../../assets/images/projectsimage37.jpg"
import projectsimage38 from "../../../assets/images/projectsimage38.webp"
import projectsimage39 from "../../../assets/images/projectsimage39.jpg"
import projectsimage40 from "../../../assets/images/projectsimage40.jpg"
import projectsimage41 from "../../../assets/images/projectsimage41.webp"
import projectsimage42 from "../../../assets/images/projectsimage42.jpg"
import projectsimage43 from "../../../assets/images/projectsimage43.jpg"
import projectsimage44 from "../../../assets/images/projectsimage44.webp"
import projectsimage45 from "../../../assets/images/projectsimage45.webp"
import projectsimage46 from "../../../assets/images/projectsimage46.webp"
import projectsimage47 from "../../../assets/images/projectsimage47.webp"
import projectsimage48 from "../../../assets/images/projectsimage48.webp"
import projectsimage49 from "../../../assets/images/projectsimage49.webp"
import projectsimage50 from "../../../assets/images/projectsimage50.webp"
import projectsimage51 from "../../../assets/images/projectsimage51.webp"
import projectsimage52 from "../../../assets/images/projectsimage52.webp"
import projectsimage53 from "../../../assets/images/projectsimage53.webp"
import projectsimage54 from "../../../assets/images/projectsimage54.webp"
import projectsimage55 from "../../../assets/images/projectsimage55.jpg"
import projectsimage56 from "../../../assets/images/projectsimage56.webp"
import projectsimage57 from "../../../assets/images/projectsimage57.webp"
import projectsimage58 from "../../../assets/images/projectsimage58.webp"
import projectsimage59 from "../../../assets/images/projectsimage59.webp"
import projectsimage60 from "../../../assets/images/projectsimage60.webp"
import projectsimage61 from "../../../assets/images/projectsimage61.webp"
import projectsimage62 from "../../../assets/images/projectsimage62.webp"

import almarjanimage1 from "../../../assets/images/almarjanimage1.webp"
import almarjanimage2 from "../../../assets/images/almarjanimage2.webp"
import almarjanimage3 from "../../../assets/images/almarjanimage3.webp"
import almarjanimage4 from "../../../assets/images/almarjanimage4.webp"
import almarjanimage5 from "../../../assets/images/almarjanimage5.webp"

import olympusimage1 from "../../../assets/images/olympusimage1.jpg"
import olympusimage2 from "../../../assets/images/olympusimage2.jpg"

import paradigmimage1 from "../../../assets/images/paradigmimage1.webp"
import paradigmimage2 from "../../../assets/images/paradigmimage2.webp"
import paradigmimage3 from "../../../assets/images/paradigmimage3.webp"

import signatureimage1 from "../../../assets/images/signatureimage1.webp"
import signatureimage2 from "../../../assets/images/signatureimage2.webp"
import signatureimage3 from "../../../assets/images/signatureimage3.webp"
import signatureimage4 from "../../../assets/images/signatureimage4.webp"
import signatureimage5 from "../../../assets/images/signatureimage5.webp"

import lionsheadimage1 from "../../../assets/images/lionsheadimage1.webp"
import lionsheadimage2 from "../../../assets/images/lionsheadimage2.webp"
import lionsheadimage3 from "../../../assets/images/lionsheadimage3.webp"
import lionsheadimage4 from "../../../assets/images/lionsheadimage4.webp"

import seafrontimage1 from "../../../assets/images/seafrontimage1.jpg"
import seafrontimage2 from "../../../assets/images/seafrontimage2.webp"
import seafrontimage3 from "../../../assets/images/seafrontimage3.jpg"

import brookfieldimage1 from "../../../assets/images/brookfieldimage1.webp"
import brookfieldimage2 from "../../../assets/images/brookfieldimage2.webp"
import brookfieldimage3 from "../../../assets/images/brookfieldimage3.webp"

import hundredimage1 from "../../../assets/images/hundredimage1.webp"
import hundredimage2 from "../../../assets/images/hundredimage2.webp"
import hundredimage3 from "../../../assets/images/hundredimage3.webp"
import hundredimage4 from "../../../assets/images/hundredimage4.webp"
import hundredimage5 from "../../../assets/images/hundredimage5.webp"

import dockroadimage1 from "../../../assets/images/dockroadimage1.webp"
import dockroadimage2 from "../../../assets/images/dockroadimage2.webp"
import dockroadimage3 from "../../../assets/images/dockroadimage3.webp"

import ellipseimage1 from "../../../assets/images/ellipseimage1.webp"
import ellipseimage2 from "../../../assets/images/ellipseimage2.webp"
import ellipseimage3 from "../../../assets/images/ellipseimage3.webp"

import rosebankimage1 from "../../../assets/images/rosebankimage1.webp"
import rosebankimage2 from "../../../assets/images/rosebankimage2.webp"
import rosebankimage3 from "../../../assets/images/rosebankimage3.webp"
import rosebankimage4 from "../../../assets/images/rosebankimage4.webp"

import sprinfieldimage1 from "../../../assets/images/sprinfieldimage1.webp"
import sprinfieldimage2 from "../../../assets/images/sprinfieldimage2.webp"

import bishopsimage1 from "../../../assets/images/bishopsimage1.webp"
import bishopsimage2 from "../../../assets/images/bishopsimage2.webp"
import bishopsimage3 from "../../../assets/images/bishopsimage3.webp"
import bishopsimage4 from "../../../assets/images/bishopsimage4.webp"

import therubikimage1 from "../../../assets/images/therubikimage1.jpg"
import therubikimage2 from "../../../assets/images/therubikimage2.jpg"
import therubikimage3 from "../../../assets/images/therubikimage3.jpg"

import lowerlongimage1 from "../../../assets/images/lowerlongimage1.webp"
import lowerlongimage2 from "../../../assets/images/lowerlongimage2.webp"

import radissonredimage1 from "../../../assets/images/radissonredimage1.webp"
import radissonredimage2 from "../../../assets/images/radissonredimage2.webp"
import radissonredimage3 from "../../../assets/images/radissonredimage3.webp"
import radissonredimage4 from "../../../assets/images/radissonredimage4.webp"

import oldcapeimage1 from "../../../assets/images/oldcapeimage1.webp"
import oldcapeimage2 from "../../../assets/images/oldcapeimage2.webp"
import oldcapeimage3 from "../../../assets/images/oldcapeimage3.webp"
import oldcapeimage4 from "../../../assets/images/oldcapeimage4.webp"
import oldcapeimage5 from "../../../assets/images/oldcapeimage5.webp"

import oxfordimage1 from "../../../assets/images/oxfordimage1.webp"
import oxfordimage2 from "../../../assets/images/oxfordimage2.webp"
import oxfordimage3 from "../../../assets/images/oxfordimage3.webp"
import oxfordimage4 from "../../../assets/images/oxfordimage4.webp"
import oxfordimage5 from "../../../assets/images/oxfordimage5.webp"

import parksimage1 from "../../../assets/images/parksimage1.webp"
import parksimage2 from "../../../assets/images/parksimage2.webp"
import parksimage3 from "../../../assets/images/parksimage3.webp"
import parksimage4 from "../../../assets/images/parksimage4.webp"
import parksimage5 from "../../../assets/images/parksimage5.webp"

import capitecbankimage1 from "../../../assets/images/capitecbankimage1.webp"
import capitecbankimage2 from "../../../assets/images/capitecbankimage2.webp"
import capitecbankimage3 from "../../../assets/images/capitecbankimage3.webp"
import capitecbankimage4 from "../../../assets/images/capitecbankimage4.webp"
import capitecbankimage5 from "../../../assets/images/capitecbankimage5.webp"

import paardevleiimage1 from "../../../assets/images/paardevleiimage1.jpg"
import paardevleiimage2 from "../../../assets/images/paardevleiimage2.jpg"
import paardevleiimage3 from "../../../assets/images/paardevleiimage3.jpg"
import paardevleiimage4 from "../../../assets/images/paardevleiimage4.jpg"

import sablecornerimage1 from "../../../assets/images/sablecornerimage1.webp"
import sablecornerimage2 from "../../../assets/images/sablecornerimage2.webp"
import sablecornerimage3 from "../../../assets/images/sablecornerimage3.webp"

import cityliftimage1 from "../../../assets/images/cityliftimage1.webp"
import cityliftimage2 from "../../../assets/images/cityliftimage2.webp"
import cityliftimage3 from "../../../assets/images/cityliftimage3.webp"
import cityliftimage4 from "../../../assets/images/cityliftimage4.webp"

import delairegraffimage1 from "../../../assets/images/delairegraffimage1.webp"
import delairegraffimage2 from "../../../assets/images/delairegraffimage2.webp"
import delairegraffimage3 from "../../../assets/images/delairegraffimage3.webp"
import delairegraffimage4 from "../../../assets/images/delairegraffimage4.webp"
import delairegraffimage5 from "../../../assets/images/delairegraffimage5.webp"

import parklandsimage1 from "../../../assets/images/parklandsimage1.webp"
import parklandsimage2 from "../../../assets/images/parklandsimage2.webp"
import parklandsimage3 from "../../../assets/images/parklandsimage3.webp"
import parklandsimage4 from "../../../assets/images/parklandsimage4.webp"
import parklandsimage5 from "../../../assets/images/parklandsimage5.webp"

import quadrantimage1 from "../../../assets/images/quadrantimage1.webp"
import quadrantimage2 from "../../../assets/images/quadrantimage2.webp"
import quadrantimage3 from "../../../assets/images/quadrantimage3.webp"

import areapiliimage1 from "../../../assets/images/areapiliimage1.webp"
import areapiliimage2 from "../../../assets/images/areapiliimage2.webp"
import areapiliimage3 from "../../../assets/images/areapiliimage3.webp"
import areapiliimage4 from "../../../assets/images/areapiliimage4.webp"

import axisimage1 from "../../../assets/images/axisimage1.webp"
import axisimage2 from "../../../assets/images/axisimage2.webp"
import axisimage3 from "../../../assets/images/axisimage3.webp"
import axisimage4 from "../../../assets/images/axisimage4.webp"

import conradieparkimage1 from "../../../assets/images/conradieparkimage1.webp"
import conradieparkimage2 from "../../../assets/images/conradieparkimage2.webp"
import conradieparkimage3 from "../../../assets/images/conradieparkimage3.webp"
import conradieparkimage4 from "../../../assets/images/conradieparkimage4.webp"
import conradieparkimage5 from "../../../assets/images/conradieparkimage5.webp"

import norvalimage1 from "../../../assets/images/norvalimage1.webp"
import norvalimage2 from "../../../assets/images/norvalimage2.webp"
import norvalimage3 from "../../../assets/images/norvalimage3.webp"
import norvalimage4 from "../../../assets/images/norvalimage4.webp"
import norvalimage5 from "../../../assets/images/norvalimage5.webp"

import sableparkimage1 from "../../../assets/images/sableparkimage1.webp"
import sableparkimage2 from "../../../assets/images/sableparkimage2.webp"
import sableparkimage3 from "../../../assets/images/sableparkimage3.webp"
import sableparkimage4 from "../../../assets/images/sableparkimage4.webp"
import sableparkimage5 from "../../../assets/images/sableparkimage5.webp"

import waterwayhouseimage1 from "../../../assets/images/waterwayhouseimage1.webp"
import waterwayhouseimage2 from "../../../assets/images/waterwayhouseimage2.webp"
import waterwayhouseimage3 from "../../../assets/images/waterwayhouseimage3.webp"
import waterwayhouseimage4 from "../../../assets/images/waterwayhouseimage4.webp"

import baywestmallimage1 from "../../../assets/images/baywestmallimage1.webp"
import baywestmallimage2 from "../../../assets/images/baywestmallimage2.webp"
import baywestmallimage3 from "../../../assets/images/baywestmallimage3.webp"
import baywestmallimage4 from "../../../assets/images/baywestmallimage4.webp"

import bridgeparkimage1 from "../../../assets/images/bridgeparkimage1.webp"
import bridgeparkimage2 from "../../../assets/images/bridgeparkimage2.jpg"
import bridgeparkimage3 from "../../../assets/images/bridgeparkimage3.webp"
import bridgeparkimage4 from "../../../assets/images/bridgeparkimage4.webp"

import dainfernimage1 from "../../../assets/images/dainfernimage1.webp"
import dainfernimage2 from "../../../assets/images/dainfernimage2.webp"
import dainfernimage3 from "../../../assets/images/dainfernimage3.webp"

import newtownimage1 from "../../../assets/images/newtownimage1.webp"
import newtownimage2 from "../../../assets/images/newtownimage2.webp"
import newtownimage3 from "../../../assets/images/newtownimage3.webp"
import newtownimage4 from "../../../assets/images/newtownimage4.webp"
import newtownimage5 from "../../../assets/images/newtownimage5.jpg"

import oxfordparksimage1 from "../../../assets/images/oxfordparksimage1.webp"
import oxfordparksimage2 from "../../../assets/images/oxfordparksimage2.webp"
import oxfordparksimage3 from "../../../assets/images/oxfordparksimage3.webp"
import oxfordparksimage4 from "../../../assets/images/oxfordparksimage4.webp"
import oxfordparksimage5 from "../../../assets/images/oxfordparksimage5.webp"

import portsideimage1 from "../../../assets/images/portsideimage1.webp"
import portsideimage2 from "../../../assets/images/portsideimage2.webp"
import portsideimage3 from "../../../assets/images/portsideimage3.webp"
import portsideimage4 from "../../../assets/images/portsideimage4.webp"
import portsideimage5 from "../../../assets/images/portsideimage5.webp"

import drostdyhotelimage1 from "../../../assets/images/drostdyhotelimage1.webp"
import drostdyhotelimage2 from "../../../assets/images/drostdyhotelimage2.jpg"
import drostdyhotelimage3 from "../../../assets/images/drostdyhotelimage3.jpg"

import fabrikmasterplanimage1 from "../../../assets/images/fabrikmasterplanimage1.webp"
import fabrikmasterplanimage2 from "../../../assets/images/fabrikmasterplanimage2.webp"
import fabrikmasterplanimage3 from "../../../assets/images/fabrikmasterplanimage3.webp"
import fabrikmasterplanimage4 from "../../../assets/images/fabrikmasterplanimage4.webp"

import nieuwesteenbergimage1 from "../../../assets/images/nieuwesteenbergimage1.webp"
import nieuwesteenbergimage2 from "../../../assets/images/nieuwesteenbergimage2.webp"
import nieuwesteenbergimage3 from "../../../assets/images/nieuwesteenbergimage3.webp"

import theshedsimage1 from "../../../assets/images/theshedsimage1.webp"
import theshedsimage2 from "../../../assets/images/theshedsimage2.webp"
import theshedsimage3 from "../../../assets/images/theshedsimage3.webp"
import theshedsimage4 from "../../../assets/images/theshedsimage4.webp"

import thefringeimage1 from "../../../assets/images/thefringeimage1.webp"
import thefringeimage2 from "../../../assets/images/thefringeimage2.webp"
import thefringeimage3 from "../../../assets/images/thefringeimage3.webp"

import doubletreeimage1 from "../../../assets/images/doubletreeimage1.webp"
import doubletreeimage2 from "../../../assets/images/doubletreeimage2.webp"
import doubletreeimage3 from "../../../assets/images/doubletreeimage3.webp"
import doubletreeimage4 from "../../../assets/images/doubletreeimage4.webp"

import eikestadmallimage1 from "../../../assets/images/eikestadmallimage1.jpg"
import eikestadmallimage2 from "../../../assets/images/eikestadmallimage2.jpg"

import kempsinkiimage1 from "../../../assets/images/kempsinkiimage1.jpg"
import kempsinkiimage2 from "../../../assets/images/kempsinkiimage2.webp"

import melrosearchimage1 from "../../../assets/images/melrosearchimage1.webp"
import melrosearchimage2 from "../../../assets/images/melrosearchimage2.webp"
import melrosearchimage3 from "../../../assets/images/melrosearchimage3.webp"
import melrosearchimage4 from "../../../assets/images/melrosearchimage4.webp"
import melrosearchimage5 from "../../../assets/images/melrosearchimage5.webp"

import tajpalacehotelimage1 from "../../../assets/images/tajpalacehotelimage1.jpg"
import tajpalacehotelimage2 from "../../../assets/images/tajpalacehotelimage2.webp"
import tajpalacehotelimage3 from "../../../assets/images/tajpalacehotelimage3.jpg"
import tajpalacehotelimage4 from "../../../assets/images/tajpalacehotelimage4.webp"

import uwclifeimage1 from "../../../assets/images/uwclifeimage1.webp"
import uwclifeimage2 from "../../../assets/images/uwclifeimage2.webp"
import uwclifeimage3 from "../../../assets/images/uwclifeimage3.webp"

import wangarimathaiimage1 from "../../../assets/images/wangarimathaiimage1.webp"
import wangarimathaiimage2 from "../../../assets/images/wangarimathaiimage2.webp"
import wangarimathaiimage3 from "../../../assets/images/wangarimathaiimage3.webp"

import ahmedbabaimage1 from "../../../assets/images/ahmedbabaimage1.webp"
import ahmedbabaimage2 from "../../../assets/images/ahmedbabaimage2.webp"
import ahmedbabaimage3 from "../../../assets/images/ahmedbabaimage3.webp"
import ahmedbabaimage4 from "../../../assets/images/ahmedbabaimage4.webp"
import ahmedbabaimage5 from "../../../assets/images/ahmedbabaimage5.webp"

import delairegraffwineryimage1 from "../../../assets/images/delairegraffwineryimage1.webp"
import delairegraffwineryimage2 from "../../../assets/images/delairegraffwineryimage2.webp"
import delairegraffwineryimage3 from "../../../assets/images/delairegraffwineryimage3.webp"
import delairegraffwineryimage4 from "../../../assets/images/delairegraffwineryimage4.webp"

import theboulevardimage1 from "../../../assets/images/theboulevardimage1.webp"
import theboulevardimage2 from "../../../assets/images/theboulevardimage2.webp"
import theboulevardimage3 from "../../../assets/images/theboulevardimage3.webp"

import thecrystalimage1 from "../../../assets/images/thecrystalimage1.webp"
import thecrystalimage2 from "../../../assets/images/thecrystalimage2.webp"
import thecrystalimage3 from "../../../assets/images/thecrystalimage3.webp"

import mandelarhodesplaceimage1 from "../../../assets/images/mandelarhodesplaceimage1.webp"
import mandelarhodesplaceimage2 from "../../../assets/images/mandelarhodesplaceimage2.webp"
import mandelarhodesplaceimage3 from "../../../assets/images/mandelarhodesplaceimage3.webp"
import mandelarhodesplaceimage4 from "../../../assets/images/mandelarhodesplaceimage4.webp"

import uctchemicalimage1 from "../../../assets/images/uctchemicalimage1.jpg"
import uctchemicalimage2 from "../../../assets/images/uctchemicalimage2.webp"
import uctchemicalimage3 from "../../../assets/images/uctchemicalimage3.webp"
import uctchemicalimage4 from "../../../assets/images/uctchemicalimage4.webp"
import uctchemicalimage5 from "../../../assets/images/uctchemicalimage5.webp"

import lavelaimage1 from "../../../assets/images/lavelaimage1.webp"
import lavelaimage2 from "../../../assets/images/lavelaimage2.webp"
import lavelaimage3 from "../../../assets/images/lavelaimage3.webp"
import lavelaimage4 from "../../../assets/images/lavelaimage4.webp"

import lagunapalacehotelimage1 from "../../../assets/images/lagunapalacehotelimage1.webp"
import lagunapalacehotelimage2 from "../../../assets/images/lagunapalacehotelimage2.webp"
import lagunapalacehotelimage3 from "../../../assets/images/lagunapalacehotelimage3.webp"
import lagunapalacehotelimage4 from "../../../assets/images/lagunapalacehotelimage4.webp"


import almarjansliderimage1 from "../../../assets/images/almarjansliderimage1.jpg"
import almarjansliderimage2 from "../../../assets/images/almarjansliderimage2.webp"
import almarjansliderimage3 from "../../../assets/images/almarjansliderimage3.webp"
import almarjansliderimage4 from "../../../assets/images/almarjansliderimage4.jpg"
import almarjansliderimage5 from "../../../assets/images/almarjansliderimage5.webp"
import almarjansliderimage6 from "../../../assets/images/almarjansliderimage6.webp"
import almarjansliderimage7 from "../../../assets/images/almarjansliderimage7.jpg"
import almarjansliderimage8 from "../../../assets/images/almarjansliderimage8.webp"
import almarjansliderimage9 from "../../../assets/images/almarjansliderimage9.webp"

import canalplazasliderimage1 from "../../../assets/images/canalplazasliderimage1.webp"
import canalplazasliderimage2 from "../../../assets/images/canalplazasliderimage2.jpg"
import canalplazasliderimage3 from "../../../assets/images/canalplazasliderimage3.jpg"
import canalplazasliderimage4 from "../../../assets/images/canalplazasliderimage4.jpg"
import canalplazasliderimage5 from "../../../assets/images/canalplazasliderimage5.jpg"

import olympussliderimage1 from "../../../assets/images/olympussliderimage1.jpg"
import olympussliderimage2 from "../../../assets/images/olympussliderimage2.webp"

import theparadigmsliderimage1 from "../../../assets/images/theparadigmsliderimage1.jpg"
import theparadigmsliderimage2 from "../../../assets/images/theparadigmsliderimage2.webp"
import theparadigmsliderimage3 from "../../../assets/images/theparadigmsliderimage3.webp"
import theparadigmsliderimage4 from "../../../assets/images/theparadigmsliderimage4.webp"
import theparadigmsliderimage5 from "../../../assets/images/theparadigmsliderimage5.webp"
import theparadigmsliderimage6 from "../../../assets/images/theparadigmsliderimage6.webp"
import theparadigmsliderimage7 from "../../../assets/images/theparadigmsliderimage7.jpg"
import theparadigmsliderimage8 from "../../../assets/images/theparadigmsliderimage8.jpg"
import theparadigmsliderimage9 from "../../../assets/images/theparadigmsliderimage9.webp"
import theparadigmsliderimage10 from "../../../assets/images/theparadigmsliderimage10.webp"
import theparadigmsliderimage11 from "../../../assets/images/theparadigmsliderimage11.webp"
import theparadigmsliderimage12 from "../../../assets/images/theparadigmsliderimage12.webp"
import theparadigmsliderimage13 from "../../../assets/images/theparadigmsliderimage13.webp"
import theparadigmsliderimage14 from "../../../assets/images/theparadigmsliderimage14.webp"
import theparadigmsliderimage15 from "../../../assets/images/theparadigmsliderimage15.webp"

import thesignaturesliderimage1 from "../../../assets/images/thesignaturesliderimage1.webp"
import thesignaturesliderimage2 from "../../../assets/images/thesignaturesliderimage2.webp"
import thesignaturesliderimage3 from "../../../assets/images/thesignaturesliderimage3.webp"
import thesignaturesliderimage4 from "../../../assets/images/thesignaturesliderimage4.webp"
import thesignaturesliderimage5 from "../../../assets/images/thesignaturesliderimage5.webp"
import thesignaturesliderimage6 from "../../../assets/images/thesignaturesliderimage6.webp"
import thesignaturesliderimage7 from "../../../assets/images/thesignaturesliderimage7.webp"
import thesignaturesliderimage8 from "../../../assets/images/thesignaturesliderimage8.webp"
import thesignaturesliderimage9 from "../../../assets/images/thesignaturesliderimage9.webp"

import lionsheadsliderimage1 from "../../../assets/images/lionsheadsliderimage1.webp"
import lionsheadsliderimage2 from "../../../assets/images/lionsheadsliderimage2.webp"
import lionsheadsliderimage3 from "../../../assets/images/lionsheadsliderimage3.webp"
import lionsheadsliderimage4 from "../../../assets/images/lionsheadsliderimage4.gif"
import lionsheadsliderimage5 from "../../../assets/images/lionsheadsliderimage5.webp"

import seafrontestatesliderimage1 from "../../../assets/images/seafrontestatesliderimage1.jpg"
import seafrontestatesliderimage2 from "../../../assets/images/seafrontestatesliderimage2.jpg"
import seafrontestatesliderimage3 from "../../../assets/images/seafrontestatesliderimage3.jpg"
import seafrontestatesliderimage4 from "../../../assets/images/seafrontestatesliderimage4.jpg"
import seafrontestatesliderimage5 from "../../../assets/images/seafrontestatesliderimage5.jpg"
import seafrontestatesliderimage6 from "../../../assets/images/seafrontestatesliderimage6.jpg"
import seafrontestatesliderimage7 from "../../../assets/images/seafrontestatesliderimage7.jpg"

import brookfieldroyalsliderimage1 from "../../../assets/images/brookfieldroyalsliderimage1.webp"
import brookfieldroyalsliderimage2 from "../../../assets/images/brookfieldroyalsliderimage2.jpg"
import brookfieldroyalsliderimage3 from "../../../assets/images/brookfieldroyalsliderimage3.webp"
import brookfieldroyalsliderimage4 from "../../../assets/images/brookfieldroyalsliderimage4.jpg"
import brookfieldroyalsliderimage5 from "../../../assets/images/brookfieldroyalsliderimage5.webp"
import brookfieldroyalsliderimage6 from "../../../assets/images/brookfieldroyalsliderimage6.webp"
import brookfieldroyalsliderimage7 from "../../../assets/images/brookfieldroyalsliderimage7.jpg"
import brookfieldroyalsliderimage8 from "../../../assets/images/brookfieldroyalsliderimage8.webp"
import brookfieldroyalsliderimage9 from "../../../assets/images/brookfieldroyalsliderimage9.webp"
import brookfieldroyalsliderimage10 from "../../../assets/images/brookfieldroyalsliderimage10.jpg"
import brookfieldroyalsliderimage11 from "../../../assets/images/brookfieldroyalsliderimage11.webp"

import hundredsliderimage1 from "../../../assets/images/hundredsliderimage1.webp"
import hundredsliderimage2 from "../../../assets/images/hundredsliderimage2.webp"
import hundredsliderimage3 from "../../../assets/images/hundredsliderimage3.webp"
import hundredsliderimage4 from "../../../assets/images/hundredsliderimage4.webp"
import hundredsliderimage5 from "../../../assets/images/hundredsliderimage5.webp"
import hundredsliderimage6 from "../../../assets/images/hundredsliderimage6.webp"
import hundredsliderimage7 from "../../../assets/images/hundredsliderimage7.webp"
import hundredsliderimage8 from "../../../assets/images/hundredsliderimage8.jpg"
import hundredsliderimage9 from "../../../assets/images/hundredsliderimage9.webp"

import dockroadsliderimage1 from "../../../assets/images/dockroadsliderimage1.webp"
import dockroadsliderimage2 from "../../../assets/images/dockroadsliderimage2.jpg"
import dockroadsliderimage3 from "../../../assets/images/dockroadsliderimage3.jpg"
import dockroadsliderimage4 from "../../../assets/images/dockroadsliderimage4.webp"
import dockroadsliderimage5 from "../../../assets/images/dockroadsliderimage5.webp"
import dockroadsliderimage6 from "../../../assets/images/dockroadsliderimage6.webp"
import dockroadsliderimage7 from "../../../assets/images/dockroadsliderimage7.webp"

import ellipsewaterfallsliderimage1 from "../../../assets/images/ellipsewaterfallsliderimage1.jpg"
import ellipsewaterfallsliderimage2 from "../../../assets/images/ellipsewaterfallsliderimage2.jpg"
import ellipsewaterfallsliderimage3 from "../../../assets/images/ellipsewaterfallsliderimage3.webp"
import ellipsewaterfallsliderimage4 from "../../../assets/images/ellipsewaterfallsliderimage4.webp"
import ellipsewaterfallsliderimage5 from "../../../assets/images/ellipsewaterfallsliderimage5.webp"
import ellipsewaterfallsliderimage6 from "../../../assets/images/ellipsewaterfallsliderimage6.jpg"
import ellipsewaterfallsliderimage7 from "../../../assets/images/ellipsewaterfallsliderimage7.webp"
import ellipsewaterfallsliderimage8 from "../../../assets/images/ellipsewaterfallsliderimage8.webp"
import ellipsewaterfallsliderimage9 from "../../../assets/images/ellipsewaterfallsliderimage9.webp"
import ellipsewaterfallsliderimage10 from "../../../assets/images/ellipsewaterfallsliderimage10.webp"

import onerosebanksliderimage1 from "../../../assets/images/onerosebanksliderimage1.jpg"
import onerosebanksliderimage2 from "../../../assets/images/onerosebanksliderimage2.webp"
import onerosebanksliderimage3 from "../../../assets/images/onerosebanksliderimage3.webp"
import onerosebanksliderimage4 from "../../../assets/images/onerosebanksliderimage4.webp"
import onerosebanksliderimage5 from "../../../assets/images/onerosebanksliderimage5.webp"
import onerosebanksliderimage6 from "../../../assets/images/onerosebanksliderimage6.webp"
import onerosebanksliderimage7 from "../../../assets/images/onerosebanksliderimage7.webp"
import onerosebanksliderimage8 from "../../../assets/images/onerosebanksliderimage8.webp"
import onerosebanksliderimage9 from "../../../assets/images/onerosebanksliderimage9.webp"

import springfieldestatesliderimage1 from "../../../assets/images/springfieldestatesliderimage1.jpg"
import springfieldestatesliderimage2 from "../../../assets/images/springfieldestatesliderimage2.jpg"
import springfieldestatesliderimage3 from "../../../assets/images/springfieldestatesliderimage3.webp"
import springfieldestatesliderimage4 from "../../../assets/images/springfieldestatesliderimage4.jpg"
import springfieldestatesliderimage5 from "../../../assets/images/springfieldestatesliderimage5.webp"
import springfieldestatesliderimage6 from "../../../assets/images/springfieldestatesliderimage6.webp"
import springfieldestatesliderimage7 from "../../../assets/images/springfieldestatesliderimage7.jpg"
import springfieldestatesliderimage8 from "../../../assets/images/springfieldestatesliderimage8.jpg"
import springfieldestatesliderimage9 from "../../../assets/images/springfieldestatesliderimage9.jpg"
import springfieldestatesliderimage10 from "../../../assets/images/springfieldestatesliderimage10.webp"
import springfieldestatesliderimage11 from "../../../assets/images/springfieldestatesliderimage11.webp"
import springfieldestatesliderimage12 from "../../../assets/images/springfieldestatesliderimage12.webp"

import bishopsacademicsliderimage1 from "../../../assets/images/bishopsacademicsliderimage1.jpg"
import bishopsacademicsliderimage2 from "../../../assets/images/bishopsacademicsliderimage2.webp"
import bishopsacademicsliderimage3 from "../../../assets/images/bishopsacademicsliderimage3.webp"
import bishopsacademicsliderimage4 from "../../../assets/images/bishopsacademicsliderimage4.webp"
import bishopsacademicsliderimage5 from "../../../assets/images/bishopsacademicsliderimage5.webp"
import bishopsacademicsliderimage6 from "../../../assets/images/bishopsacademicsliderimage6.jpg"
import bishopsacademicsliderimage7 from "../../../assets/images/bishopsacademicsliderimage7.webp"
import bishopsacademicsliderimage8 from "../../../assets/images/bishopsacademicsliderimage8.webp"
import bishopsacademicsliderimage9 from "../../../assets/images/bishopsacademicsliderimage9.webp"

import longkloofsliderimage1 from "../../../assets/images/longkloofsliderimage1.jpg"
import longkloofsliderimage2 from "../../../assets/images/longkloofsliderimage2.jpg"
import longkloofsliderimage3 from "../../../assets/images/longkloofsliderimage3.jpg"
import longkloofsliderimage4 from "../../../assets/images/longkloofsliderimage4.jpg"
import longkloofsliderimage5 from "../../../assets/images/longkloofsliderimage5.jpg"
import longkloofsliderimage6 from "../../../assets/images/longkloofsliderimage6.jpg"
import longkloofsliderimage7 from "../../../assets/images/longkloofsliderimage7.jpg"
import longkloofsliderimage8 from "../../../assets/images/longkloofsliderimage8.webp"
import longkloofsliderimage9 from "../../../assets/images/longkloofsliderimage9.jpg"
import longkloofsliderimage10 from "../../../assets/images/longkloofsliderimage10.jpg"
import longkloofsliderimage11 from "../../../assets/images/longkloofsliderimage11.jpg"
import longkloofsliderimage12 from "../../../assets/images/longkloofsliderimage12.jpg"
import longkloofsliderimage13 from "../../../assets/images/longkloofsliderimage13.jpg"
import longkloofsliderimage14 from "../../../assets/images/longkloofsliderimage14.jpg"
import longkloofsliderimage15 from "../../../assets/images/longkloofsliderimage15.jpg"
import longkloofsliderimage16 from "../../../assets/images/longkloofsliderimage16.jpg"
import longkloofsliderimage17 from "../../../assets/images/longkloofsliderimage17.jpg"

import therubiksliderimage1 from "../../../assets/images/therubiksliderimage1.jpg"
import therubiksliderimage2 from "../../../assets/images/therubiksliderimage2.webp"
import therubiksliderimage3 from "../../../assets/images/therubiksliderimage3.webp"
import therubiksliderimage4 from "../../../assets/images/therubiksliderimage4.webp"
import therubiksliderimage5 from "../../../assets/images/therubiksliderimage5.webp"
import therubiksliderimage6 from "../../../assets/images/therubiksliderimage6.webp"
import therubiksliderimage7 from "../../../assets/images/therubiksliderimage7.webp"
import therubiksliderimage8 from "../../../assets/images/therubiksliderimage8.jpg"
import therubiksliderimage9 from "../../../assets/images/therubiksliderimage9.webp"

import lowerlongsliderimage1 from "../../../assets/images/lowerlongsliderimage1.jpg"
import lowerlongsliderimage2 from "../../../assets/images/lowerlongsliderimage2.webp"
import lowerlongsliderimage3 from "../../../assets/images/lowerlongsliderimage3.webp"
import lowerlongsliderimage4 from "../../../assets/images/lowerlongsliderimage4.webp"
import lowerlongsliderimage5 from "../../../assets/images/lowerlongsliderimage5.jpg"
import lowerlongsliderimage6 from "../../../assets/images/lowerlongsliderimage6.webp"
import lowerlongsliderimage7 from "../../../assets/images/lowerlongsliderimage7.webp"

import radissonredsliderimage1 from "../../../assets/images/radissonredsliderimage1.webp"
import radissonredsliderimage2 from "../../../assets/images/radissonredsliderimage2.webp"
import radissonredsliderimage3 from "../../../assets/images/radissonredsliderimage3.jpg"
import radissonredsliderimage4 from "../../../assets/images/radissonredsliderimage4.webp"
import radissonredsliderimage5 from "../../../assets/images/radissonredsliderimage5.webp"
import radissonredsliderimage6 from "../../../assets/images/radissonredsliderimage6.webp"
import radissonredsliderimage7 from "../../../assets/images/radissonredsliderimage7.webp"
import radissonredsliderimage8 from "../../../assets/images/radissonredsliderimage8.webp"
import radissonredsliderimage9 from "../../../assets/images/radissonredsliderimage9.webp"
import radissonredsliderimage10 from "../../../assets/images/radissonredsliderimage10.webp"

import oldcapesliderimage1 from "../../../assets/images/oldcapesliderimage1.webp"
import oldcapesliderimage2 from "../../../assets/images/oldcapesliderimage2.webp"
import oldcapesliderimage3 from "../../../assets/images/oldcapesliderimage3.webp"
import oldcapesliderimage4 from "../../../assets/images/oldcapesliderimage4.webp"
import oldcapesliderimage5 from "../../../assets/images/oldcapesliderimage5.webp"
import oldcapesliderimage6 from "../../../assets/images/oldcapesliderimage6.webp"
import oldcapesliderimage7 from "../../../assets/images/oldcapesliderimage7.jpg"
import oldcapesliderimage8 from "../../../assets/images/oldcapesliderimage8.webp"
import oldcapesliderimage9 from "../../../assets/images/oldcapesliderimage9.webp"
import oldcapesliderimage10 from "../../../assets/images/oldcapesliderimage10.webp"
import oldcapesliderimage11 from "../../../assets/images/oldcapesliderimage11.jpg"
import oldcapesliderimage12 from "../../../assets/images/oldcapesliderimage12.jpg"
import oldcapesliderimage13 from "../../../assets/images/oldcapesliderimage13.webp"
import oldcapesliderimage14 from "../../../assets/images/oldcapesliderimage14.webp"
import oldcapesliderimage15 from "../../../assets/images/oldcapesliderimage15.webp"

import oxfordsliderimage1 from "../../../assets/images/oxfordsliderimage1.webp"
import oxfordsliderimage2 from "../../../assets/images/oxfordsliderimage2.webp"
import oxfordsliderimage3 from "../../../assets/images/oxfordsliderimage3.webp"
import oxfordsliderimage4 from "../../../assets/images/oxfordsliderimage4.webp"
import oxfordsliderimage5 from "../../../assets/images/oxfordsliderimage5.webp"
import oxfordsliderimage6 from "../../../assets/images/oxfordsliderimage6.jpg"
import oxfordsliderimage7 from "../../../assets/images/oxfordsliderimage7.webp"
import oxfordsliderimage8 from "../../../assets/images/oxfordsliderimage8.webp"
import oxfordsliderimage9 from "../../../assets/images/oxfordsliderimage9.jpg"
import oxfordsliderimage10 from "../../../assets/images/oxfordsliderimage10.jpg"
import oxfordsliderimage11 from "../../../assets/images/oxfordsliderimage11.webp"
import oxfordsliderimage12 from "../../../assets/images/oxfordsliderimage12.webp"
import oxfordsliderimage13 from "../../../assets/images/oxfordsliderimage13.webp"

import parkssliderimage1 from "../../../assets/images/parkssliderimage1.jpg"
import parkssliderimage2 from "../../../assets/images/parkssliderimage2.webp"
import parkssliderimage3 from "../../../assets/images/parkssliderimage3.webp"
import parkssliderimage4 from "../../../assets/images/parkssliderimage4.webp"
import parkssliderimage5 from "../../../assets/images/parkssliderimage5.webp"
import parkssliderimage6 from "../../../assets/images/parkssliderimage6.webp"
import parkssliderimage7 from "../../../assets/images/parkssliderimage7.webp"
import parkssliderimage8 from "../../../assets/images/parkssliderimage8.webp"
import parkssliderimage9 from "../../../assets/images/parkssliderimage9.webp"
import parkssliderimage10 from "../../../assets/images/parkssliderimage10.webp"

import capitecbanksliderimage1 from "../../../assets/images/capitecbanksliderimage1.jpg"
import capitecbanksliderimage2 from "../../../assets/images/capitecbanksliderimage2.webp"
import capitecbanksliderimage3 from "../../../assets/images/capitecbanksliderimage3.webp"
import capitecbanksliderimage4 from "../../../assets/images/capitecbanksliderimage4.webp"
import capitecbanksliderimage5 from "../../../assets/images/capitecbanksliderimage5.webp"
import capitecbanksliderimage6 from "../../../assets/images/capitecbanksliderimage6.webp"
import capitecbanksliderimage7 from "../../../assets/images/capitecbanksliderimage7.webp"
import capitecbanksliderimage8 from "../../../assets/images/capitecbanksliderimage8.webp"
import capitecbanksliderimage9 from "../../../assets/images/capitecbanksliderimage9.webp"
import capitecbanksliderimage10 from "../../../assets/images/capitecbanksliderimage10.webp"
import capitecbanksliderimage11 from "../../../assets/images/capitecbanksliderimage11.jpg"
import capitecbanksliderimage12 from "../../../assets/images/capitecbanksliderimage12.jpg"
import capitecbanksliderimage13 from "../../../assets/images/capitecbanksliderimage13.jpg"

import paardevleisliderimage1 from "../../../assets/images/paardevleisliderimage1.webp"
import paardevleisliderimage2 from "../../../assets/images/paardevleisliderimage2.webp"
import paardevleisliderimage3 from "../../../assets/images/paardevleisliderimage3.webp"
import paardevleisliderimage4 from "../../../assets/images/paardevleisliderimage4.webp"
import paardevleisliderimage5 from "../../../assets/images/paardevleisliderimage5.jpg"
import paardevleisliderimage6 from "../../../assets/images/paardevleisliderimage6.webp"
import paardevleisliderimage7 from "../../../assets/images/paardevleisliderimage7.jpg"
import paardevleisliderimage8 from "../../../assets/images/paardevleisliderimage8.webp"
import paardevleisliderimage9 from "../../../assets/images/paardevleisliderimage9.webp"
import paardevleisliderimage10 from "../../../assets/images/paardevleisliderimage10.jpg"
import paardevleisliderimage11 from "../../../assets/images/paardevleisliderimage11.webp"
import paardevleisliderimage12 from "../../../assets/images/paardevleisliderimage12.webp"
import paardevleisliderimage13 from "../../../assets/images/paardevleisliderimage13.jpg"

import sablecornersliderimage1 from "../../../assets/images/sablecornersliderimage1.jpg"
import sablecornersliderimage2 from "../../../assets/images/sablecornersliderimage2.webp"
import sablecornersliderimage3 from "../../../assets/images/sablecornersliderimage3.webp"
import sablecornersliderimage4 from "../../../assets/images/sablecornersliderimage4.webp"
import sablecornersliderimage5 from "../../../assets/images/sablecornersliderimage5.webp"
import sablecornersliderimage6 from "../../../assets/images/sablecornersliderimage6.webp"
import sablecornersliderimage7 from "../../../assets/images/sablecornersliderimage7.webp"
import sablecornersliderimage8 from "../../../assets/images/sablecornersliderimage8.webp"
import sablecornersliderimage9 from "../../../assets/images/sablecornersliderimage9.jpg"
import sablecornersliderimage10 from "../../../assets/images/sablecornersliderimage10.webp"
import sablecornersliderimage11 from "../../../assets/images/sablecornersliderimage11.webp"

import cityliftsliderimage1 from "../../../assets/images/cityliftsliderimage1.webp"
import cityliftsliderimage2 from "../../../assets/images/cityliftsliderimage2.gif"
import cityliftsliderimage3 from "../../../assets/images/cityliftsliderimage3.webp"
import cityliftsliderimage4 from "../../../assets/images/cityliftsliderimage4.webp"
import cityliftsliderimage5 from "../../../assets/images/cityliftsliderimage5.webp"
import cityliftsliderimage6 from "../../../assets/images/cityliftsliderimage6.gif"
import cityliftsliderimage7 from "../../../assets/images/cityliftsliderimage7.webp"
import cityliftsliderimage8 from "../../../assets/images/cityliftsliderimage8.webp"
import cityliftsliderimage9 from "../../../assets/images/cityliftsliderimage9.webp"
import cityliftsliderimage10 from "../../../assets/images/cityliftsliderimage10.webp"

import delairegraffsliderimage1 from "../../../assets/images/delairegraffsliderimage1.webp"
import delairegraffsliderimage2 from "../../../assets/images/delairegraffsliderimage2.webp"
import delairegraffsliderimage3 from "../../../assets/images/delairegraffsliderimage3.jpg"
import delairegraffsliderimage4 from "../../../assets/images/delairegraffsliderimage4.webp"
import delairegraffsliderimage5 from "../../../assets/images/delairegraffsliderimage5.webp"
import delairegraffsliderimage6 from "../../../assets/images/delairegraffsliderimage6.webp"
import delairegraffsliderimage7 from "../../../assets/images/delairegraffsliderimage7.webp"
import delairegraffsliderimage8 from "../../../assets/images/delairegraffsliderimage8.webp"
import delairegraffsliderimage9 from "../../../assets/images/delairegraffsliderimage9.webp"
import delairegraffsliderimage10 from "../../../assets/images/delairegraffsliderimage10.webp"
import delairegraffsliderimage11 from "../../../assets/images/delairegraffsliderimage11.jpg"
import delairegraffsliderimage12 from "../../../assets/images/delairegraffsliderimage12.jpg"
import delairegraffsliderimage13 from "../../../assets/images/delairegraffsliderimage13.webp"
import delairegraffsliderimage14 from "../../../assets/images/delairegraffsliderimage14.webp"
import delairegraffsliderimage15 from "../../../assets/images/delairegraffsliderimage15.webp"
import delairegraffsliderimage16 from "../../../assets/images/delairegraffsliderimage16.webp"
import delairegraffsliderimage17 from "../../../assets/images/delairegraffsliderimage17.webp"
import delairegraffsliderimage18 from "../../../assets/images/delairegraffsliderimage18.webp"

import parklandssliderimage1 from "../../../assets/images/parklandssliderimage1.webp"
import parklandssliderimage2 from "../../../assets/images/parklandssliderimage2.webp"
import parklandssliderimage3 from "../../../assets/images/parklandssliderimage3.jpg"
import parklandssliderimage4 from "../../../assets/images/parklandssliderimage4.webp"
import parklandssliderimage5 from "../../../assets/images/parklandssliderimage5.webp"
import parklandssliderimage6 from "../../../assets/images/parklandssliderimage6.webp"
import parklandssliderimage7 from "../../../assets/images/parklandssliderimage7.webp"
import parklandssliderimage8 from "../../../assets/images/parklandssliderimage8.webp"
import parklandssliderimage9 from "../../../assets/images/parklandssliderimage9.webp"
import parklandssliderimage10 from "../../../assets/images/parklandssliderimage10.webp"
import parklandssliderimage11 from "../../../assets/images/parklandssliderimage11.webp"
import parklandssliderimage12 from "../../../assets/images/parklandssliderimage12.jpg"
import parklandssliderimage13 from "../../../assets/images/parklandssliderimage13.webp"
import parklandssliderimage14 from "../../../assets/images/parklandssliderimage14.jpg"

import quadrantssliderimage1 from "../../../assets/images/quadrantssliderimage1.jpg"
import quadrantssliderimage2 from "../../../assets/images/quadrantssliderimage2.webp"
import quadrantssliderimage3 from "../../../assets/images/quadrantssliderimage3.jpg"
import quadrantssliderimage4 from "../../../assets/images/quadrantssliderimage4.jpg"
import quadrantssliderimage5 from "../../../assets/images/quadrantssliderimage5.jpg"
import quadrantssliderimage6 from "../../../assets/images/quadrantssliderimage6.jpg"
import quadrantssliderimage7 from "../../../assets/images/quadrantssliderimage7.jpg"
import quadrantssliderimage8 from "../../../assets/images/quadrantssliderimage8.jpg"
import quadrantssliderimage9 from "../../../assets/images/quadrantssliderimage9.webp"
import quadrantssliderimage10 from "../../../assets/images/quadrantssliderimage10.jpg"
import quadrantssliderimage11 from "../../../assets/images/quadrantssliderimage11.webp"

import areapilisliderimage1 from "../../../assets/images/areapilisliderimage1.jpg"
import areapilisliderimage2 from "../../../assets/images/areapilisliderimage2.webp"
import areapilisliderimage3 from "../../../assets/images/areapilisliderimage3.webp"
import areapilisliderimage4 from "../../../assets/images/areapilisliderimage4.jpg"
import areapilisliderimage5 from "../../../assets/images/areapilisliderimage5.jpg"
import areapilisliderimage6 from "../../../assets/images/areapilisliderimage6.gif"
import areapilisliderimage7 from "../../../assets/images/areapilisliderimage7.webp"
import areapilisliderimage8 from "../../../assets/images/areapilisliderimage8.webp"
import areapilisliderimage9 from "../../../assets/images/areapilisliderimage9.webp"
import areapilisliderimage10 from "../../../assets/images/areapilisliderimage10.webp"
import areapilisliderimage11 from "../../../assets/images/areapilisliderimage11.webp"
import areapilisliderimage12 from "../../../assets/images/areapilisliderimage12.webp"
import areapilisliderimage13 from "../../../assets/images/areapilisliderimage13.webp"

import axissliderimage1 from "../../../assets/images/axissliderimage1.jpg"
import axissliderimage2 from "../../../assets/images/axissliderimage2.webp"
import axissliderimage3 from "../../../assets/images/axissliderimage3.webp"
import axissliderimage4 from "../../../assets/images/axissliderimage4.webp"
import axissliderimage5 from "../../../assets/images/axissliderimage5.webp"
import axissliderimage6 from "../../../assets/images/axissliderimage6.webp"
import axissliderimage7 from "../../../assets/images/axissliderimage7.webp"
import axissliderimage8 from "../../../assets/images/axissliderimage8.webp"
import axissliderimage9 from "../../../assets/images/axissliderimage9.webp"
import axissliderimage10 from "../../../assets/images/axissliderimage10.webp"
import axissliderimage11 from "../../../assets/images/axissliderimage11.webp"

import batteryparksliderimage1 from "../../../assets/images/batteryparksliderimage1.jpg"
import batteryparksliderimage2 from "../../../assets/images/batteryparksliderimage2.jpg"
import batteryparksliderimage3 from "../../../assets/images/batteryparksliderimage3.jpg"
import batteryparksliderimage4 from "../../../assets/images/batteryparksliderimage4.jpg"
import batteryparksliderimage5 from "../../../assets/images/batteryparksliderimage5.jpg"
import batteryparksliderimage6 from "../../../assets/images/batteryparksliderimage6.jpg"
import batteryparksliderimage7 from "../../../assets/images/batteryparksliderimage7.jpg"
import batteryparksliderimage8 from "../../../assets/images/batteryparksliderimage8.jpg"
import batteryparksliderimage9 from "../../../assets/images/batteryparksliderimage9.jpg"
import batteryparksliderimage10 from "../../../assets/images/batteryparksliderimage10.jpg"
import batteryparksliderimage11 from "../../../assets/images/batteryparksliderimage11.jpg"

import conradieparksliderimage1 from "../../../assets/images/conradieparksliderimage1.jpg"
import conradieparksliderimage2 from "../../../assets/images/conradieparksliderimage2.webp"
import conradieparksliderimage3 from "../../../assets/images/conradieparksliderimage3.jpg"
import conradieparksliderimage4 from "../../../assets/images/conradieparksliderimage4.jpg"
import conradieparksliderimage5 from "../../../assets/images/conradieparksliderimage5.webp"
import conradieparksliderimage6 from "../../../assets/images/conradieparksliderimage6.jpg"
import conradieparksliderimage7 from "../../../assets/images/conradieparksliderimage7.jpg"
import conradieparksliderimage8 from "../../../assets/images/conradieparksliderimage8.jpg"
import conradieparksliderimage9 from "../../../assets/images/conradieparksliderimage9.webp"
import conradieparksliderimage10 from "../../../assets/images/conradieparksliderimage10.jpg"
import conradieparksliderimage11 from "../../../assets/images/conradieparksliderimage11.webp"
import conradieparksliderimage12 from "../../../assets/images/conradieparksliderimage12.webp"
import conradieparksliderimage13 from "../../../assets/images/conradieparksliderimage13.webp"
import conradieparksliderimage14 from "../../../assets/images/conradieparksliderimage14.jpg"
import conradieparksliderimage15 from "../../../assets/images/conradieparksliderimage15.jpg"
import conradieparksliderimage16 from "../../../assets/images/conradieparksliderimage16.webp"
import conradieparksliderimage17 from "../../../assets/images/conradieparksliderimage17.jpg"
import conradieparksliderimage18 from "../../../assets/images/conradieparksliderimage18.webp"
import conradieparksliderimage19 from "../../../assets/images/conradieparksliderimage19.webp"

import norvalsliderimage1 from "../../../assets/images/norvalsliderimage1.webp"
import norvalsliderimage2 from "../../../assets/images/norvalsliderimage2.webp"
import norvalsliderimage3 from "../../../assets/images/norvalsliderimage3.webp"
import norvalsliderimage4 from "../../../assets/images/norvalsliderimage4.webp"
import norvalsliderimage5 from "../../../assets/images/norvalsliderimage5.webp"
import norvalsliderimage6 from "../../../assets/images/norvalsliderimage6.jpg"
import norvalsliderimage7 from "../../../assets/images/norvalsliderimage7.webp"
import norvalsliderimage8 from "../../../assets/images/norvalsliderimage8.gif"
import norvalsliderimage9 from "../../../assets/images/norvalsliderimage9.webp"
import norvalsliderimage10 from "../../../assets/images/norvalsliderimage10.jpg"
import norvalsliderimage11 from "../../../assets/images/norvalsliderimage11.webp"
import norvalsliderimage12 from "../../../assets/images/norvalsliderimage12.jpg"
import norvalsliderimage13 from "../../../assets/images/norvalsliderimage13.jpg"

import sableparksliderimage1 from "../../../assets/images/sableparksliderimage1.webp"
import sableparksliderimage2 from "../../../assets/images/sableparksliderimage2.webp"
import sableparksliderimage3 from "../../../assets/images/sableparksliderimage3.webp"
import sableparksliderimage4 from "../../../assets/images/sableparksliderimage4.webp"
import sableparksliderimage5 from "../../../assets/images/sableparksliderimage5.webp"
import sableparksliderimage6 from "../../../assets/images/sableparksliderimage6.webp"
import sableparksliderimage7 from "../../../assets/images/sableparksliderimage7.webp"
import sableparksliderimage8 from "../../../assets/images/sableparksliderimage8.webp"
import sableparksliderimage9 from "../../../assets/images/sableparksliderimage9.webp"
import sableparksliderimage10 from "../../../assets/images/sableparksliderimage10.jpg"
import sableparksliderimage11 from "../../../assets/images/sableparksliderimage11.jpg"

import waterwayhousesliderimage1 from "../../../assets/images/waterwayhousesliderimage1.jpg"
import waterwayhousesliderimage2 from "../../../assets/images/waterwayhousesliderimage2.webp"
import waterwayhousesliderimage3 from "../../../assets/images/waterwayhousesliderimage3.webp"
import waterwayhousesliderimage4 from "../../../assets/images/waterwayhousesliderimage4.jpg"
import waterwayhousesliderimage5 from "../../../assets/images/waterwayhousesliderimage5.webp"
import waterwayhousesliderimage6 from "../../../assets/images/waterwayhousesliderimage6.webp"
import waterwayhousesliderimage7 from "../../../assets/images/waterwayhousesliderimage7.webp"
import waterwayhousesliderimage8 from "../../../assets/images/waterwayhousesliderimage8.webp"
import waterwayhousesliderimage9 from "../../../assets/images/waterwayhousesliderimage9.webp"
import waterwayhousesliderimage10 from "../../../assets/images/waterwayhousesliderimage10.webp"
import waterwayhousesliderimage11 from "../../../assets/images/waterwayhousesliderimage11.webp"
import waterwayhousesliderimage12 from "../../../assets/images/waterwayhousesliderimage12.webp"
import waterwayhousesliderimage13 from "../../../assets/images/waterwayhousesliderimage13.webp"
import waterwayhousesliderimage14 from "../../../assets/images/waterwayhousesliderimage14.webp"

import baywestmallsliderimage1 from "../../../assets/images/baywestmallsliderimage1.webp"
import baywestmallsliderimage2 from "../../../assets/images/baywestmallsliderimage2.jpg"
import baywestmallsliderimage3 from "../../../assets/images/baywestmallsliderimage3.jpg"
import baywestmallsliderimage4 from "../../../assets/images/baywestmallsliderimage4.jpg"
import baywestmallsliderimage5 from "../../../assets/images/baywestmallsliderimage5.webp"
import baywestmallsliderimage6 from "../../../assets/images/baywestmallsliderimage6.jpg"

import bridgeparksliderimage1 from "../../../assets/images/bridgeparksliderimage1.jpg"
import bridgeparksliderimage2 from "../../../assets/images/bridgeparksliderimage2.webp"
import bridgeparksliderimage3 from "../../../assets/images/bridgeparksliderimage3.webp"
import bridgeparksliderimage4 from "../../../assets/images/bridgeparksliderimage4.webp"
import bridgeparksliderimage5 from "../../../assets/images/bridgeparksliderimage5.webp"
import bridgeparksliderimage6 from "../../../assets/images/bridgeparksliderimage6.webp"
import bridgeparksliderimage7 from "../../../assets/images/bridgeparksliderimage7.webp"
import bridgeparksliderimage8 from "../../../assets/images/bridgeparksliderimage8.webp"
import bridgeparksliderimage9 from "../../../assets/images/bridgeparksliderimage9.webp"
import bridgeparksliderimage10 from "../../../assets/images/bridgeparksliderimage10.webp"
import bridgeparksliderimage11 from "../../../assets/images/bridgeparksliderimage11.webp"
import bridgeparksliderimage12 from "../../../assets/images/bridgeparksliderimage12.webp"
import bridgeparksliderimage13 from "../../../assets/images/bridgeparksliderimage13.webp"
import bridgeparksliderimage14 from "../../../assets/images/bridgeparksliderimage14.webp"
import bridgeparksliderimage15 from "../../../assets/images/bridgeparksliderimage15.webp"
import bridgeparksliderimage16 from "../../../assets/images/bridgeparksliderimage16.webp"
import bridgeparksliderimage17 from "../../../assets/images/bridgeparksliderimage17.webp"
import bridgeparksliderimage18 from "../../../assets/images/bridgeparksliderimage18.webp"

import dainfernsliderimage1 from "../../../assets/images/dainfernsliderimage1.webp"
import dainfernsliderimage2 from "../../../assets/images/dainfernsliderimage2.webp"
import dainfernsliderimage3 from "../../../assets/images/dainfernsliderimage3.webp"
import dainfernsliderimage4 from "../../../assets/images/dainfernsliderimage4.webp"
import dainfernsliderimage5 from "../../../assets/images/dainfernsliderimage5.webp"
import dainfernsliderimage6 from "../../../assets/images/dainfernsliderimage6.webp"

import newtownsliderimage1 from "../../../assets/images/newtownsliderimage1.jpg"
import newtownsliderimage2 from "../../../assets/images/newtownsliderimage2.webp"
import newtownsliderimage3 from "../../../assets/images/newtownsliderimage3.jpg"
import newtownsliderimage4 from "../../../assets/images/newtownsliderimage4.webp"
import newtownsliderimage5 from "../../../assets/images/newtownsliderimage5.webp"
import newtownsliderimage6 from "../../../assets/images/newtownsliderimage6.jpg"
import newtownsliderimage7 from "../../../assets/images/newtownsliderimage7.webp"
import newtownsliderimage8 from "../../../assets/images/newtownsliderimage8.webp"
import newtownsliderimage9 from "../../../assets/images/newtownsliderimage9.webp"
import newtownsliderimage10 from "../../../assets/images/newtownsliderimage10.webp"
import newtownsliderimage11 from "../../../assets/images/newtownsliderimage11.webp"
import newtownsliderimage12 from "../../../assets/images/newtownsliderimage12.webp"
import newtownsliderimage13 from "../../../assets/images/newtownsliderimage13.webp"
import newtownsliderimage14 from "../../../assets/images/newtownsliderimage14.webp"
import newtownsliderimage15 from "../../../assets/images/newtownsliderimage15.webp"
import newtownsliderimage16 from "../../../assets/images/newtownsliderimage16.webp"

import oxfordparkssliderimage1 from "../../../assets/images/oxfordparkssliderimage1.jpg"
import oxfordparkssliderimage2 from "../../../assets/images/oxfordparkssliderimage2.jpg"
import oxfordparkssliderimage3 from "../../../assets/images/oxfordparkssliderimage3.jpg"
import oxfordparkssliderimage4 from "../../../assets/images/oxfordparkssliderimage4.jpg"
import oxfordparkssliderimage5 from "../../../assets/images/oxfordparkssliderimage5.webp"
import oxfordparkssliderimage6 from "../../../assets/images/oxfordparkssliderimage6.jpg"
import oxfordparkssliderimage7 from "../../../assets/images/oxfordparkssliderimage7.webp"
import oxfordparkssliderimage8 from "../../../assets/images/oxfordparkssliderimage8.webp"
import oxfordparkssliderimage9 from "../../../assets/images/oxfordparkssliderimage9.webp"
import oxfordparkssliderimage10 from "../../../assets/images/oxfordparkssliderimage10.webp"
import oxfordparkssliderimage11 from "../../../assets/images/oxfordparkssliderimage11.webp"
import oxfordparkssliderimage12 from "../../../assets/images/oxfordparkssliderimage12.webp"
import oxfordparkssliderimage13 from "../../../assets/images/oxfordparkssliderimage13.webp"

import portsidesliderimage1 from "../../../assets/images/portsidesliderimage1.webp"
import portsidesliderimage2 from "../../../assets/images/portsidesliderimage2.webp"
import portsidesliderimage3 from "../../../assets/images/portsidesliderimage3.webp"
import portsidesliderimage4 from "../../../assets/images/portsidesliderimage4.webp"
import portsidesliderimage5 from "../../../assets/images/portsidesliderimage5.webp"
import portsidesliderimage6 from "../../../assets/images/portsidesliderimage6.webp"
import portsidesliderimage7 from "../../../assets/images/portsidesliderimage7.webp"
import portsidesliderimage8 from "../../../assets/images/portsidesliderimage8.webp"
import portsidesliderimage9 from "../../../assets/images/portsidesliderimage9.webp"
import portsidesliderimage10 from "../../../assets/images/portsidesliderimage10.webp"
import portsidesliderimage11 from "../../../assets/images/portsidesliderimage11.webp"
import portsidesliderimage12 from "../../../assets/images/portsidesliderimage12.webp"

import drostdyhotelsliderimage1 from "../../../assets/images/drostdyhotelsliderimage1.jpg"
import drostdyhotelsliderimage2 from "../../../assets/images/drostdyhotelsliderimage2.webp"
import drostdyhotelsliderimage3 from "../../../assets/images/drostdyhotelsliderimage3.webp"
import drostdyhotelsliderimage4 from "../../../assets/images/drostdyhotelsliderimage4.jpg"
import drostdyhotelsliderimage5 from "../../../assets/images/drostdyhotelsliderimage5.jpg"
import drostdyhotelsliderimage6 from "../../../assets/images/drostdyhotelsliderimage6.jpg"
import drostdyhotelsliderimage7 from "../../../assets/images/drostdyhotelsliderimage7.webp"
import drostdyhotelsliderimage8 from "../../../assets/images/drostdyhotelsliderimage8.jpg"
import drostdyhotelsliderimage9 from "../../../assets/images/drostdyhotelsliderimage9.jpg"
import drostdyhotelsliderimage10 from "../../../assets/images/drostdyhotelsliderimage10.jpg"
import drostdyhotelsliderimage11 from "../../../assets/images/drostdyhotelsliderimage11.jpg"
import drostdyhotelsliderimage12 from "../../../assets/images/drostdyhotelsliderimage12.gif"
import drostdyhotelsliderimage13 from "../../../assets/images/drostdyhotelsliderimage13.jpg"
import drostdyhotelsliderimage14 from "../../../assets/images/drostdyhotelsliderimage14.webp"
import drostdyhotelsliderimage15 from "../../../assets/images/drostdyhotelsliderimage15.jpg"
import drostdyhotelsliderimage16 from "../../../assets/images/drostdyhotelsliderimage16.jpg"
import drostdyhotelsliderimage17 from "../../../assets/images/drostdyhotelsliderimage17.jpg"
import drostdyhotelsliderimage18 from "../../../assets/images/drostdyhotelsliderimage18.webp"
import drostdyhotelsliderimage19 from "../../../assets/images/drostdyhotelsliderimage19.webp"

import fabrikmasterplansliderimage1 from "../../../assets/images/fabrikmasterplansliderimage1.jpg"
import fabrikmasterplansliderimage2 from "../../../assets/images/fabrikmasterplansliderimage2.webp"
import fabrikmasterplansliderimage3 from "../../../assets/images/fabrikmasterplansliderimage3.webp"
import fabrikmasterplansliderimage4 from "../../../assets/images/fabrikmasterplansliderimage4.webp"
import fabrikmasterplansliderimage5 from "../../../assets/images/fabrikmasterplansliderimage5.webp"

import nieuwesteenbergsliderimage1 from "../../../assets/images/nieuwesteenbergsliderimage1.webp"
import nieuwesteenbergsliderimage2 from "../../../assets/images/nieuwesteenbergsliderimage2.webp"
import nieuwesteenbergsliderimage3 from "../../../assets/images/nieuwesteenbergsliderimage3.jpg"
import nieuwesteenbergsliderimage4 from "../../../assets/images/nieuwesteenbergsliderimage4.webp"
import nieuwesteenbergsliderimage5 from "../../../assets/images/nieuwesteenbergsliderimage5.jpg"
import nieuwesteenbergsliderimage6 from "../../../assets/images/nieuwesteenbergsliderimage6.webp"
import nieuwesteenbergsliderimage7 from "../../../assets/images/nieuwesteenbergsliderimage7.webp"
import nieuwesteenbergsliderimage8 from "../../../assets/images/nieuwesteenbergsliderimage8.webp"

import theshedssliderimage1 from "../../../assets/images/theshedssliderimage1.webp"
import theshedssliderimage2 from "../../../assets/images/theshedssliderimage2.webp"
import theshedssliderimage3 from "../../../assets/images/theshedssliderimage3.webp"
import theshedssliderimage4 from "../../../assets/images/theshedssliderimage4.jpg"
import theshedssliderimage5 from "../../../assets/images/theshedssliderimage5.webp"
import theshedssliderimage6 from "../../../assets/images/theshedssliderimage6.webp"
import theshedssliderimage7 from "../../../assets/images/theshedssliderimage7.webp"
import theshedssliderimage8 from "../../../assets/images/theshedssliderimage8.webp"
import theshedssliderimage9 from "../../../assets/images/theshedssliderimage9.webp"

import thefringesliderimage1 from "../../../assets/images/thefringesliderimage1.webp"
import thefringesliderimage2 from "../../../assets/images/thefringesliderimage2.jpg"
import thefringesliderimage3 from "../../../assets/images/thefringesliderimage3.jpg"
import thefringesliderimage4 from "../../../assets/images/thefringesliderimage4.jpg"
import thefringesliderimage5 from "../../../assets/images/thefringesliderimage5.webp"
import thefringesliderimage6 from "../../../assets/images/thefringesliderimage6.jpg"
import thefringesliderimage7 from "../../../assets/images/thefringesliderimage7.jpg"
import thefringesliderimage8 from "../../../assets/images/thefringesliderimage8.webp"
import thefringesliderimage9 from "../../../assets/images/thefringesliderimage9.jpg"
import thefringesliderimage10 from "../../../assets/images/thefringesliderimage10.webp"
import thefringesliderimage11 from "../../../assets/images/thefringesliderimage11.jpg"
import thefringesliderimage12 from "../../../assets/images/thefringesliderimage12.jpg"
import thefringesliderimage13 from "../../../assets/images/thefringesliderimage13.webp"
import thefringesliderimage14 from "../../../assets/images/thefringesliderimage14.webp"
import thefringesliderimage15 from "../../../assets/images/thefringesliderimage15.webp"
import thefringesliderimage16 from "../../../assets/images/thefringesliderimage16.webp"

import doubletreesliderimage1 from "../../../assets/images/doubletreesliderimage1.webp"
import doubletreesliderimage2 from "../../../assets/images/doubletreesliderimage2.webp"
import doubletreesliderimage3 from "../../../assets/images/doubletreesliderimage3.webp"
import doubletreesliderimage4 from "../../../assets/images/doubletreesliderimage4.webp"
import doubletreesliderimage5 from "../../../assets/images/doubletreesliderimage5.webp"
import doubletreesliderimage6 from "../../../assets/images/doubletreesliderimage6.webp"
import doubletreesliderimage7 from "../../../assets/images/doubletreesliderimage7.webp"
import doubletreesliderimage8 from "../../../assets/images/doubletreesliderimage8.webp"
import doubletreesliderimage9 from "../../../assets/images/doubletreesliderimage9.webp"

import eikestadmallsliderimage1 from "../../../assets/images/eikestadmallsliderimage1.webp"
import eikestadmallsliderimage2 from "../../../assets/images/eikestadmallsliderimage2.jpg"
import eikestadmallsliderimage3 from "../../../assets/images/eikestadmallsliderimage3.webp"
import eikestadmallsliderimage4 from "../../../assets/images/eikestadmallsliderimage4.webp"
import eikestadmallsliderimage5 from "../../../assets/images/eikestadmallsliderimage5.jpg"
import eikestadmallsliderimage6 from "../../../assets/images/eikestadmallsliderimage6.webp"

import kempsinkisliderimage1 from "../../../assets/images/kempsinkisliderimage1.webp"
import kempsinkisliderimage2 from "../../../assets/images/kempsinkisliderimage2.jpg"
import kempsinkisliderimage3 from "../../../assets/images/kempsinkisliderimage3.jpg"
import kempsinkisliderimage4 from "../../../assets/images/kempsinkisliderimage4.jpg"
import kempsinkisliderimage5 from "../../../assets/images/kempsinkisliderimage5.jpg"
import kempsinkisliderimage6 from "../../../assets/images/kempsinkisliderimage6.jpg"

import melrosearchsliderimage1 from "../../../assets/images/melrosearchsliderimage1.webp"
import melrosearchsliderimage2 from "../../../assets/images/melrosearchsliderimage2.jpg"
import melrosearchsliderimage3 from "../../../assets/images/melrosearchsliderimage3.webp"
import melrosearchsliderimage4 from "../../../assets/images/melrosearchsliderimage4.jpg"
import melrosearchsliderimage5 from "../../../assets/images/melrosearchsliderimage5.jpg"
import melrosearchsliderimage6 from "../../../assets/images/melrosearchsliderimage6.webp"
import melrosearchsliderimage7 from "../../../assets/images/melrosearchsliderimage7.jpg"
import melrosearchsliderimage8 from "../../../assets/images/melrosearchsliderimage8.jpg"
import melrosearchsliderimage9 from "../../../assets/images/melrosearchsliderimage9.jpg"
import melrosearchsliderimage10 from "../../../assets/images/melrosearchsliderimage10.webp"
import melrosearchsliderimage11 from "../../../assets/images/melrosearchsliderimage11.webp"
import melrosearchsliderimage12 from "../../../assets/images/melrosearchsliderimage12.webp"

import tajpalacehotelsliderimage1 from "../../../assets/images/tajpalacehotelsliderimage1.webp"
import tajpalacehotelsliderimage2 from "../../../assets/images/tajpalacehotelsliderimage2.jpg"
import tajpalacehotelsliderimage3 from "../../../assets/images/tajpalacehotelsliderimage3.jpg"
import tajpalacehotelsliderimage4 from "../../../assets/images/tajpalacehotelsliderimage4.jpg"
import tajpalacehotelsliderimage5 from "../../../assets/images/tajpalacehotelsliderimage5.jpg"
import tajpalacehotelsliderimage6 from "../../../assets/images/tajpalacehotelsliderimage6.jpg"
import tajpalacehotelsliderimage7 from "../../../assets/images/tajpalacehotelsliderimage7.webp"
import tajpalacehotelsliderimage8 from "../../../assets/images/tajpalacehotelsliderimage8.webp"
import tajpalacehotelsliderimage9 from "../../../assets/images/tajpalacehotelsliderimage9.webp"
import tajpalacehotelsliderimage10 from "../../../assets/images/tajpalacehotelsliderimage10.webp"
import tajpalacehotelsliderimage11 from "../../../assets/images/tajpalacehotelsliderimage11.webp"
import tajpalacehotelsliderimage12 from "../../../assets/images/tajpalacehotelsliderimage12.jpg"
import tajpalacehotelsliderimage13 from "../../../assets/images/tajpalacehotelsliderimage13.jpg"

import uwclifesliderimage1 from "../../../assets/images/uwclifesliderimage1.webp"
import uwclifesliderimage2 from "../../../assets/images/uwclifesliderimage2.jpg"
import uwclifesliderimage3 from "../../../assets/images/uwclifesliderimage3.jpg"
import uwclifesliderimage4 from "../../../assets/images/uwclifesliderimage4.jpg"
import uwclifesliderimage5 from "../../../assets/images/uwclifesliderimage5.jpg"
import uwclifesliderimage6 from "../../../assets/images/uwclifesliderimage6.jpg"
import uwclifesliderimage7 from "../../../assets/images/uwclifesliderimage7.webp"
import uwclifesliderimage8 from "../../../assets/images/uwclifesliderimage8.jpg"

import wangarimathaisliderimage1 from "../../../assets/images/wangarimathaisliderimage1.webp"
import wangarimathaisliderimage2 from "../../../assets/images/wangarimathaisliderimage2.jpg"
import wangarimathaisliderimage3 from "../../../assets/images/wangarimathaisliderimage3.webp"
import wangarimathaisliderimage4 from "../../../assets/images/wangarimathaisliderimage4.webp"
import wangarimathaisliderimage5 from "../../../assets/images/wangarimathaisliderimage5.webp"
import wangarimathaisliderimage6 from "../../../assets/images/wangarimathaisliderimage6.webp"
import wangarimathaisliderimage7 from "../../../assets/images/wangarimathaisliderimage7.webp"
import wangarimathaisliderimage8 from "../../../assets/images/wangarimathaisliderimage8.webp"
import wangarimathaisliderimage9 from "../../../assets/images/wangarimathaisliderimage9.jpg"
import wangarimathaisliderimage10 from "../../../assets/images/wangarimathaisliderimage10.webp"
import wangarimathaisliderimage11 from "../../../assets/images/wangarimathaisliderimage11.webp"
import wangarimathaisliderimage12 from "../../../assets/images/wangarimathaisliderimage12.webp"

import ahmedbabasliderimage1 from "../../../assets/images/ahmedbabasliderimage1.webp"
import ahmedbabasliderimage2 from "../../../assets/images/ahmedbabasliderimage2.jpg"
import ahmedbabasliderimage3 from "../../../assets/images/ahmedbabasliderimage3.webp"
import ahmedbabasliderimage4 from "../../../assets/images/ahmedbabasliderimage4.jpg"
import ahmedbabasliderimage5 from "../../../assets/images/ahmedbabasliderimage5.webp"
import ahmedbabasliderimage6 from "../../../assets/images/ahmedbabasliderimage6.webp"
import ahmedbabasliderimage7 from "../../../assets/images/ahmedbabasliderimage7.webp"
import ahmedbabasliderimage8 from "../../../assets/images/ahmedbabasliderimage8.webp"
import ahmedbabasliderimage9 from "../../../assets/images/ahmedbabasliderimage9.webp"
import ahmedbabasliderimage10 from "../../../assets/images/ahmedbabasliderimage10.jpg"
import ahmedbabasliderimage11 from "../../../assets/images/ahmedbabasliderimage11.webp"
import ahmedbabasliderimage12 from "../../../assets/images/ahmedbabasliderimage12.webp"
import ahmedbabasliderimage13 from "../../../assets/images/ahmedbabasliderimage13.jpg"
import ahmedbabasliderimage14 from "../../../assets/images/ahmedbabasliderimage14.webp"
import ahmedbabasliderimage15 from "../../../assets/images/ahmedbabasliderimage15.webp"

import delairegraffwinerysliderimage1 from "../../../assets/images/delairegraffwinerysliderimage1.jpg"
import delairegraffwinerysliderimage2 from "../../../assets/images/delairegraffwinerysliderimage2.jpg"
import delairegraffwinerysliderimage3 from "../../../assets/images/delairegraffwinerysliderimage3.webp"
import delairegraffwinerysliderimage4 from "../../../assets/images/delairegraffwinerysliderimage4.webp"
import delairegraffwinerysliderimage5 from "../../../assets/images/delairegraffwinerysliderimage5.jpg"
import delairegraffwinerysliderimage6 from "../../../assets/images/delairegraffwinerysliderimage6.jpg"
import delairegraffwinerysliderimage7 from "../../../assets/images/delairegraffwinerysliderimage7.webp"
import delairegraffwinerysliderimage8 from "../../../assets/images/delairegraffwinerysliderimage8.jpg"
import delairegraffwinerysliderimage9 from "../../../assets/images/delairegraffwinerysliderimage9.webp"
import delairegraffwinerysliderimage10 from "../../../assets/images/delairegraffwinerysliderimage10.jpg"
import delairegraffwinerysliderimage11 from "../../../assets/images/delairegraffwinerysliderimage11.jpg"
import delairegraffwinerysliderimage12 from "../../../assets/images/delairegraffwinerysliderimage12.webp"
import delairegraffwinerysliderimage13 from "../../../assets/images/delairegraffwinerysliderimage13.jpg"
import delairegraffwinerysliderimage14 from "../../../assets/images/delairegraffwinerysliderimage14.jpg"
import delairegraffwinerysliderimage15 from "../../../assets/images/delairegraffwinerysliderimage15.jpg"
import delairegraffwinerysliderimage16 from "../../../assets/images/delairegraffwinerysliderimage16.jpg"
import delairegraffwinerysliderimage17 from "../../../assets/images/delairegraffwinerysliderimage17.webp"
import delairegraffwinerysliderimage18 from "../../../assets/images/delairegraffwinerysliderimage18.webp"
import delairegraffwinerysliderimage19 from "../../../assets/images/delairegraffwinerysliderimage19.webp"
import delairegraffwinerysliderimage20 from "../../../assets/images/delairegraffwinerysliderimage20.webp"

import theboulevardslideimage1 from "../../../assets/images/theboulevardslideimage1.webp"
import theboulevardslideimage2 from "../../../assets/images/theboulevardslideimage2.jpg"
import theboulevardslideimage3 from "../../../assets/images/theboulevardslideimage3.jpg"
import theboulevardslideimage4 from "../../../assets/images/theboulevardslideimage4.jpg"
import theboulevardslideimage5 from "../../../assets/images/theboulevardslideimage5.webp"
import theboulevardslideimage6 from "../../../assets/images/theboulevardslideimage6.webp"
import theboulevardslideimage7 from "../../../assets/images/theboulevardslideimage7.webp"

import thecrystalsliderimage1 from "../../../assets/images/thecrystalsliderimage1.webp"
import thecrystalsliderimage2 from "../../../assets/images/thecrystalsliderimage2.jpg"
import thecrystalsliderimage3 from "../../../assets/images/thecrystalsliderimage3.jpg"
import thecrystalsliderimage4 from "../../../assets/images/thecrystalsliderimage4.jpg"
import thecrystalsliderimage5 from "../../../assets/images/thecrystalsliderimage5.jpg"

import mandelarhodesplacesliderimage1 from "../../../assets/images/mandelarhodesplacesliderimage1.webp"
import mandelarhodesplacesliderimage2 from "../../../assets/images/mandelarhodesplacesliderimage2.webp"
import mandelarhodesplacesliderimage3 from "../../../assets/images/mandelarhodesplacesliderimage3.jpg"
import mandelarhodesplacesliderimage4 from "../../../assets/images/mandelarhodesplacesliderimage4.webp"
import mandelarhodesplacesliderimage5 from "../../../assets/images/mandelarhodesplacesliderimage5.jpg"
import mandelarhodesplacesliderimage6 from "../../../assets/images/mandelarhodesplacesliderimage6.jpg"
import mandelarhodesplacesliderimage7 from "../../../assets/images/mandelarhodesplacesliderimage7.webp"

import lavelasliderimage1 from "../../../assets/images/lavelasliderimage1.webp"
import lavelasliderimage2 from "../../../assets/images/lavelasliderimage2.webp"
import lavelasliderimage3 from "../../../assets/images/lavelasliderimage3.jpg"
import lavelasliderimage4 from "../../../assets/images/lavelasliderimage4.webp"
import lavelasliderimage5 from "../../../assets/images/lavelasliderimage5.webp"
import lavelasliderimage6 from "../../../assets/images/lavelasliderimage6.webp"
import lavelasliderimage7 from "../../../assets/images/lavelasliderimage7.webp"
import lavelasliderimage8 from "../../../assets/images/lavelasliderimage8.webp"
import lavelasliderimage9 from "../../../assets/images/lavelasliderimage9.webp"
import lavelasliderimage10 from "../../../assets/images/lavelasliderimage10.webp"

import uctchemicalsliderimage1 from "../../../assets/images/uctchemicalsliderimage1.webp"
import uctchemicalsliderimage2 from "../../../assets/images/uctchemicalsliderimage2.jpg"
import uctchemicalsliderimage3 from "../../../assets/images/uctchemicalsliderimage3.jpg"
import uctchemicalsliderimage4 from "../../../assets/images/uctchemicalsliderimage4.jpg"
import uctchemicalsliderimage5 from "../../../assets/images/uctchemicalsliderimage5.jpg"
import uctchemicalsliderimage6 from "../../../assets/images/uctchemicalsliderimage6.jpg"
import uctchemicalsliderimage7 from "../../../assets/images/uctchemicalsliderimage7.jpg"
import uctchemicalsliderimage8 from "../../../assets/images/uctchemicalsliderimage8.webp"
import uctchemicalsliderimage9 from "../../../assets/images/uctchemicalsliderimage9.webp"
import uctchemicalsliderimage10 from "../../../assets/images/uctchemicalsliderimage10.jpg"
import uctchemicalsliderimage11 from "../../../assets/images/uctchemicalsliderimage11.jpg"

import lagunapalacehotelsliderimage1 from "../../../assets/images/lagunapalacehotelsliderimage1.webp"
import lagunapalacehotelsliderimage2 from "../../../assets/images/lagunapalacehotelsliderimage2.webp"
import lagunapalacehotelsliderimage3 from "../../../assets/images/lagunapalacehotelsliderimage3.webp"
import lagunapalacehotelsliderimage4 from "../../../assets/images/lagunapalacehotelsliderimage4.webp"
import lagunapalacehotelsliderimage5 from "../../../assets/images/lagunapalacehotelsliderimage5.webp"
import lagunapalacehotelsliderimage6 from "../../../assets/images/lagunapalacehotelsliderimage6.webp"
import lagunapalacehotelsliderimage7 from "../../../assets/images/lagunapalacehotelsliderimage7.webp"
import lagunapalacehotelsliderimage8 from "../../../assets/images/lagunapalacehotelsliderimage8.webp"


const projects = [
    {
        number: '01',
        title: 'Al Marjan',
        location: 'Al Marjan Island, UAE',
        year: '2028',
        image: projectsimage1,
        data: [
            almarjanimage1,
            almarjanimage2,
            almarjanimage3,
            almarjanimage4,
            almarjanimage5,
        ],
        pagedata: [
            {
                Pagetitle: "Al Marjan",
                pagelocation: "Al Marjan Island, UAE",
                paragraphs: [
                    "Collaboration is at the heart of our work. We're proud to be working in association with U+A on a luxury residential development currently underway in the United Arab Emirates, located on Al Marjan Island in Ras Al Khaimah. Our team worked closely with U+A on the design philosophy, coordination and building information modelling (BIM) to create a luxurious yet functional living environment that harmonises with its beachfront location.",
                    "The Al Marjan Beach Club is a prestigious residential development nestled on Al Marjan Island in Ras Al Khaimah. Conveniently located just a 45-minute drive away from both Dubai and Sharjah International Airports, this exclusive enclave offers a luxurious lifestyle, featuring a total of 2000 residential and branded apartments.",
                    "With the breathtaking Arabian Peninsula as its backdrop, the development places a strong emphasis on family-oriented waterfront leisure, complemented by a robust wellness theme. Along the charming promenade, a delightful array of food and beverage options adds to the island's unique allure, solidifying its position as the ultimate destination for those seeking an upscale lifestyle by the water's edge."
                ],
                method: "Binyan + Red Vertex - Renders",
                client: "Aldar Properties",
                status: "on site",
                year: "2028",
                services: [
                    "architecture",
                    "urban design"
                ],
                tags: [
                    "mixed-use",
                    "residential",
                    "hospitality"
                ],
                location: "https://maps.app.goo.gl/HLjRCMfL1BDo9k1KA",
                sliderdata: [
                    {
                        image: almarjansliderimage1,
                        title: "red vertex - render",
                        number: "1"
                    },
                    {
                        image: almarjansliderimage2,
                        title: "binyan - renders",
                        number: "2"
                    },
                    {
                        image: almarjansliderimage3,
                        title: "",
                        number: "3"
                    },
                    {
                        image: almarjansliderimage4,
                        title: "",
                        number: "4"
                    },
                    {
                        image: almarjansliderimage5,
                        title: "",
                        number: "5"
                    },
                    {
                        image: almarjansliderimage6,
                        title: "",
                        number: "6"
                    },
                    {
                        image: almarjansliderimage7,
                        title: "",
                        number: "7"
                    },
                    {
                        image: almarjansliderimage8,
                        title: "red vertex - renders",
                        number: "8"
                    },
                    {
                        image: almarjansliderimage9,
                        title: "",
                        number: "9"
                    },
                    {
                        image: canalplazasliderimage1,
                        title: "Canal Plaza",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '02',
        title: 'Canal Plaza',
        location: 'Cape Town, South Africa',
        year: '2027',
        image: projectsimage2,
        data: [],
        pagedata: [
            {
                Pagetitle: "Canal Plaza",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "The brief for Canal Plaza was to design a commercially viable office building on a green field site, located at the northern end of Heron Close, Century City, a vibrant urban centre just outside Cape Town. The development is the latest of several we have previously delivered in the area. Designed for Abland Property Developers, it is a 10,816m² commercial office development. The five-storey structure comprises offices and retail units, with basement and podium car parking.",
                    "The development overlooks the serene Intaka Island, an award-winning 16-hectare wetland and bird sanctuary that hosts 177 species of indigenous fynbos plants and 120 bird species. The position adjacent to the wetland reserve of Intaka Island makes the location an attractive one for commercial tenants.",
                    "The accommodation in the five-storey structure is arranged in an H-shaped plan with a central core. The wings of the “H” splay to the south to reflect the geometry of the site and to receive visitors from Heron Close. The western wing is partially elevated from the ground to form an understorey for visitor parking and to allow for visual and pedestrian permeability. Here, a small retail component has been integrated to service office workers and pedestrians passing on the north-south route along the canal edge.",
                    "The planning and servicing of the commercial office space has been strategically designed to be adaptable and versatile. This means its floorplates can accommodate several tenants of various sizes. This flexibility will support the development’s long-term economic sustainability, as the space can respond to the dynamic workplace needs of future tenants. Accessible external terraces have been provided on the west and eastern edges of the site. Provision has been made on the roof for access to amenities and photovoltaic panels.",
                    "The building is designed to minimise energy use and enhance thermal comfort with the goal of achieving a Green Building Council South Africa (GBCSA) 4-star rating as a minimum. It is a welcome addition to the Century City precinct, which has in recent years been transformed into a sophisticated hub, attracting a cross-section of local and international investors, global corporates, residents and visitors. It’s one of several buildings we’ve designed in Century City. Visit the others at Sable Park, Bridge Park, Axis, Sable Corner and Canal Walk."
                ],
                method: "",
                client: "Abland Property Developers",
                status: "on site",
                year: "2027",
                services: ["architecture"],
                tags: [
                    "office",
                    "retail"
                ],
                location: "https://maps.app.goo.gl/7pRD5yys2mbrwEK97",
                sliderdata: [
                    {
                        image: canalplazasliderimage1,
                        title: "iniitial illustrations - Heron Close",
                        number: "1"
                    },
                    {
                        image: canalplazasliderimage2,
                        title: "view from canal",
                        number: "2"
                    },
                    {
                        image: canalplazasliderimage3,
                        title: "",
                        number: "3"
                    },
                    {
                        image: canalplazasliderimage4,
                        title: "",
                        number: "4"
                    },
                    {
                        image: canalplazasliderimage5,
                        title: "early aerial view",
                        number: "5"
                    },
                    {
                        image: olympussliderimage1,
                        title: "Olympus Sandton",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '03',
        title: 'Olympus Sandton',
        location: 'Johannesburg, South Africa',
        year: '2027',
        image: projectsimage3,
        data: [
            olympusimage1,
            olympusimage2
        ],
        pagedata: [
            {
                Pagetitle: "Olympus Sandton",
                pagelocation: "Johannesburg, South Africa",
                paragraphs: [
                    "Olympus Sandton stands proud on the corner of Empire Place and Rivonia Road in Johannesburg. The design was developed from an initial concept created by ClarkeHopkinsClarke Architects for co-developers Tricolt and Growthpoint Properties. The clients sought to create a development that emphasises high comfort standards, expressing the pinnacle of luxury living while contributing to Sandton’s urban landscape.",
                    "The scheme was conceived as an elevated experience. The development features alternating curved geometric floorplates, resulting in a visually dynamic silhouette on the city’s skyline. It is a true gateway development, with its unique sculptural form and striking staggered wraparound façade. The mix of executive suites, in one-, two- and three-bedroom apartment configurations, along with penthouses and duplex apartments on upper levels, enable smaller lock-up-and-go living, or full-time immersion in an executive environment to suit individual needs. Apartment layouts can be adapted to the diverse needs of buyers, and the location offers easy access to public transport and a vibrant neighbourhood.",
                    "Beyond introducing a distinctive lifestyle, Olympus promotes the growth of mixed-use development in Africa's most affluent square mile. A grand sculptural staircase connects the building with high-end retail amenities at the street-level entrance. The lush green podium, with leisure facilities and high-end signature restaurant is the jewel in the Olympus crown. A luxurious sky bar presents panoramic views of the city’s expansive green canopy below.",
                    "The design features two striking towers named Athena and Apollo, inspired by the giants of ancient Greek mythology. Its architectural language represents contemporary sophistication, designed to resonate with the aspirations of an exceptionally discerning clientele."
                ],
                method: "",
                client: "Tricolt and Growthpoint Properties",
                status: "design development",
                year: "2027",
                services: ["architecture"],
                tags: [
                    "mixed-use",
                    "residential",
                    "retail"
                ],
                location: "https://maps.app.goo.gl/1nKCAFY5WpLJkTHJ6",
                sliderdata: [
                    {
                        image: olympussliderimage1,
                        title: "initial illustrations",
                        number: "1"
                    },
                    {
                        image: olympussliderimage2,
                        title: "",
                        number: "2"
                    },
                    {
                        image: theparadigmsliderimage1,
                        title: "The Paradigm",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '04',
        title: 'The Paradigm',
        location: 'Cape Town, South Africa',
        year: '2027',
        image: projectsimage4,
        data: [
            paradigmimage1,
            paradigmimage2,
            paradigmimage3
        ],
        pagedata: [
            {
                Pagetitle: "The Paradigm",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "The Paradigm is a premium mixed-use residential development in the heart of the Cape Town CBD.  Vantage Property and Tiber Construction appointed dhk as project architects to take the project forward, based on the original massing concept approval by Fabian Architects. dhk Interior Design created the interior designs throughout the commercial and residential spaces in the building including interior design packages for buyers to select with their purchase.",
                    "The client acquired two adjacent sites along Shortmarket Street, with a view to developing a combined scheme incorporating reworked retail level design and façades, revised façades of the residential levels and an amended SDP to accommodate design improvements. The clients also needed a compelling vision for the interiors of The Paradigm.",
                    "Due to the site’s gradient, the street-level frontages are activated on all three levels with retail units and restaurants, creating a human-scale sense of place for passers-by. The building’s distinctive façades on Buitengracht, Longmarket, Shortmarket and Rose Streets each have a unique character that respond to the facing context. On Buitengracht, the building reflects the tall buildings along Buitengracht and the CBD skyline to the east, while the building steps down in response to the lower-scale of Rose Street.",
                    "Each apartment benefits from panoramic views of the City Bowl, Cape Town harbour, Signal Hilland Table Mountain. The Paradigm also comprises business and luxury lifestyle offerings, including retail, restaurants, shared co-working spaces and 233apartments ranging from studio units, and one-, two-, and three-bedroom configurations, and large penthouse units.",
                    "The Paradigm also features a new publicly accessible courtyard facing Shortmarket Street and up to Rose Street, which enables a connection through the site to Longmarket Street. New retail stores and restaurants line this new space, offering moments of connection, a chance to linger and a place for visitors and residents to meet and greet. Secure parking, swimming pool, and rooftop lounge offers residents a chance to live, work and play in inner-city Cape Town style.",
                    "The interior design introduces a neutral palette and light spaces in a calm, elegant combination, contrasted with the building’s complex geometric architecture and the busy city outside. The curated furniture pack offers buyers a range of bespoke furniture to complement the sophisticated atmosphere of The Paradigm’s interior spaces, making it easy to curate their own spaces from the moment they move in."
                ],
                method: "Visoo - Renders",
                client: "Vantage Property + Tiber Construction",
                status: "on site",
                year: "2202728",
                services: ["architecture"],
                tags: [
                    "mixed-use",
                    "residential",
                    "retail",
                    "office",
                ],
                location: "https://maps.app.goo.gl/XhLPffDwZgc4dQ3J8",
                sliderdata: [
                    {
                        image: theparadigmsliderimage1,
                        title: "The Paradigm",
                        number: "1"
                    },
                    {
                        image: theparadigmsliderimage2,
                        title: "",
                        number: "2"
                    },
                    {
                        image: theparadigmsliderimage3,
                        title: "view from buitengracht street",
                        number: "3"
                    },
                    {
                        image: theparadigmsliderimage4,
                        title: "",
                        number: "4"
                    },
                    {
                        image: theparadigmsliderimage5,
                        title: "view from rose street",
                        number: "5"
                    },
                    {
                        image: theparadigmsliderimage6,
                        title: "dhki - first floor bar + reastaurant",
                        number: "6"
                    },
                    {
                        image: theparadigmsliderimage7,
                        title: "dhki - ground floor restaurant + retail space",
                        number: "7"
                    },
                    {
                        image: theparadigmsliderimage8,
                        title: "dhki - offices",
                        number: "8"
                    },
                    {
                        image: theparadigmsliderimage9,
                        title: "dhki - three bedroom apartment",
                        number: "9"
                    },
                    {
                        image: theparadigmsliderimage10,
                        title: "",
                        number: "10"
                    },
                    {
                        image: theparadigmsliderimage11,
                        title: "dhki - one bedroom apartment",
                        number: "11"
                    },
                    {
                        image: theparadigmsliderimage12,
                        title: "dhki - studio apartment",
                        number: "12"
                    },
                    {
                        image: theparadigmsliderimage13,
                        title: "dhki - penthouse",
                        number: "13"
                    },
                    {
                        image: theparadigmsliderimage14,
                        title: "",
                        number: "14"
                    },
                    {
                        image: theparadigmsliderimage15,
                        title: "visoo - renders",
                        number: "15"
                    },
                    {
                        image: thesignaturesliderimage1,
                        title: "The Signature",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '05',
        title: 'The Signature',
        location: 'Mont Choisy, Mauritius',
        year: '2027',
        image: projectsimage5,
        data: [
            signatureimage1,
            signatureimage2,
            signatureimage3,
            signatureimage4,
            signatureimage5
        ],
        pagedata: [
            {
                Pagetitle: "The Signature",
                pagelocation: "Mont Choisy, Mauritius",
                paragraphs: [
                    "The Signature is a 24 000m² mixed-use development in Grand Baie, Mauritius, set within the Mont Choisy smart city. The challenge was to design a building of dramatic presence in a prominent position without detracting from future neighbouring developments, while also balancing the need to acknowledge Mont Choisy’s layered heritage.",
                    "Designed for the Mont Choisy Group, the scheme comprises 95 apartments, retail space, offices and basement parking. The public realm approach supports a lively, pedestrian-friendly environment with permeable routes and a central courtyard filled with greenery.",
                    "The building's architecture features slender edges, soft curves and distinctive rose-pink accents that add warmth to its tropical aesthetic. Cantilevered apartment overhangs provide shade over the ground-floor retail, while sliding shutters and fixed screens improve energy efficiency. Interiors designed by dhk Interior Design combine luxury with lifestyle, marking a sophisticated contribution to Mont Choisy's vision."
                ],
                method: "Renderby - Renders",
                client: "Mont Choisy Group",
                status: "on site",
                year: "2027",
                services: [
                    "architecture",
                    "urban design",
                    "interior design"
                ],
                tags: [
                    "mixed-use",
                    "hospitality",
                    "office"
                ],
                location: "https://maps.app.goo.gl/eo32rrd9MQpdURux8",
                sliderdata: [
                    {
                        image: thesignaturesliderimage1,
                        title: "dhki - bedroom option",
                        number: "1"
                    },
                    {
                        image: thesignaturesliderimage2,
                        title: "dhki - penthouse view",
                        number: "2"
                    },
                    {
                        image: thesignaturesliderimage3,
                        title: "dhki - bedroom option",
                        number: "3"
                    },
                    {
                        image: thesignaturesliderimage4,
                        title: "dhki penthouse views",
                        number: "4"
                    },
                    {
                        image: thesignaturesliderimage5,
                        title: "",
                        number: "5"
                    },
                    {
                        image: thesignaturesliderimage6,
                        title: "",
                        number: "6"
                    },
                    {
                        image: thesignaturesliderimage7,
                        title: "street facing commercial",
                        number: "7"
                    },
                    {
                        image: thesignaturesliderimage8,
                        title: "",
                        number: "8"
                    },
                    {
                        image: thesignaturesliderimage9,
                        title: "renderby - renders",
                        number: "9"
                    },
                    {
                        image: lionsheadsliderimage1,
                        title: "Lions Head at Conradie Park",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '06',
        title: 'Lions Head at Conradie Park',
        location: 'Cape Town, South Africa',
        year: '2026',
        image: projectsimage6,
        data: [
            lionsheadimage1,
            lionsheadimage2,
            lionsheadimage3,
            lionsheadimage4
        ],
        pagedata: [
            {
                Pagetitle: "Lions Head at Conradie Park",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "Designed in association with Jakupa Architects and Urban Designers, for developers Concor, Lions Head is a new addition to the award-winning Conradie Park mixed-use development near Pinelands, Cape Town.",
                    "The new building is one of four mixed-tenure residential buildings and will feature a mix of residential accommodation over a neighbourhood convenience shopping centre, alongside office space and a gym. The ground floor retail complex will be anchored by a major supermarket, with other stores surrounding to cater to the daily needs of residents and the wider neighbourhood. The building is due for completion during 2026."
                ],
                method: "",
                client: "Concor",
                status: "on site",
                year: "2026",
                services: [
                    "urban design",
                    "architecture"
                ],
                tags: [
                    "retail",
                    "mixed-use",
                    "residential"
                ],
                location: "https://maps.app.goo.gl/uUQ46gm3xy4TsgC7A",
                sliderdata: [
                    {
                        image: lionsheadsliderimage1,
                        title: "Lions Head at Conradie Park",
                        number: "1"
                    },
                    {
                        image: lionsheadsliderimage2,
                        title: "view towards devil's peak",
                        number: "2"
                    },
                    {
                        image: lionsheadsliderimage3,
                        title: "urban scheme",
                        number: "3"
                    },
                    {
                        image: lionsheadsliderimage4,
                        title: "apartment types",
                        number: "4"
                    },
                    {
                        image: lionsheadsliderimage5,
                        title: "urban scheme",
                        number: "5"
                    },
                    {
                        image: seafrontestatesliderimage1,
                        title: "Seafront Estate",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '07',
        title: 'Seafront Estate',
        location: 'Roche Caiman, Seychelles',
        year: '2026',
        image: projectsimage7,
        data: [
            seafrontimage1,
            seafrontimage2,
            seafrontimage3
        ],
        pagedata: [
            {
                Pagetitle: "Seafront Estate",
                pagelocation: "Roche Caiman, Seychelles",
                paragraphs: [
                    "Designed for Seafront Development, Seafront Estate brings together multiple uses that offer various facilities forresidents. This mixed-use approach is a first on the island of the Seychelles,where hospitality is the predominant development form. The scheme includes a120-room hotel, 68residential apartments, a sea-facing pavilion, retail and office spaces and conference facilities, as well as the first private hospital in the country.",
                    "The marine and seafront setting strongly influenced the design, which comprises two distinct typologies of a rectilinear form on the land side and a more curvilinear style on the ocean- and marina-facing side. However, a common materials palette connects and unifies the two."
                ],
                method: "Liaison - Renders",
                client: "Seafront Development",
                status: "on site",
                year: "2026",
                services: ["architecture"],
                tags: [
                    "hospitality",
                    "residential",
                    "retail",
                    "office"
                ],
                location: "https://maps.app.goo.gl/g7KsBBkgjuu9htvo6",
                sliderdata: [
                    {
                        image: seafrontestatesliderimage1,
                        title: "Seafront Estate",
                        number: "1"
                    },
                    {
                        image: seafrontestatesliderimage2,
                        title: "",
                        number: "2"
                    },
                    {
                        image: seafrontestatesliderimage3,
                        title: "view from terrace",
                        number: "3"
                    },
                    {
                        image: seafrontestatesliderimage4,
                        title: "",
                        number: "4"
                    },
                    {
                        image: seafrontestatesliderimage5,
                        title: "",
                        number: "5"
                    },
                    {
                        image: seafrontestatesliderimage6,
                        title: "",
                        number: "6"
                    },
                    {
                        image: seafrontestatesliderimage7,
                        title: "liason - renders",
                        number: "7"
                    },
                    {
                        image: brookfieldroyalsliderimage1,
                        title: "Brookfield at Royal",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '08',
        title: 'Brookfield at Royal',
        location: 'Johannesburg, South Africa',
        year: '2025',
        image: projectsimage8,
        data: [
            brookfieldimage1,
            brookfieldimage2,
            brookfieldimage3
        ],
        pagedata: [
            {
                Pagetitle: "Brookfield at Royal",
                pagelocation: "Johannesburg, South Africa",
                paragraphs: [
                    "The brief by Tricolt for Brookfield at Royal was to conceptualise a luxurious residential experience that bridges the gap between the past and present. The result is a high-end estate that represents the true value of sophisticated design in urban housing. When complete by the end of 2025, the development will feature around 290 units estate in one-, two-and three-bedroom configurations, starting from 38m2 up to 154m2penthouses.",
                    "Brookfield at Royal in Johannesburg is the first luxury apartment development to be situated within the precinct of the Royal Johannesburg and Kensington Golf Club. The development is set out on a long, narrow, sloping site alongside the golf course, arranged in a linear form that follows the contours of the land. Each block consists of three-storey walk-up structures, typically arranged in clusters of six to eight units. Each cluster features a symmetrical layout with two-bedroom apartments on the ground and first floors, and loft units on the top floor with bedrooms and living spaces split between two levels.",
                    "The design is characterised by a central pitched frame flanked by flat-roofed sections. This combination creates an undulating rhythm along the length of the development. The pitched roofs are clad in slate-grey standing-seam steel roof sheets, while the flanking sections feature red brick and white-painted plaster. These vertical roof elements play a key role in the terraced design form.",
                    "Open gables on one side house entrances and vertical circulation, with balconies facing on to landscaped parking. Gables on the other side feature expansive glazing and steel-and-glass balconies overlooking the golf course, with vertical brick barbecue columns forming privacy dividers between units. Each unit is crowned by twin steel chimney pipes, forming an iconic leitmotif throughout the scheme.",
                    "The combination of traditional materials of red brick and plaster and modern elements of steel and glass creates a harmonious blend of solidity and lightness that references the treed landscape between the buildings, private gardens, a dam and golf course. The dark steel and slate-grey tones reference the original black slate roof of the Royal Johannesburg clubhouse. The overall effect is a carefully articulated contemporary interpretation of a traditional terraced row-house development.",
                    "The Royal Johannesburg and Kensington Golf Club was established in 1890. It is recognised as one of the premium golf courses in Africa. The long-established club is regarded as the “home of golf” in South Africa. It hosts the Gauteng Senior Golfer’s Society, the PGA of South Africa and the Club Managers Association of South Africa. Brookfield at Royal is one of several developments we designed for Tricolt. Click to see more details about Olympus Sandton, One Rosebank, Ellipse Waterfall and Tree Tops, Houghton."
                ],
                method: "Sean Gibson - Photographer",
                client: "Tricolt",
                status: "on site",
                year: "2025",
                services: ["architecture"],
                tags: [
                    "residential"
                ],
                location: "https://maps.app.goo.gl/zejFSzQYFP5iMJ44A",
                sliderdata: [
                    {
                        image: brookfieldroyalsliderimage1,
                        title: "Brookfield at Royal",
                        number: ""
                    },
                    {
                        image: brookfieldroyalsliderimage2,
                        title: "aerial view over the golf course",
                        number: "1"
                    },
                    {
                        image: brookfieldroyalsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: brookfieldroyalsliderimage4,
                        title: "unit entrance access",
                        number: "3"
                    },
                    {
                        image: brookfieldroyalsliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: brookfieldroyalsliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: brookfieldroyalsliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: brookfieldroyalsliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: brookfieldroyalsliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: brookfieldroyalsliderimage10,
                        title: "site visit - 2021",
                        number: "9"
                    },
                    {
                        image: brookfieldroyalsliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: hundredsliderimage1,
                        title: "1 Hundred on M",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '09',
        title: '1 Hundred on M',
        location: 'Cape Town, South Africa',
        year: '2025',
        image: projectsimage9,
        data: [
            hundredimage1,
            hundredimage2,
            hundredimage3,
            hundredimage4,
            hundredimage5,
        ],
        pagedata: [
            {
                Pagetitle: "1 Hundred on M",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "One Hundred on M on Sea Point Main Road is an example of old meeting new to achieve a sensitive transformation of a heritage building into a striking piece of contemporary architecture.",
                    "We designed this seven-storey, mixed-use development for blok, to reimagine a Victorian-era building and repurpose it for modern living. Set in a vibrant location with natural beauty, One Hundred on M features retail and commercial spaces on the ground floor level and residential accommodation on upper levels. We’ll share more details about this coastal development as construction progresses."
                ],
                method: "",
                client: "Blok",
                status: "on site",
                year: "2025",
                services: "architecture",
                tags: [
                    "residential",
                    "mixed-use",
                    "retail"
                ],
                location: "https://maps.app.goo.gl/nimNqWimPML9H6BR9",
                sliderdata: [
                    {
                        image: hundredsliderimage1,
                        title: "1 Hundred on M",
                        number: ""
                    },
                    {
                        image: hundredsliderimage2,
                        title: "view from main road",
                        number: "1"
                    },
                    {
                        image: hundredsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: hundredsliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: hundredsliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: hundredsliderimage6,
                        title: "micro-apartment",
                        number: "5"
                    },
                    {
                        image: hundredsliderimage7,
                        title: "model of the original building",
                        number: "6"
                    },
                    {
                        image: hundredsliderimage8,
                        title: "site visit - 2024",
                        number: "7"
                    },
                    {
                        image: hundredsliderimage9,
                        title: "original façade",
                        number: "8"
                    },
                    {
                        image: dockroadsliderimage1,
                        title: "5 Dock Road",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '10',
        title: '5 Dock Road',
        location: 'Cape Town, South Africa',
        year: '2025',
        image: projectsimage10,
        data: [
            dockroadimage1,
            dockroadimage2,
            dockroadimage3
        ],
        pagedata: [
            {
                Pagetitle: "5 Dock Road",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "The brief for the luxury apartments at 5 Dock Road was to take advantage of its unique position at the gateway connection between the V&A Waterfront to De Waterkant on the west and CBD to the south. The building overlooks Battery Park, a 12 000m² urban park we developed in 2018 as the nucleus of a larger urban vision for the district. The building is located on the northern portion of the park, which extends down to the reception lobby and porte cochere at street level. This residential project kickstarts the second phase of the masterplan designed to enliven the Canal Precinct into a mixed-use environment where retail outlets, offices and a hotel already exist.",
                    "The design is articulated into distinct massings on each of the four façades, to break down the scale of the overall building on all outward facing edges. This is achieved by stepping back the building footprint in certain areas and through the façade articulation. Recessed balconies featuring frameless glazed balustrades are fronted by a large shaped brise-soleil outer façade to provide solar shading. This also avoids the building becoming an overbearing mass.",
                    "The building rises to six storeys above the park. The central southern portion facing the park has been lowered by two floors to accommodate the rooftop pool and amenity areas. The balconies are orientated to create a faceted, angular, serrated edge, adding interest to the façade.",
                    "The development offers one-, two- and three-bedroom configurations spread over six floors, with exclusive penthouses on the top floor. The interior layouts have been finely designed complemented by superior interior finishes designed by Paragon Interface. Depending on where they’re located in the building, units offer spectacular views of the V&A Waterfront, Cape Town harbour, CBD, Table Mountain and Signal Hill."
                ],
                method: "",
                client: "V&A Waterfront",
                status: "on site",
                year: "2025",
                services: ["architecture", "urban design"],
                tags: [
                    "residential"
                ],
                location: "https://maps.app.goo.gl/HdzaemtXUUhzxE5q6",
                sliderdata: [
                    {
                        image: dockroadsliderimage1,
                        title: "5 Dock Road",
                        number: ""
                    },
                    {
                        image: dockroadsliderimage2,
                        title: "aerial view of precinct - urban design",
                        number: "1"
                    },
                    {
                        image: dockroadsliderimage3,
                        title: "view from dock road",
                        number: "2"
                    },
                    {
                        image: dockroadsliderimage4,
                        title: "view from waterway house",
                        number: "3"
                    },
                    {
                        image: dockroadsliderimage5,
                        title: "view from penthouse bedroom",
                        number: "4"
                    },
                    {
                        image: dockroadsliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: dockroadsliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: ellipsewaterfallsliderimage1,
                        title: "Ellipse Waterfall",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '11',
        title: 'Ellipse Waterfall',
        location: 'Johannesburg, South Africa',
        year: '2025',
        image: projectsimage11,
        data: [
            ellipseimage1,
            ellipseimage2,
            ellipseimage3
        ],
        pagedata: [
            {
                Pagetitle: "Ellipse Waterfall",
                pagelocation: "Johannesburg, South Africa",
                paragraphs: [
                    "Designed for Tricolt and Attacq, Ellipse Waterfall is located in the heart of Waterfall City, in Gauteng. The client brief was to create a unique residential complex of striking architectural impact to mark its status as the first high-rise luxury apartment development in the area",
                    "In response, we moved away from the traditional rectangular apartment block design in favour of a more unconventional form. We proposed four separate elliptical towers to make the most of the site’s elevated location and unobstructed views. The buildings' shape takes inspiration from an ellipse, a mathematical term for a curved plane surrounding two focal points, which is highly efficient in terms of ratio of surface area to internal volume. The lack of corners reduces the visual profile of the buildings to offer the most suitable form when considering multiple towers in proximity to one another.",
                    "The 45 000 m² precinct features 620 apartments, including executive one-bedroom, one-bedroom, two-bedroom and three-bedroom units and multiple penthouse suites. Other amenities include The Luna Club, an exclusive multi-concept lifestyle destination.",
                    "The towers sit on a raised podium, creating an elevated ground floor with a parking garage and services infrastructure underneath. The podium level is extensively landscaped and includes a central piazza, running track, active and passive parks, lap and leisure pools, verdant gardens and The Luna Club. These spaces offer moments of connection between residents and encourage community activity. At street level, an elevated forecourt addresses the most prominent corner where retail spaces spill out onto the activated street edges to create a relationship with other users from the broader Waterfall City community.",
                    "The four towers have an identical footprint, though each is a different height. Newton has 10 storeys, Kepler has 11 storeys, Cassini has 13 and Galileo 15. The curvilinear façade of the towers is complemented by a mix of moveable and fixed screens which serve to animate the elevations. This produces an ever-changing collage responding to the movement of the sun and the moods of its occupants.",
                    "The interiors have a clean and contemporary aesthetic, complete with ultra-modern finishes, high ceilings and large windows that provide panoramic views of the Gauteng skyline. Designed with user experience in mind, everything has been considered to optimise internal functionality and flow. Ellipse’s design prioritises sustainable living. It incorporates green design practices and building features that contribute to a reduced environmental footprint.",
                    "Inspired by their mathematical origins, each tower is named after some of the world’s most celebrated scientists, namely Newton, Kepler, Cassini and Galileo. This is one of multiple projects we have delivered for Tricolt. Visit One Rosebank, Brookfield at Royal and Olympus Sandton for more details."
                ],
                method: "Tricolt - Aerial",
                method2: "Sean Gibson - Photographer",
                client: "Attacq and Tricolt",
                status: "on site",
                year: "2025",
                services: ["architecture"],
                tags: [
                    "residential",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/99jdyTUhHWwL4VLf6",
                sliderdata: [
                    {
                        image: ellipsewaterfallsliderimage1,
                        title: "Ellipse Waterfall",
                        number: ""
                    },
                    {
                        image: ellipsewaterfallsliderimage2,
                        title: "newton, kepler + cassini towers",
                        number: "1"
                    },
                    {
                        image: ellipsewaterfallsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: ellipsewaterfallsliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: ellipsewaterfallsliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: ellipsewaterfallsliderimage6,
                        title: "site visit - 2023",
                        number: "5"
                    },
                    {
                        image: ellipsewaterfallsliderimage7,
                        title: "early elevations",
                        number: "6"
                    },
                    {
                        image: ellipsewaterfallsliderimage8,
                        title: "penthouse bedroom",
                        number: "7"
                    },
                    {
                        image: ellipsewaterfallsliderimage9,
                        title: "penthouse view",
                        number: "8"
                    },
                    {
                        image: ellipsewaterfallsliderimage10,
                        title: "on site - 2019",
                        number: "9"
                    },
                    {
                        image: onerosebanksliderimage1,
                        title: "One Rosebank",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '12',
        title: 'One Rosebank',
        location: 'Johannesburg, South Africa',
        year: '2025',
        image: projectsimage12,
        data: [
            rosebankimage1,
            rosebankimage2,
            rosebankimage3,
            rosebankimage4
        ],
        pagedata: [
            {
                Pagetitle: "One Rosebank",
                pagelocation: "Johannesburg, South Africa",
                paragraphs: [
                    "One Rosebank is a high-quality mixed-use development in one of the Johannesburg’s most sought-after commercial, cultural and residential hubs. The client, Tricolt, envisaged a luxury residential development located close to the vibrant commercial hub of Rosebank, located north of the Johannesburg CBD.",
                    "We responded with a design that contributes to the urban design language of the adjacent Oxford Parks precinct. The 1.2-hectare site is bordered by large commercial office buildings to the south and single residential homes on large, tree-lined plots to the north.",
                    "The design responds to the site’s sloping topography, resulting in a seven-storey block to one side of the site and a lower, four-storey construction opposite, respecting the zoning requirements and acknowledging the scale of the surrounding urban fabric. These buildings encompass around 600 units in studio, one-bedroom and two-bedroom configurations, designed around a large landscaped courtyard that creates an active social environment containing a gym, swimming pool and ball court. Mixed-used elements include co-working spaces, a coffee shop with meeting rooms and a spectacular rooftop restaurant and a bar",
                    "The architecture is simple and fresh, comprising a strong, two-storey tiled and colonnaded lower base, with upper levels of white-painted, raked, jointed brickwork. An alternating rhythm of inset balconies and windows are offset with projecting concrete framed bays. This forms a carefully modulated and taut composition, creating varying depths of light and shadow. Simple vertical steel balustrades further animate and enliven the façades. Walkway bridges and strong vertical breaks between blocks define entrances, the position of lobbies and vertical circulation. The retail components, gym and clubhouse are expressed as lightweight flat-roofed, steel and glass pavilions, with a publicly accessible terrace stitching the building sat the corner. The rooftop restaurant follows the same transparent architectural formula, with its angled shopfronts and corner tilted roof capturing the panoramic views above the dense tree canopy of the urban forest below.",
                    "One Rosebank is one of a series of projects we have worked on in Rosebank. In 2016, we designed the masterplan for Oxford Parks, drawing from the concepts laid out in the Dunkeld Design Manual which we developed in 2015. We also designed several other buildings in the precinct including 203 Oxford, 6 Parks Boulevard for Arup and Radisson Red hotel, which have both been recognized in local awards series."
                ],
                method: "Visoo - Renders",
                client: "Tricolt",
                status: "on site",
                year: "2025",
                services: ["architecture"],
                tags: [
                    "residential",
                    "mixed-use",
                    "office",
                    "retail"
                ],
                location: "https://maps.app.goo.gl/D24pRYXgr53tXGq97",
                sliderdata: [
                    {
                        image: onerosebanksliderimage1,
                        title: "One Rosebank",
                        number: ""
                    },
                    {
                        image: onerosebanksliderimage2,
                        title: "mixed-use facilities",
                        number: "1"
                    },
                    {
                        image: onerosebanksliderimage3,
                        title: "rooftop restaurant",
                        number: "2"
                    },
                    {
                        image: onerosebanksliderimage4,
                        title: "view from cradock avenue",
                        number: "3"
                    },
                    {
                        image: onerosebanksliderimage5,
                        title: "site visit - august 2024",
                        number: "4"
                    },
                    {
                        image: onerosebanksliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: onerosebanksliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: onerosebanksliderimage8,
                        title: "one bedroom unit",
                        number: "7"
                    },
                    {
                        image: onerosebanksliderimage9,
                        title: "interior renders - visoo",
                        number: "8"
                    },
                    {
                        image: springfieldestatesliderimage1,
                        title: "Springfield Estate",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '13',
        title: 'Springfield Estate',
        location: 'George, South Africa',
        year: '2025',
        image: projectsimage13,
        data: [
            sprinfieldimage1,
            sprinfieldimage2
        ],
        pagedata: [
            {
                Pagetitle: "Springfield Estate",
                pagelocation: "George, South Africa",
                paragraphs: [
                    "Springfield Estate is a new premium residential development located in George in the Western Cape, at the heart of South Africa's beautiful Garden Route. Our client, Vantage Property, wanted a concept masterplan and design for a 16-hectare lifestyle estate offering a selection of two- and three-bedroom modern homes offering a range of resort-level amenities, including a heated swimming pool and a spacious, welcoming clubhouse.",
                    "Our response, which brought together the skills and expertise of our architectural and urban design teams, was a thoughtfully designed lifestyle estate in a contemporary Cape Vernacular style. At the heart of the concept isa masterplan that creates three distinct neighbourhoods, interconnected by a green spine that runs through the entire development. This central feature not only provides a unifying element but also serves as a green corridor for leisure and recreation.",
                    "The layout of the estate has been crafted to create a sense of place and facilitate easy navigation. A hierarchy of streets and spaces defines the community, with a primary circular route at its core. Secondary roads branch off from this main artery, creating intimate residential pockets and fostering a village-like atmosphere. Phase 1 of the project commenced in February 2024."
                ],
                method: "Visoo - Renders",
                client: "Vantage Property",
                status: "on site",
                year: "2025",
                services: ["urban design", "architecture"],
                tags: [
                    "urban design",
                    "residential"
                ],
                location: "https://maps.app.goo.gl/Gn2bXyrfd87jf2sT9",
                sliderdata: [
                    {
                        image: springfieldestatesliderimage1,
                        title: "Springfield Estate",
                        number: ""
                    },
                    {
                        image: springfieldestatesliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: springfieldestatesliderimage3,
                        title: "dhki - kitchen option",
                        number: "2"
                    },
                    {
                        image: springfieldestatesliderimage4,
                        title: "dhki - lounge option",
                        number: "3"
                    },
                    {
                        image: springfieldestatesliderimage5,
                        title: "dhki - bedroom option",
                        number: "4"
                    },
                    {
                        image: springfieldestatesliderimage6,
                        title: "dhki - bathroom option",
                        number: "5"
                    },
                    {
                        image: springfieldestatesliderimage7,
                        title: "public spaces",
                        number: "6"
                    },
                    {
                        image: springfieldestatesliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: springfieldestatesliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: springfieldestatesliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: springfieldestatesliderimage11,
                        title: "masterplan - urban design",
                        number: "10"
                    },
                    {
                        image: springfieldestatesliderimage12,
                        title: "streetscape section - urban design",
                        number: "11"
                    },
                    {
                        image: bishopsacademicsliderimage1,
                        title: "Bishops Academic Learning Centre",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '14',
        title: 'Bishops Academic Learning Centre',
        location: 'Cape Town, South Africa',
        year: '2024',
        image: projectsimage14,
        data: [
            bishopsimage1,
            bishopsimage2,
            bishopsimage3,
            bishopsimage4
        ],
        pagedata: [
            {
                Pagetitle: "Bishops Academic Learning Centre",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "The new multimedia academic learning centre at Bishops Diocesan College in Rondebosch, Cape Town, was completed in 2024. The design combines the expertise of our architecture team and interior design team at dhk Interior Design. The project comprises the transformation of a cluster of existing different rooms and functions which previously adjoined the library into a multimedia-based learning hub in the heart of the academic precinct. The existing facility had become outdated and needed to be better connected to surrounding buildings, movement routes and the landscape. The key requirement was to expand the learning environment, with built-in flexibility to configure the spaces as needs arise.",
                    "The result is a contemporary insertion, as a hub surrounded by a mix of building styles, some historical and others more modern. Extensive glazing at the ground floor creates a virtual wall that enables a sense of openness and connection to the surrounding gardens and buildings despite the tightness of the location. It also allows for a direct relationship to a terraced outdoor space which can be used as a spill out area for gatherings or outdoor learning. Both existing walls which have been preserved and those that are new feature deep, angled reveals and chamfered, shaped windowsills. Long narrow windows create an effective, playful aesthetic impact, while also helping to control light hitting the east and west façades.",
                    "Internally, the space can be sub-divided to accommodate flexible learning configurations. The accommodation is arranged around a spindle, with staffrooms on the upper levels that upgrade staff facilities to a more multi-functional environment. These rooms feature easily accessible booths, meeting pods and breakaway rooms. A new Information and Communications Technology (ICT) centre is accessed from this area too, providing a permanent, dedicated ICT centre to staff and learners alike. This crucial hub provides services to teachers and administrators, and also learners, so ease of access and security were of equal importance.",
                    "The interiors by dhk Interior Design are configured as a calm backdrop against to stimulate learning and development. The interiors are designed deliberately to not mimic design trends or use design gimmicks; rather, the aesthetic treatment reflects the ethos and longevity of the campus, by honouring the Bishops brand identity with a complementary colour palette. The interior design follows a visual thread expressing all elements of the building’s architecture. Materials are robust and durable, but natural timbers make the space warm and inviting, while concrete and steel reflect the exterior language. The furniture selection prioritises flexibility, with pull-out ottomans, multipurpose and multifunctional furniture and shelving that can be configured to respond to learning needs.",
                    "The Bishops Learning Centre represents an example of how existing buildings can be reused, preserving their historical personality while facilitating 21st Century learning."
                ],
                method: "",
                client: "Bishops Diocesan College",
                status: "built",
                year: "2024",
                services: ["architecture", "urban design"],
                tags: [
                    "public + education"
                ],
                location: "https://maps.app.goo.gl/vWZ5gaUFEGZzaRBC6",
                sliderdata: [
                    {
                        image: bishopsacademicsliderimage1,
                        title: "Bishops Academic Learning Centre",
                        number: ""
                    },
                    {
                        image: bishopsacademicsliderimage2,
                        title: "primary entrance + courtyard",
                        number: "1"
                    },
                    {
                        image: bishopsacademicsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: bishopsacademicsliderimage4,
                        title: "dhki - teachers lounge",
                        number: "3"
                    },
                    {
                        image: bishopsacademicsliderimage5,
                        title: "dhki - collab room",
                        number: "4"
                    },
                    {
                        image: bishopsacademicsliderimage6,
                        title: "dhki - chill area in the molteno library",
                        number: "5"
                    },
                    {
                        image: bishopsacademicsliderimage7,
                        title: "dhki - first floor of the molteno library",
                        number: "6"
                    },
                    {
                        image: bishopsacademicsliderimage8,
                        title: "dhki - ground level of the molteno library",
                        number: "7"
                    },
                    {
                        image: bishopsacademicsliderimage9,
                        title: "molteno library entrance - back of building",
                        number: "8"
                    },
                    {
                        image: longkloofsliderimage1,
                        title: "Longkloof Precinct",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '15',
        title: 'Longkloof Precinct',
        location: 'Cape Town, South Africa',
        year: '2024',
        image: projectsimage15,
        data: [],
        pagedata: [
            {
                Pagetitle: "Longkloof Precinct",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "The Longkloof Precinct project was a complex multidisciplinary adaptive reuse design challenge that creates a meaningful dialogue between heritage and contemporary elements in a sensitive and respectful combination. The 15-year long project comprises the sensitive restoration of five historic buildings and the construction of a new five-star hotel, set within an interconnected landscaped public realm with new street frontage and a new secured yet publicly accessible external space at the heart of the precinct.",
                    "The site comprises six separate erven owned by a single owner, with an accumulated site area of 16,500m2, in a transitional location off the edge of the Cape Town CBD. Five original historic buildings of various scales were subject to heritage protections in terms of height, building mass, protected view corridors, façade articulation and materiality. The precinct was landlocked with minimal street frontages and restricted public access to commercial buildings; it had become fragmented, lacking spatial cohesion and connectivity.",
                    "The project commenced in 2010, with the original architectural brief to design an office, retail and basement parking proposal on the larger site which included existing surface parking. While this site contained one of the historical buildings, only one wall of that building was deemed worthy of retention. The brief later expanded to individual redevelopment proposals for the other heritage buildings in the precinct. It became clear that there was a need, and an opportunity, to fully integrate all the erven into one cohesive precinct. The precinct-wide urban design approach creates a vibrant publicly accessible environment while respecting heritage indicators and the surrounding context.",
                    "The scheme revitalises the existing heritage buildings, upgrading them to premium grade co-working and office spaces. Contemporary additions included additions and partial demolition to existing buildings, excavations to activate existing basement floors and to create activated courtyard spaces, reconfiguring internal spaces into open-plan offices and reinstating ground floor connections between existing buildings and the public realm. The new-build five-star hotel was initially designed and approved as two separate office buildings. This approved scheme was later adapted to hotel use, which required above-ground connection between the two buildings with glass-clad bridges at all four levels. Façades are stepped back away from the street to reduce their scale and to better respond to the surrounding streetscape and the public square. New ground floor retail, restaurants and cafes enliven street edges, pedestrian walkways and new urban square.",
                    "The design introduces new pedestrian links into and through the precinct to connect the surrounding public realm into the heart of the new Longkloof precinct. This enhances the quality of the public realm and emphasises pedestrian permeability. Street edges and pedestrian routes are well defined, with canopies or pergolas offering protection in appropriate areas. Access to three levels of basement parking ensures a car-free pedestrian-friendly environment. On site vehicular movement is limited to hotel drop off and intermittent servicing along Jamieson Lane."
                ],
                method: "Sean Gibson - Photographer",
                methoddetails: [
                    "Longkloof is one of the studio’s flagship projects. It is an outstanding demonstration of how precinct-led urban design and considered architectural design can be combined to add value to neglected urban environments. We are absolutely delighted with the results.",
                    "Derick Henstra, Executive Chairman and co-founder of"
                ],
                dhkArchitects: "Architects",
                client: "Growthpoint Properties",
                status: "built",
                year: "2024",
                services: ["urban design", "architecture"],
                tags: [
                    "mixed-use",
                    "retail",
                    "urban design",
                    "office",
                    "hospitality"
                ],
                location: "https://maps.app.goo.gl/366g7qX1JpRjDQDG9",
                sliderdata: [
                    {
                        image: longkloofsliderimage1,
                        title: "Longkloof Precinct",
                        number: ""
                    },
                    {
                        image: longkloofsliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: longkloofsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: longkloofsliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: longkloofsliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: longkloofsliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: longkloofsliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: longkloofsliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: longkloofsliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: longkloofsliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: longkloofsliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: longkloofsliderimage12,
                        title: "",
                        number: "11"
                    },
                    {
                        image: longkloofsliderimage13,
                        title: "",
                        number: "12"
                    },
                    {
                        image: longkloofsliderimage14,
                        title: "",
                        number: "13"
                    },
                    {
                        image: longkloofsliderimage15,
                        title: "",
                        number: "14"
                    },
                    {
                        image: longkloofsliderimage16,
                        title: "",
                        number: "15"
                    },
                    {
                        image: longkloofsliderimage17,
                        title: "",
                        number: "16"
                    },
                    {
                        image: therubiksliderimage1,
                        title: "The Rubik",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '16',
        title: 'The Rubik',
        location: 'Cape Town, South Africa',
        year: '2024',
        image: projectsimage16,
        data: [
            therubikimage1,
            therubikimage2,
            therubikimage3
        ],
        pagedata: [
            {
                Pagetitle: "The Rubik",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "The Rubik is a 27-storey mixed-use tower designed for Abland Property Developers. The developers wanted a viable yet unique design for a modern mixed-use building on an 821m2 site that straddles the historical inner-city district and the more recently developed city blocks north of Riebeek Street in Cape Town’s CBD. The design needed to address the challenge of its location in a Heritage Overlay Zone and required approval from heritage authorities. The result is a distinctive form that rises to 91 meters. While exceeding initial height restrictions, the resulting approval led to a building that enhances the city skyline with its dynamic sculptural elegance.",
                    "Retail spaces activate the streetscape from ground to first floor and the parking podium rises ten floors above. The upper levels, from floors 11 to 26, are divided into three stacked,orthogonal twisting cubes rotated around a central axis. These levels contain commercial offices and residential apartments, including one- and two-bedroom units, duplex and triplex penthouses. The fragmentation creates visual interest and captures varied reflections of the surrounding cityscape. Small recessed terraces punctuate the facade, adding to the building’s aesthetic.",
                    "The façade design is thoughtful and contextual. The parking podium’s exterior references the scale and rhythm of nearby heritage buildings, using a combination of pre-cast concrete, extruded aluminium, and glazed panels. The office and residential levels feature flush glazing co structural elements and incorporates discreet balconies.",
                    "Despite the tight site constraints, the internal layout maximises efficiency. The centralised lift core and scissor stair accommodate parking circulation below while providing flexibility for office and residential layouts above. Terraces to the residential units are stepped back, providing protection from the weather. A common roof terrace with a pool and indigenous planting crowns the building.",
                    "The Rubik incorporates several sustainable features including high-performance glazing, energy-efficient systems and environmentally-friendly materials. Its mixed-use nature and central location promote urban density and walkability, aligning with sustainable urban development principles. Overall, The Rubik stands as a significant contemporary addition to Cape Town’s skyline, balancing modern design with sensitivity to its historic context while promoting a vibrant, mixed-use urban environment."
                ],
                method: "Sean Gibson - Photographer",
                client: "Abland Property Developers",
                status: "built",
                year: "2024",
                services: "architecture",
                tags: [
                    "mixed-use",
                    "office",
                    "residential",
                    "retail"
                ],
                location: "https://maps.app.goo.gl/PwwgBNZdRK6bHwVa8",
                sliderdata: [
                    {
                        image: therubiksliderimage1,
                        title: "The Rubik",
                        number: ""
                    },
                    {
                        image: therubiksliderimage2,
                        title: "view up loop street",
                        number: "1"
                    },
                    {
                        image: therubiksliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: therubiksliderimage4,
                        title: "view from bree street",
                        number: "3"
                    },
                    {
                        image: therubiksliderimage5,
                        title: "parking podium façade",
                        number: "4"
                    },
                    {
                        image: therubiksliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: therubiksliderimage7,
                        title: "façade detail informed by the surrounding heritage buildings",
                        number: "6"
                    },
                    {
                        image: therubiksliderimage8,
                        title: "view from buitengracht street",
                        number: "7"
                    },
                    {
                        image: therubiksliderimage9,
                        title: "sean gibson - photographer",
                        number: "8"
                    },
                    {
                        image: lowerlongsliderimage1,
                        title: "35 Lower Long",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '17',
        title: '35 Lower Long',
        location: 'Cape Town, South Africa',
        year: '2022',
        image: projectsimage17,
        data: [
            lowerlongimage1,
            lowerlongimage2
        ],
        pagedata: [
            {
                Pagetitle: "35 Lower Long",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "35 Lower Long is an elegant and dynamic tower designed for Abland Property Developers and Ellerine Brothers in Cape Town’s Foreshore precinct. It features14 floors of office space, flexible co-working spaces, a luxurious top-floor business suite, ground-floor retail space and 280 parking bays.",
                    "The site contained an existing, unremarkable 1980s building. The initial brief was to remodel and extend that building. However, this proposition was deemed impractical due to the limitations of adding floors, the need to replace an outdated façade and challenges with long-term viability. The scheme was subsequently revised to create a significantly taller, more inspirational structure that would enhance Cape Town’s skyline and offer developers greater medium- to long-term viability. That said, the challenge remained to maximise the quality of multi-tenant commercial space while accommodating core components such as lifts, stairs and structured basement parking, all within a relatively small floor plate.",
                    "The result is a building characterised by a singular sculpted massing with dynamic glazed façades that extend seamlessly over the office’s floors and parking levels. The façade terminates above ground level to emphasise and activate the street edge, particularly along entire length of the street frontage along Lower Long and Jetty Streets. This is enlivened by retail units at ground level, multiple entry points to the office building and a prominent double-volume main entrance.",
                    "The two main corners of the building are chamfered towards the roof line, breaking the solidity of the building. The glazing on these corners soars upwards past the roofline, further articulating the façade and extending past the building’s chamfered corners, giving the effect of a crystalline screen rather than solid building mass. The sculptural form of the building provides dynamic views from across the city, both at street level and from nearby buildings. 35 Lower Long was designed according to best practice green principles and holds a 4-Star Green Star rating by the Green Building Council of South Africa.",
                    "Visit The Rubik for more details of another project we completed in 2024 for Abland Property Developers."
                ],
                method: "Adam Letch - Photographer",
                client: "Abland Property Developers and Ellerine Brothers",
                status: "built",
                year: "2022",
                services: ["architecture"],
                tags: [
                    "office",
                    "mixed-use",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/qG9sRuB2UW3ejWY37",
                sliderdata: [
                    {
                        image: lowerlongsliderimage1,
                        title: "35 Lower Long",
                        number: ""
                    },
                    {
                        image: lowerlongsliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: lowerlongsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: lowerlongsliderimage4,
                        title: "view from hans strijdom avenue",
                        number: "3"
                    },
                    {
                        image: lowerlongsliderimage5,
                        title: "skyline profile",
                        number: "4"
                    },
                    {
                        image: lowerlongsliderimage6,
                        title: "view from lower loop street",
                        number: "5"
                    },
                    {
                        image: lowerlongsliderimage7,
                        title: "adam letch - photographer",
                        number: "6"
                    },
                    {
                        image: radissonredsliderimage1,
                        title: "Radisson Red",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '18',
        title: 'Radisson Red',
        location: 'Johannesburg, South Africa',
        year: '2022',
        image: projectsimage18,
        data: [
            radissonredimage1,
            radissonredimage2,
            radissonredimage3,
            radissonredimage4
        ],
        pagedata: [
            {
                Pagetitle: "Radisson Red",
                pagelocation: "Johannesburg, South Africa",
                paragraphs: [
                    "Radisson RED Rosebank holds pride of place in the Oxford Parks precinct in Rosebank, Johannesburg. The brief from Intaprop for Radisson RED Rosebank was to create an architecturally sophisticated hotel with a playful tone. Oxford Parks emerged from the Dunkeld Design Manual, an urban masterplan which we developed to harness the strengths of Rosebank’s walkable urban realm and to connect the centre with others beyond. Key characteristics of the masterplan are human-scale architecture with striking façades and active street frontages. Radisson RED delivers on both points.",
                    "The hotel comprises 222 keys, a restaurant, bar and rooftop terrace and a generous reception area accessible from the pedestrian hub of Oxford Parks. The grand full-height entrance canopy creates a striking sense of place, highlighted with public artworks and halo pendant lights. Ground-floor volumes are visually transparent to increase internal/external interaction, reinforced by interior spaces that spill over into undercover outdoor seating areas. Illumination at night magnifies the visual impact",
                    "Art is a key feature. Bold red accents and sculptural red artworks reference the RED brand. A commissioned angel-wing sculpture by local artist Usha Seejarim forms a prominent landmark. Corridors, rooms and suites feature custom-designed wallpaper inspired by local people, art, music and fashion. Street-style art displays change regularly. An interactive digi-wall and Chromecast televisions offer high-tech visuals. The building adheres to ASHRAE standards for high thermal comfort. Its energy-efficient fittings also surpass SANS 10400 standards."
                ],
                method: "Tristan Mclaren + Sean Gibson - Photographers",
                method2: "Source IBA - Interior Design",
                client: "Intaprop",
                status: "built",
                year: "2022",
                services: ["architecture"],
                tags: [
                    "hospitality",
                    "retail",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/1fV3dRhVoqvyKkrz5",
                sliderdata: [
                    {
                        image: radissonredsliderimage1,
                        title: "Radisson Red",
                        number: ""
                    },
                    {
                        image: radissonredsliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: radissonredsliderimage3,
                        title: "source iba - interior design",
                        number: "2"
                    },
                    {
                        image: radissonredsliderimage4,
                        title: "jake michael singer - sculpture",
                        number: "3"
                    },
                    {
                        image: radissonredsliderimage5,
                        title: "hotel rooftop bar",
                        number: "4"
                    },
                    {
                        image: radissonredsliderimage6,
                        title: "position within oxford parks",
                        number: "5"
                    },
                    {
                        image: radissonredsliderimage7,
                        title: "view from the corner of oxford road",
                        number: "6"
                    },
                    {
                        image: radissonredsliderimage8,
                        title: "view of the drop off spot on oxford road",
                        number: "7"
                    },
                    {
                        image: radissonredsliderimage9,
                        title: "an early elevation",
                        number: "8"
                    },
                    {
                        image: radissonredsliderimage10,
                        title: "initial sketch",
                        number: "9"
                    },
                    {
                        image: oldcapesliderimage1,
                        title: "Old Cape Quarter",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '19',
        title: 'Old Cape Quarter',
        location: 'Cape Town, South Africa',
        year: '2021',
        image: projectsimage19,
        data: [
            oldcapeimage1,
            oldcapeimage2,
            oldcapeimage3,
            oldcapeimage4,
            oldcapeimage5
        ],
        pagedata: [
            {
                Pagetitle: "Old Cape Quarter",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "Nestled in the heart of Cape Town’s vibrant De Waterkant neighbourhood, Old Cape Quarter is an exemplar of thoughtful urban renewal and adaptive reuse design principles. The brief by Tower Property Fund was to revitalise the complex into a mixed-use hub including new retail and office spaces as well as 55 luxury apartments and penthouses. At the core of the development lies the protected Old Cape Quarter Piazza, a significant historical landmark that anchors the development in Cape Town’s rich past.",
                    "Our approach was to weave contemporary elements into the original structure, preserving its heritage and reviving the area with a high quality contemporary architectural insertion. The key objective for this approach was to design buildings that were efficient while making an architectural statement that could reflect and embody the existing heritage context.",
                    "The development prioritises occupant well-being through optimised living and workspaces, improved indoor air quality and the use of non-toxic materials throughout. This focus on health and comfort contributes to an enhanced quality of life for residents and workers throughout the development. A timber brise-soleil creates an elegant screen that enhances privacy for the apartments on the upper floors.",
                    "The central courtyard at the heart of the development is one of its most striking features. Cobblestones and cascading planted terraces provide a tranquil retreat from urban life, beyond the surrounding busy streets. Ground floor retail and commercial units open directly into the courtyard, enhancing it as an active public space. Secure underground parking, access control and separate entrances to the residential units contribute to the sense of privacy for residents. Overall, our design response has resulted in a development that seamlessly blends historical charm with modern sophistication, offering a unique living and working experience.",
                    "We were also very proud to secure the ground floor space to locate our Cape Town office, providing us with a prominent street presence and a direct connection with the urban environment. In February 2025, Old Cape Quarter was awarded a Four Star Greenstar As-Built Rating by the Green Building Council of South Africa, recognising its sustainable design principles."
                ],
                method: "Sean Gibson - Photographer",
                client: "Tower Property Fund",
                status: "built",
                year: "2021",
                services: ["architecture"],
                tags: [
                    "retail",
                    "residential",
                    "mixed-use",
                    "office",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/LmRWmL7UziV6T5K18",
                sliderdata: [
                    {
                        image: oldcapesliderimage1,
                        title: "Old Cape Quarter",
                        number: ""
                    },
                    {
                        image: oldcapesliderimage2,
                        title: "view from the corner of hudson street",
                        number: "1"
                    },
                    {
                        image: oldcapesliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: oldcapesliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: oldcapesliderimage5,
                        title: "first floor - timber screen detail",
                        number: "4"
                    },
                    {
                        image: oldcapesliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: oldcapesliderimage7,
                        title: "view of the courtyard + residential",
                        number: "6"
                    },
                    {
                        image: oldcapesliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: oldcapesliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: oldcapesliderimage10,
                        title: "view from the corner of dixon street",
                        number: "9"
                    },
                    {
                        image: oldcapesliderimage11,
                        title: "view from the corner of dixon street",
                        number: "10"
                    },
                    {
                        image: oldcapesliderimage12,
                        title: "dixon street retail",
                        number: "11"
                    },
                    {
                        image: oldcapesliderimage13,
                        title: "boyd + ogier - model based on our initial sketches of the courtyard",
                        number: "12"
                    },
                    {
                        image: oldcapesliderimage14,
                        title: "early in-house illustrations",
                        number: "13"
                    },
                    {
                        image: oldcapesliderimage15,
                        title: "",
                        number: "14"
                    },
                    {
                        image: oxfordsliderimage1,
                        title: "203 Oxford, Oxford Parks",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '20',
        title: '203 Oxford, Oxford Parks',
        location: 'Johannesburg, South Africa',
        year: '2020',
        image: projectsimage20,
        data: [
            oxfordimage1,
            oxfordimage2,
            oxfordimage3,
            oxfordimage4,
            oxfordimage5
        ],
        pagedata: [
            {
                Pagetitle: "203 Oxford, Oxford Parks",
                pagelocation: "Johannesburg, South Africa",
                paragraphs: [
                    "Collaboration is at the heart of our work. We're proud to be working in association with U+A on a luxury residential development currently underway in the United Arab Emirates, located on Al Marjan Island in Ras Al Khaimah. Our team worked closely with U+A on the design philosophy, coordination and building information modelling (BIM) to create a luxurious yet functional living environment that harmonises with its beachfront location.",
                    "The Al Marjan Beach Club is a prestigious residential development nestled on Al Marjan Island in Ras Al Khaimah. Conveniently located just a 45-minute drive away from both Dubai and Sharjah International Airports, this exclusive enclave offers a luxurious lifestyle, featuring a total of 2000 residential and branded apartments.",
                    "With the breathtaking Arabian Peninsula as its backdrop, the development places a strong emphasis on family-oriented waterfront leisure, complemented by a robust wellness theme. Along the charming promenade, a delightful array of food and beverage options adds to the island's unique allure, solidifying its position as the ultimate destination for those seeking an upscale lifestyle by the water's edge."
                ],
                method: "Binyan + Red Vertex - Renders",
                client: "Aldar Properties",
                status: "on site",
                year: "2028",
                services: ["architecture", "urban design"],
                tags: [
                    "mixed-use",
                    "residential",
                    "hospitality"
                ],
                location: "https://maps.app.goo.gl/HLjRCMfL1BDo9k1KA",
                sliderdata: [
                    {
                        image: oxfordsliderimage1,
                        title: "203 Oxford, Oxford Parks",
                        number: ""
                    },
                    {
                        image: oxfordsliderimage2,
                        title: "view from oxford road",
                        number: "1"
                    },
                    {
                        image: oxfordsliderimage3,
                        title: "context within the oxford parks precinct",
                        number: "2"
                    },
                    {
                        image: oxfordsliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: oxfordsliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: oxfordsliderimage6,
                        title: "pedestrian access into oxford parks",
                        number: "5"
                    },
                    {
                        image: oxfordsliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: oxfordsliderimage8,
                        title: "site visit - 2019",
                        number: "7"
                    },
                    {
                        image: oxfordsliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: oxfordsliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: oxfordsliderimage11,
                        title: "initial illustrations",
                        number: "10"
                    },
                    {
                        image: oxfordsliderimage12,
                        title: "",
                        number: "11"
                    },
                    {
                        image: oxfordsliderimage13,
                        title: "",
                        number: "12"
                    },
                    {
                        image: parkssliderimage1,
                        title: "6 Parks Boulevard, Oxford Parks",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '21',
        title: '6 Parks Boulevard, Oxford Parks',
        location: 'Johannesburg, South Africa',
        year: '2020',
        image: projectsimage21,
        data: [
            parksimage1,
            parksimage2,
            parksimage3,
            parksimage4,
            parksimage5
        ],
        pagedata: [
            {
                Pagetitle: "6 Parks Boulevard, Oxford Parks",
                pagelocation: "Johannesburg, South Africa",
                paragraphs: [
                    "6 Parks Boulevard, for Intaprop, formed part of the first phase of the new Oxford Parks precinct in Johannesburg. Our brief was to design a striking headquarters building within the new commercial development. At just three storeys, and with only a portion of the façade facing Oxford Road, the design needed to be unique and eye-catching to make an impression on passing foot and vehicle traffic. Arup, a multidisciplinary planning, design and advisory consultancy, was the primary tenant at completion, occupying the 1 300m² office space.",
                    "Our solution was to establish a distinctive façade of fritted glass featuring a pattern of trees inspired by Johannesburg’s urban forest, reflecting Arup’s focus on sustainable development. We applied a specific focus on the contrast between light and dark frames surrounding the glazed area, creating interest and maintaining focus and energy on the façade.",
                    "The Oxford Parks urban design framework emerged from our 2015 project to develop the Dunkeld Design Manual. This was conceived to extend the vibrant, pedestrian environment of Rosebank along the Oxford Road corridor and link it to the emerging retail and office node of Illovo. We have also completed two other buildings in the precinct – Radisson RED and 203 Oxford, and another, One Rosebank, will be completed in 2025. We also created the entire basement and podium to prioritise a pedestrian friendly precinct environment at Oxford Parks."
                ],
                method: "Sean Gibson - Photographer",
                client: "Intaprop",
                status: "built",
                year: "2020",
                services: "architecture",
                tags: [
                    "office",
                    "retail",
                    "mixed-use",
                    "urban design",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/vFHyuHrtAJHQyBBd7",
                sliderdata: [
                    {
                        image: parkssliderimage1,
                        title: "6 Parks Boulevard, Oxford Parks",
                        number: ""
                    },
                    {
                        image: parkssliderimage2,
                        title: "glazing detail",
                        number: "1"
                    },
                    {
                        image: parkssliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: parkssliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: parkssliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: parkssliderimage6,
                        title: "position within the oxford parks precinct",
                        number: "5"
                    },
                    {
                        image: parkssliderimage7,
                        title: "site visit - 2019",
                        number: "6"
                    },
                    {
                        image: parkssliderimage8,
                        title: "initial illustrations",
                        number: "7"
                    },
                    {
                        image: parkssliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: parkssliderimage10,
                        title: "dunkeld precinct design manual overlay - urban design",
                        number: "9"
                    },
                    {
                        image: capitecbanksliderimage1,
                        title: "Capitec Bank HQ",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '22',
        title: 'Capitec Bank HQ',
        location: 'Stellenbosch, South Africa',
        year: '2020',
        image: projectsimage22,
        data: [
            capitecbankimage1,
            capitecbankimage2,
            capitecbankimage3,
            capitecbankimage4,
            capitecbankimage5
        ],
        pagedata: [
            {
                Pagetitle: "Capitec Bank HQ",
                pagelocation: "Stellenbosch, South Africa",
                paragraphs: [
                    "The head office of Capitec Bank is one of the jewels in our portfolio. This building is a great example of how innovative commercial office design can drive operational efficiencies and can also be cost effective. Located in Stellenbosch in the Western Cape, the building is named iKhaya, meaning ‘home’ in isiXhosa. Capitec is one of the largest and most progressive banks in Africa.",
                    "The brief emerged from Capitec’s strategic business decision to move into custom-designed, owned buildings that would better serve its business requirements. One of the key priorities in the brief was creating a head office that would be true to the brand and facilitate high interaction between business units and the executive team.",
                    "Our response was to create a striking, almost other-worldly building that uses effective exterior and interior design to optimise internal flow, foster inter-departmental interactions, manage corporate expenditure and enhance sustainability. The three-storey curvilinear building is defined by its dynamic interior architecture, which embodies the company’s progressive outlook and facilitates agile working",
                    "Completed in 2020, the three-storey superstructure wraps around itself, into a unique ‘doughnut’ shape. A central triple volume atrium acts as an internal social spine at the heart of the building. Internally, wide open-plan floorplates loop around the atrium’s periphery. This is an intentional design element to better connect the various departments, creating opportunities for chance collaborative encounters and personal interactions.",
                    "Our clients championed environmental sustainability and employee well-being throughout the building. To future-proof the design of the building, a flexible and agile approach was taken. Various breakaway areas offer spaces to fuel creativity, spark innovation, enjoy moments of solitude, conduct a private meeting or brainstorm ideas in small groups, with the effect of boosting productivity and enhancing efficiency."
                ],
                method: "Wieland Gliech - Photographer",
                client: "Capitec Bank",
                status: "built",
                year: "2020",
                services: ["architecture"],
                tags: [
                    "office",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/nbGJxqnn8hwuTCbv6",
                sliderdata: [
                    {
                        image: capitecbanksliderimage1,
                        title: "Capitec Bank HQ",
                        number: ""
                    },
                    {
                        image: capitecbanksliderimage2,
                        title: "techno park campus exterior",
                        number: "1"
                    },
                    {
                        image: capitecbanksliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: capitecbanksliderimage4,
                        title: "interior details",
                        number: "3"
                    },
                    {
                        image: capitecbanksliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: capitecbanksliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: capitecbanksliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: capitecbanksliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: capitecbanksliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: capitecbanksliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: capitecbanksliderimage11,
                        title: "wieland gliech - photographer",
                        number: "10"
                    },
                    {
                        image: capitecbanksliderimage12,
                        title: "initial illustrations",
                        number: "11"
                    },
                    {
                        image: capitecbanksliderimage13,
                        title: "",
                        number: "12"
                    },
                    {
                        image: paardevleisliderimage1,
                        title: "Paardevlei",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '23',
        title: 'Paardevlei',
        location: 'Somerset West, South Africa',
        year: '2020',
        image: projectsimage23,
        data: [
            paardevleiimage1,
            paardevleiimage2,
            paardevleiimage3,
            paardevleiimage4
        ],
        pagedata: [
            {
                Pagetitle: "Paardevlei",
                pagelocation: "Somerset West, South Africa",
                paragraphs: [
                    "Paardevlei Lifestyle Estate is one of several residential estates we’ve designed for Balwin Properties. The development is located in Somerset West.",
                    "The architectural form of the buildings transition from the historic crescent houses with their original red roof tiles, pitched roofs and shuttered sash windows, to the more modern aesthetic of the pitched roof duplexes and clubhouse. The apartment complex sits outside of the historic core and its architectural language is much more contemporary.",
                    "Restored family homes are located to the north of the site, adjacent to a row of semi-detached duplexes, designed to a more contemporary aesthetic that complements and respects their historic neighbours. To the south is a collection of apartment buildings comprising around 260 units in one-, two- and three-bedroomed configurations. These are arranged around a series of courtyards with extensive residents parking and storage below ground.",
                    "A large clubhouse includes a catered dining hall, arts and crafts centre, hairdressers, medical suites and a swimming pool. These community amenities open out onto an expansive green space with access to the network of pedestrian pathways that encircle the vlei."
                ],
                method: "David Southwood - Photographer",
                client: "Balwin Property Group",
                status: "built",
                year: "2020",
                services: ["architecture"],
                tags: [
                    "residential",
                    "mixed-use"
                ],
                location: "https://www.dhk.co.za/projects/paardevlei-lifestyle-estate#",
                sliderdata: [
                    {
                        image: paardevleisliderimage1,
                        title: "Paardevlei",
                        number: ""
                    },
                    {
                        image: paardevleisliderimage2,
                        title: "paardevlei lifestyle estate",
                        number: "1"
                    },
                    {
                        image: paardevleisliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: paardevleisliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: paardevleisliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: paardevleisliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: paardevleisliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: paardevleisliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: paardevleisliderimage9,
                        title: "paardevlei square",
                        number: "8"
                    },
                    {
                        image: paardevleisliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: paardevleisliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: paardevleisliderimage12,
                        title: "",
                        number: "11"
                    },
                    {
                        image: paardevleisliderimage13,
                        title: "",
                        number: "12"
                    },
                    {
                        image: sablecornersliderimage1,
                        title: "Sable Corner",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '24',
        title: 'Sable Corner',
        location: 'Cape Town, South Africa',
        year: '2020',
        image: projectsimage24,
        data: [
            sablecornerimage1,
            sablecornerimage2,
            sablecornerimage3
        ],
        pagedata: [
            {
                Pagetitle: "Sable Corner",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "Collaboration is at the heart of our work. We're proud to be working in association with U+A on a luxury residential development currently underway in the United Arab Emirates, located on Al Marjan Island in Ras Al Khaimah. Our team worked closely with U+A on the design philosophy, coordination and building information modelling (BIM) to create a luxurious yet functional living environment that harmonises with its beachfront location.",
                    "The Al Marjan Beach Club is a prestigious residential development nestled on Al Marjan Island in Ras Al Khaimah. Conveniently located just a 45-minute drive away from both Dubai and Sharjah International Airports, this exclusive enclave offers a luxurious lifestyle, featuring a total of 2000 residential and branded apartments.",
                    "With the breathtaking Arabian Peninsula as its backdrop, the development places a strong emphasis on family-oriented waterfront leisure, complemented by a robust wellness theme. Along the charming promenade, a delightful array of food and beverage options adds to the island's unique allure, solidifying its position as the ultimate destination for those seeking an upscale lifestyle by the water's edge."
                ],
                method: "Binyan + Red Vertex - Renders",
                client: "Aldar Properties",
                status: "on site",
                year: "2028",
                services: ["architecture", "urban design"],
                tags: [
                    "mixed-use",
                    "residential",
                    "hospitality"
                ],
                location: "https://maps.app.goo.gl/HLjRCMfL1BDo9k1KA",
                sliderdata: [
                    {
                        image: sablecornersliderimage1,
                        title: "Sable Corner",
                        number: ""
                    },
                    {
                        image: sablecornersliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: sablecornersliderimage3,
                        title: "view from bridgeway lane",
                        number: "2"
                    },
                    {
                        image: sablecornersliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: sablecornersliderimage5,
                        title: "view from sable road",
                        number: "4"
                    },
                    {
                        image: sablecornersliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: sablecornersliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: sablecornersliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: sablecornersliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: sablecornersliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: sablecornersliderimage11,
                        title: "adam letch - photographer",
                        number: "10"
                    },
                    {
                        image: cityliftsliderimage1,
                        title: "Citylift",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '25',
        title: 'Citylift',
        location: 'Cape Town, South Africa',
        year: '2019',
        image: projectsimage25,
        data: [
            cityliftimage1,
            cityliftimage2,
            cityliftimage3,
            cityliftimage4
        ],
        pagedata: [
            {
                Pagetitle: "Citylift",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "What should become of the unfinished bridges at the edge of the Cape Town CBD, which splice between the ocean and the city centre? This question has occupied the minds of city planners for decades as they seek solutions to create long-term value for the surrounding precinct and the city in general.",
                    "We formulated our answer to this question in 2016, when we worked in a coalition with nine other companies to submit an entry for a City of Cape Town competition to reimagine the Foreshore freeways. The CITYLIFT submission was an innovative masterplan that proposed dropping the elevated freeways to the ground and elevating the city over them. This scheme was intended to expand the Cape Town CBD and provide a new mixed-use neighbourhood with commercial, residential and cultural facilities, supported by the services and infrastructure to feed the new developments.",
                    "The plan had three components: extending the city to the harbour on the upper levels, creating strategic sub-surface underground mobility systems and developing a new linear park. The first step entailed demolishing the foreshore freeway bridge. The next step would be to lower the working freeway to the ground, and finally, to gradually elevate the city up over the underground freeway, raising and extending the city grid to about seven to ten metres above the existing ground level, which would lift the city above the moving public transport and cars below.",
                    "The competition project was cancelled by the City of Cape Town’s administration at the time."
                ],
                method: "",
                client: "City of Cape Town",
                status: "proposed",
                year: "2019",
                services: "urban design",
                tags: [
                    "urban design"
                ],
                location: "https://maps.app.goo.gl/GrnzWp1LvJk6v3Ku6",
                sliderdata: [
                    {
                        image: cityliftsliderimage1,
                        title: "Citylift",
                        number: ""
                    },
                    {
                        image: cityliftsliderimage2,
                        title: "proposed foreshore activation",
                        number: "1"
                    },
                    {
                        image: cityliftsliderimage3,
                        title: "illustrative masterplan",
                        number: "2"
                    },
                    {
                        image: cityliftsliderimage4,
                        title: "mobility from foreshore to city center",
                        number: "3"
                    },
                    {
                        image: cityliftsliderimage5,
                        title: "the city's development opportunities",
                        number: "4"
                    },
                    {
                        image: cityliftsliderimage6,
                        title: "linear park - axo",
                        number: "5"
                    },
                    {
                        image: cityliftsliderimage7,
                        title: "proposed cityscape - section",
                        number: "6"
                    },
                    {
                        image: cityliftsliderimage8,
                        title: "renewed precincts - vertical zoning",
                        number: "7"
                    },
                    {
                        image: cityliftsliderimage9,
                        title: "milnerton to sea point - enhanced activity + connection",
                        number: "8"
                    },
                    {
                        image: cityliftsliderimage10,
                        title: "infrastructure development - early illustrations",
                        number: "9"
                    },
                    {
                        image: delairegraffsliderimage1,
                        title: "Delaire Graff Estate Villa + Lodges",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '26',
        title: 'Delaire Graff Estate Villa + Lodges',
        location: 'Stellenbosch, South Africa',
        year: '2019',
        image: projectsimage26,
        data: [
            delairegraffimage1,
            delairegraffimage2,
            delairegraffimage3,
            delairegraffimage4,
            delairegraffimage5
        ],
        pagedata: [
            {
                Pagetitle: "Delaire Graff Estate Villa + Lodges",
                pagelocation: "Stellenbosch, South Africa",
                paragraphs: [
                    "Over the years we've added our design flair to the Delaire Graff Estate in Stellenbosch, world-renowned for its fine wine, exquisite interiors and commitment to celebrating African art. In 2009, we designed the winery, restaurant and tasting room. In 2019, we were selected to complete the accommodation offering, featuring a four-bedroom villa for the owner and six superior guest lodges. London-based David Collins Studio designed the interior spaces and our sister company dhk Interior Design implemented the London studio’s interior design concept with meticulous precision.",
                    "The brief from our client, Laurence Graff Wines, was to establish a new standard of luxury accommodation while creating closer connections to the greater estate. Refined and elegant, the villa and lodges are of exceptional quality with high-end finishes and careful detailing throughout. We introduced a selection of natural and raw materials, including solid French oak trusses, stone-clad walls, thatched roofs and extended timber terraces. The buildings further coalesce with the encompassing mountain and vineyard landscape due to the extensive landscaping.",
                    "The four-bedroom villa covers 660m² over two floors and sleeps up to eight guests. A notable element of the design is the impressive and welcoming arrival experience that includes a thatched porte cochere, stone-clad walls and water features. Meanwhile, the six lodges extend the luxuriousness of the villa, featuring natural materials, high-end finishes and opulent décor. In addition to a bedroom, the lodges also include a private living area, dressing room and ensuite bathroom."
                ],
                method: "David Collins Studio - Interior Design",
                method2: "dhki - Interior Design Implementation",
                method3: "Charles Russel + Wieland Gleich - Photographers",
                client: "Laurence Graff Wines",
                status: "built",
                year: "2019",
                services: ["architecture"],
                tags: [
                    "hospitality"
                ],
                location: "https://maps.app.goo.gl/thhBCjH6qx2dN2pS8",
                sliderdata: [
                    {
                        image: delairegraffsliderimage1,
                        title: "Delaire Graff Estate Villa + Lodges",
                        number: ""
                    },
                    {
                        image: delairegraffsliderimage2,
                        title: "owner's Villa",
                        number: "1"
                    },
                    {
                        image: delairegraffsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: delairegraffsliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: delairegraffsliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: delairegraffsliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: delairegraffsliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: delairegraffsliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: delairegraffsliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: delairegraffsliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: delairegraffsliderimage11,
                        title: "delaire guest lodges",
                        number: "10"
                    },
                    {
                        image: delairegraffsliderimage12,
                        title: "",
                        number: "11"
                    },
                    {
                        image: delairegraffsliderimage13,
                        title: "",
                        number: "12"
                    },
                    {
                        image: delairegraffsliderimage14,
                        title: "",
                        number: "13"
                    },
                    {
                        image: delairegraffsliderimage15,
                        title: "",
                        number: "14"
                    },
                    {
                        image: delairegraffsliderimage16,
                        title: "david collins studio - interior designer",
                        number: "15"
                    },
                    {
                        image: delairegraffsliderimage17,
                        title: "dhki - interior design implementation",
                        number: "16"
                    },
                    {
                        image: delairegraffsliderimage18,
                        title: "charles russel + wieland gleich - photographers",
                        number: "17"
                    },
                    {
                        image: parklandssliderimage1,
                        title: "Parklands College",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '27',
        title: 'Parklands College',
        location: 'Cape Town South Africa',
        year: '2019',
        image: projectsimage27,
        data: [
            parklandsimage1,
            parklandsimage2,
            parklandsimage3,
            parklandsimage4,
            parklandsimage5
        ],
        pagedata: [
            {
                Pagetitle: "Parklands College",
                pagelocation: "Cape Town South Africa",
                paragraphs: [
                    "Located in Cape Town, Parklands College is one of the leading independent schools South Africa. The school commissioned us to expand its campus to include a new innovation centre, in pursuit of its vision to be a leader in 21st century education practices, preparing learners for the challenges of life not only academically but also emotionally, socially, morally and physically. Our brief was to develop an exemplary school building that responds to and accommodates current and emerging best practice in teaching and learning. The development needed to respond to, reinforce and extend the existing collegiate campus structure and to create an iconic image for the school.",
                    "The centre comprises a series of adaptable rooms arranged around a central hub and a double-volume glazed atrium, wrapped in a perforated aluminium screen, with courtyards on either side. To meet this vision of the school’s future, we created a series of teaching venues to suit different learning methods. Three large collaboration rooms accommodate up to 90 learners. These can also be adapted to become two or three smaller learning spaces. Two large workshop-style rooms were designed to accommodate activities like robotics and an innovation lab for building and crafting. A large indoor recreational area can be used for informal gathering and self-study. This also includes an AV room for immersive digital experiences. Eleven general classrooms and a series of break-away spaces were also included.",
                    "Conceptually, the building was envisioned as two solid rectilinear wings separated by courtyards; The three large single-storey collaboration rooms were placed alongside the existing school quad with break-away rooms lining the northern flanks. The general classrooms and two specialist workshops comprise a longer wing which bends north, providing a distinctive, striking backdrop to the playing fields.",
                    "The two wings are simultaneously split and bound together by a large, steel-and-glass double-volume recreational atrium aptly named Grand Central. This forms the nucleus of the building. The atrium serves as a central movement hub and is also used for activities such as informal gatherings, impromptu performances, self-study and immersive digital experiences.",
                    "Overall, the architectural design is contemporary and elegantly simple. It makes a distinct departure from the existing style of the campus buildings, yet remains sympathetic to the overall, orthogonal planning. The building form was strongly influenced by the need to optimise spatial relationships while adhering to the basic tenets of good environmental design - particularly internal environmental comfort."
                ],
                method: "Dave Southwood - Photographer",
                client: "Parklands College",
                status: "built",
                year: "2019",
                services: "architecture",
                tags: [
                    "public + education",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/ZMp4cuzAqoiuhGi46",
                sliderdata: [
                    {
                        image: parklandssliderimage1,
                        title: "Parklands College",
                        number: ""
                    },
                    {
                        image: parklandssliderimage2,
                        title: "break-away pod",
                        number: "1"
                    },
                    {
                        image: parklandssliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: parklandssliderimage4,
                        title: "central atrium",
                        number: "3"
                    },
                    {
                        image: parklandssliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: parklandssliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: parklandssliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: parklandssliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: parklandssliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: parklandssliderimage10,
                        title: "perforated facade detail - graphic designers",
                        number: "9"
                    },
                    {
                        image: parklandssliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: parklandssliderimage12,
                        title: "early illustrations",
                        number: "11"
                    },
                    {
                        image: parklandssliderimage13,
                        title: "",
                        number: "12"
                    },
                    {
                        image: parklandssliderimage14,
                        title: "",
                        number: "13"
                    },
                    {
                        image: quadrantssliderimage1,
                        title: "Quadrant Gardens",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '28',
        title: 'Quadrant Gardens',
        location: 'Cape Town, South Africa',
        year: '2019',
        image: projectsimage28,
        data: [
            quadrantimage1,
            quadrantimage2,
            quadrantimage3
        ],
        pagedata: [
            {
                Pagetitle: "Quadrant Gardens",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "Quadrant Gardens, for Corevest, is a luxury urban retirement development in Cape Town, comprising 74 apartments over six stories arranged around a landscaped courtyard. The design approach for this project was to provide high quality accommodation to enable residents to enjoy their golden years in a well-designed environment supported by the necessary social, medical and leisure facilities on site. This is the fourth phase of the Quadrant Precinct and it is separated into three distinct blocks.",
                    "A bold facebrick cube marks the entrance with a slender steel entrance canopy and clerestory glazing. The remaining two blocks complement the existing phases in terms of colours and façade finishes. The design incorporates level changes to create a high ceiling and spacious entrance level. Apartments overlooking the courtyard are elevated by 1.5 metres for greater privacy. A split-level entrance ramp ensures easy access to the main entrance podium and structured parking below.",
                    "Recreational facilities include an entrance-level library, lounge and serviced dining area with large sliding doors seamlessly connecting these facilities with the courtyard. A rooftop glasshouse, croquet lawn and planting complete the shared facilities. The development includes a21-bed frail-care facility where medical staff are on call 24/7. This facility also features a dedicated lounge and dining area. All apartments have panic buttons and intercom access to a central nursing station."
                ],
                method: "",
                client: "Corevest",
                status: "built",
                year: "2019",
                services: "architecture",
                tags: [
                    "residential"
                ],
                location: "https://maps.app.goo.gl/u6b8eJivqqEn2sv66",
                sliderdata: [
                    {
                        image: quadrantssliderimage1,
                        title: "Quadrant Gardens",
                        number: ""
                    },
                    {
                        image: quadrantssliderimage2,
                        title: "central quad",
                        number: "1"
                    },
                    {
                        image: quadrantssliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: quadrantssliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: quadrantssliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: quadrantssliderimage6,
                        title: "vehicular access",
                        number: "5"
                    },
                    {
                        image: quadrantssliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: quadrantssliderimage8,
                        title: "early illustrations",
                        number: "7"
                    },
                    {
                        image: quadrantssliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: quadrantssliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: quadrantssliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: areapilisliderimage1,
                        title: "Area Pili Masterplan",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '29',
        title: 'Area Pili Masterplan',
        location: 'Venice, Italy',
        year: '2018',
        image: projectsimage29,
        data: [
            areapiliimage1,
            areapiliimage2,
            areapiliimage3,
            areapiliimage4
        ],
        pagedata: [
            {
                Pagetitle: "Area Pili Masterplan",
                pagelocation: "Venice, Italy",
                paragraphs: [
                    "Collaboration is at the heart of our work. We're proud to be working in association with U+A on a luxury residential development currently underway in the United Arab Emirates, located on Al Marjan Island in Ras Al Khaimah. Our team worked closely with U+A on the design philosophy, coordination and building information modelling (BIM) to create a luxurious yet functional living environment that harmonises with its beachfront location.",
                    "The Al Marjan Beach Club is a prestigious residential development nestled on Al Marjan Island in Ras Al Khaimah. Conveniently located just a 45-minute drive away from both Dubai and Sharjah International Airports, this exclusive enclave offers a luxurious lifestyle, featuring a total of 2000 residential and branded apartments.",
                    "With the breathtaking Arabian Peninsula as its backdrop, the development places a strong emphasis on family-oriented waterfront leisure, complemented by a robust wellness theme. Along the charming promenade, a delightful array of food and beverage options adds to the island's unique allure, solidifying its position as the ultimate destination for those seeking an upscale lifestyle by the water's edge."
                ],
                method: "Binyan + Red Vertex - Renders",
                client: "Aldar Properties",
                status: "on site",
                year: "2028",
                services: "architecture, urban design",
                tags: [
                    "mixed-use",
                    "residential",
                    "hospitality"
                ],
                location: "https://maps.app.goo.gl/HLjRCMfL1BDo9k1KA",
                sliderdata: [
                    {
                        image: areapilisliderimage1,
                        title: "Area Pili Masterplan",
                        number: ""
                    },
                    {
                        image: areapilisliderimage2,
                        title: "tower + arena proposal",
                        number: "1"
                    },
                    {
                        image: areapilisliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: areapilisliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: areapilisliderimage5,
                        title: "illustrative masterplan",
                        number: "4"
                    },
                    {
                        image: areapilisliderimage6,
                        title: "section types",
                        number: "5"
                    },
                    {
                        image: areapilisliderimage7,
                        title: "3d perspective sketches",
                        number: "6"
                    },
                    {
                        image: areapilisliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: areapilisliderimage9,
                        title: "concept diagram",
                        number: "8"
                    },
                    {
                        image: areapilisliderimage10,
                        title: "precinct programme",
                        number: "9"
                    },
                    {
                        image: areapilisliderimage11,
                        title: "vehicular + pedestrian movement",
                        number: "10"
                    },
                    {
                        image: areapilisliderimage12,
                        title: "green space",
                        number: "11"
                    },
                    {
                        image: areapilisliderimage13,
                        title: "initial sketch",
                        number: "12"
                    },
                    {
                        image: axissliderimage1,
                        title: "Axis",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '30',
        title: 'Axis',
        location: 'Cape Town, South Africa',
        year: '2018',
        image: projectsimage30,
        data: [
            axisimage1,
            axisimage2,
            axisimage3,
            axisimage4
        ],
        pagedata: [
            {
                Pagetitle: "Axis",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "The Axis apartment block occupies a prominent corner position in Century City, Cape Town and was designed to capitalise on enviable views of Table Mountain and the Atlantic Ocean. The design was conceived as a monolith with indentations and cut-outs to add surprise and interest to the form. Designed for Rabie Property Group, it comprises 85 luxury residential apartments and penthouses, supplemented with small-scale commercial and retail space at ground level.",
                    "The compact form of the building wraps around itself and rises gradually to its full 11storey height. Consequently, most apartments are oriented towards views of Cape Town and the mountain. Visual ‘gashes’ add interest to the façade. The unique doughnut-shaped structure includes sheltered walkway spaces that offer glimpses of the city and offer a sense of connection with the outside world. The rising form cuts away, creating dynamic terraces and activity at differing heights, culminating in generous penthouse units.",
                    "A deep fissure at the heart of the building creates a contrasting negative space as the building form wraps around itself. This deep 30m x 13m space acts as alight chasm that catches the north light and delivers it through the whole building to the lowest floors. At the base is a courtyard made up of a white-painted face brick fenestration that creates an alternate world inside the building. The rustic textured nature of this area was intentionally designed to complement the smooth, sleek external cladding. A series of transparent glazed commercial and public spaces surround the courtyard. The courtyard spills out onto landscaped gardens, offering 360-degree views and connecting the internal areas to the outside environment. Inside the courtyard, a highly reflective aluminum material wraps the bottom escape staircase, emulating a mirror, and challenging residents to look up.",
                    "Each apartment was meticulously designed to optimise views and light and to provide generous spaces that extend to ample external terraces. Axis was a welcome addition to the vibrant, mixed-use Bridgeways Precinct in Century City when it was completed in 2018. Other developments in the area include commercial twin developments Sable Park and Bridge Park, which we also designed. Click to read more about these projects."
                ],
                method: "Dave Southwood + Wieland Gleich - Photographers",
                client: "Rabie Property Group",
                status: "built",
                year: "2018",
                services: ["architecture"],
                tags: [
                    "residential"
                ],
                location: "https://maps.app.goo.gl/4UMW9qZH3YQQfitN9",
                sliderdata: [
                    {
                        image: axissliderimage1,
                        title: "Axis",
                        number: ""
                    },
                    {
                        image: axissliderimage2,
                        title: "primary entrance",
                        number: "1"
                    },
                    {
                        image: axissliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: axissliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: axissliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: axissliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: axissliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: axissliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: axissliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: axissliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: axissliderimage11,
                        title: "dave southwood + wieland gleich - photographers",
                        number: "10"
                    },
                    {
                        image: batteryparksliderimage1,
                        title: "Battery Park",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '31',
        title: 'Battery Park',
        location: 'Cape Town, South Africa',
        year: '2018',
        image: projectsimage31,
        data: [],
        pagedata: [
            {
                Pagetitle: "Battery Park",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "Battery Park is a 12000 sqm (1.2 hectare) urban park situated at a key entranceway to one ofAfrica’s most visited tourist destinations, the V&A Waterfront in CapeTown, South Africa. The brief from our clients, the V&A Waterfront, was tocreate a publicly accessible park which lies at the nexus of multiple newpedestrian routes, stitching the new district into the surrounding urban fabricand helping to invigorate the area. The park forms part of an urban designframework we created for the V&A Waterfront’s previously under-used CanalDistrict. In 2024, work commenced on 5 Dock Road, a luxury residentialdevelopment, which completes the masterplan vision.",
                    "The projectcomprises a park and piazza constructed over a 1 206-bay parking facility. Newpedestrian routes have reinvigorated the precinct with activity of park users,office workers and passing pedestrian traffic. The site is of archaeologicalimportance: it contains the remnants of the Amsterdam Battery, a coastalfortification that is one of the oldest structures in the city. This provided aunique opportunity for us to pay homage to the historic landmark while providinga contemporary public leisure space and parking facilities.",
                    "dhk’s response hascreated a new hub of activity within the V&A Waterfront. It has preservedthe heritage of the Amsterdam Battery, once a place of exclusion andincarceration, and transformed it into a public space designed to support andengage the greater Cape Town community.",
                    "Historical datumsrevealed through archaeological excavations were used to inform the design. Wemaintained the historical courtyard level for the raised park, demarcated byplanted edges above the new retail piazza, to represent the estimated naturalground level that fronted the battery. Other architectural and landscapedelements reflect the structure’s original footprint, such as semi-circularcurved pathways, concrete additions to the rear ramparts, splayed canal-facingwalls and concrete-clad structures. This was done to give visitors an authenticsense of the battery’s former size. An axial visual connection to Cape Town’sNoon Gun on Signal Hill was retained to preserve the site’s historic sightline.",
                    "A precast concretepanel structure – dubbed the interpretation pavilion – was built to theestimated height of the battery’s original walls. This links the park, piazzaand parking facility via internal elevators. The interpretation paviliondisplays historic cannons from Amsterdam Battery, thanks to research by theCannon Association of South Africa. These were found scattered throughout the V&A Waterfront and preserved as part of the project’s historical reference. Three small openings form part of the structure’s canal-facing wall to resemblecannon embrasures."
                ],
                method: "",
                client: "V&A Waterfront",
                status: "built",
                year: "2018",
                services: ["architecture", "urban design"],
                tags: [
                    "public + education",
                    "urban design"
                ],
                location: "https://maps.app.goo.gl/DJqZG6Nzi85vkE8Q6",
                sliderdata: [
                    {
                        image: batteryparksliderimage1,
                        title: "Battery Park",
                        number: ""
                    },
                    {
                        image: batteryparksliderimage2,
                        title: "pedestrian view from dock road",
                        number: "1"
                    },
                    {
                        image: batteryparksliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: batteryparksliderimage4,
                        title: "heritage component",
                        number: "3"
                    },
                    {
                        image: batteryparksliderimage5,
                        title: "public amenities",
                        number: "4"
                    },
                    {
                        image: batteryparksliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: batteryparksliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: batteryparksliderimage8,
                        title: "pedestrian entrance from de waterkant",
                        number: "7"
                    },
                    {
                        image: batteryparksliderimage9,
                        title: "modern-build mirrors heritage + original fort",
                        number: "8"
                    },
                    {
                        image: batteryparksliderimage10,
                        title: "site visit - 2022",
                        number: "9"
                    },
                    {
                        image: batteryparksliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: conradieparksliderimage1,
                        title: "Conradie Park",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '32',
        title: 'Conradie Park',
        location: 'Cape Town, South Africa',
        year: '2018',
        image: projectsimage32,
        data: [
            conradieparkimage1,
            conradieparkimage2,
            conradieparkimage3,
            conradieparkimage4,
            conradieparkimage5
        ],
        pagedata: [
            {
                Pagetitle: "Conradie Park",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "The Conradie Park Better Living Model is a groundbreaking 22-hectare mixed-use development in Cape Town, launched in 2018. The brief was to develop an innovative model for high-density, integrated residential communities, as part of the Western Cape Government’s commitment to delivering sustainable, affordable housing supported by schools, shops and places to work. The clients also wanted a development that looked and felt modern, safe, spacious, connected, affordable and practical for everyday living.",
                    "Developed on the site of the former Conradie Hospital, this R3 billion project is a public-private partnership between Concor and the Western Cape Government. Conradie Park is a mixed-use neighbourhood comprising housing, commercial uses, retail units, a school and sports facilities. The residential accommodation provides 3 602 units, of which 1 794 are grant-funded, affordable units. The project stands out for its inclusivity, offering a mix of social, affordable and open market housing within the same development.",
                    "We’re delivering the project in association with Jakupa Architects and Urban Designers and collaborated with Green Inc on the landscaping. Own Haven Housing Association is the social housing partner. Completion is expected by 2029. We conceptualised the full design for the site, including the urban design framework, architecture, public open spaces, landscaping, streets and pedestrian walkways, courtyards, parks and squares. The architectural scale and spatial configuration present a common visual language, creating the effect of a more urban district or suburb than housing estate. No visual or other coding distinguishes visually between accommodation for residents with different income levels, ensuring a more democratic, inclusive housing mix.",
                    "Small block sizes with a fine-grain network of streets and pedestrian walkways facilitate pedestrian permeability. A perimeter block forms a traditional design component to create protected space and facilitate greater surveillance. The site also features original heritage structures dating back to the first half of the 20th century. These have been retained for community use.",
                    "The design integrates urban design into the overall architectural vision. Buildings sit within a continuous public realm network of streets, squares, parks and piazzas, with generous tree-lined sidewalks and a linear park called Grande Park. The grid rotation aligns to the geometry of the canal and linear park along the southeast boundary of the site, creating a well-defined park edge. This layout maximises solar orientation for most apartments. Strong public edges contrast the softer, landscaped courtyards which are secure, private spaces.",
                    "The scheme prioritises pedestrians, with wide sidewalks and a streetscape that functions as part of the public space network instead of simply accommodating cars. Footpaths and cycling paths are part of an integrated non-motorised transport (NMT) plan. Green technologies support energy, water and waste management practices."
                ],
                method: "Sean Gibson - Photographer",
                client: "Concor",
                status: "on site",
                year: "2018",
                services: ["urban design", "architecture"],
                tags: [
                    "urban design",
                    "residential",
                    "mixed-use",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/QWBFexBBoDm6bPZz6",
                sliderdata: [
                    {
                        image: conradieparksliderimage1,
                        title: "Conradie Park",
                        number: ""
                    },
                    {
                        image: conradieparksliderimage2,
                        title: "private ownership + social housing options",
                        number: "1"
                    },
                    {
                        image: conradieparksliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: conradieparksliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: conradieparksliderimage5,
                        title: "central quads",
                        number: "4"
                    },
                    {
                        image: conradieparksliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: conradieparksliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: conradieparksliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: conradieparksliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: conradieparksliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: conradieparksliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: conradieparksliderimage12,
                        title: "",
                        number: "11"
                    },
                    {
                        image: conradieparksliderimage13,
                        title: "",
                        number: "12"
                    },
                    {
                        image: conradieparksliderimage14,
                        title: "initial illustrations",
                        number: "13"
                    },
                    {
                        image: conradieparksliderimage15,
                        title: "",
                        number: "14"
                    },
                    {
                        image: conradieparksliderimage16,
                        title: "",
                        number: "15"
                    },
                    {
                        image: conradieparksliderimage17,
                        title: "",
                        number: "16"
                    },
                    {
                        image: conradieparksliderimage18,
                        title: "one bedroom apartment",
                        number: "17"
                    },
                    {
                        image: conradieparksliderimage19,
                        title: "one bedroom apartment - axo",
                        number: "18"
                    },
                    {
                        image: norvalsliderimage1,
                        title: "Norval Foundation",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '33',
        title: 'Norval Foundation',
        location: 'Cape Town, South Africa',
        year: '2018',
        image: projectsimage33,
        data: [
            norvalimage1,
            norvalimage2,
            norvalimage3,
            norvalimage4,
            norvalimage5
        ],
        pagedata: [
            {
                Pagetitle: "Norval Foundation",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "Norval Foundation is a modern pavilion for art set against a dramatic mountain and vineyard landscape on the slopes of the Constantiaberg Mountain in Cape Town. The client brief by Village Trust was to create a world-class art and cultural centre in an exceptional location that would be open to the public. Our response to this brief was to present a pure expression of architectural form.",
                    "The design responds to its linear site set between a busy road and an existing wetland, opposite a neighbouring embassy compound. The linear circulation spine is positioned along this edge, with galleries and public spaces facing the natural landscape, capturing framed views of the wetland, vineyards and mountains beyond. The design strikes a balance between two motivations: to protect the artwork within and maximise views to the natural landscape outside. The building sits in an elevated position. It shields a wetland, creating a private space for the sculpture garden and forming an inhabited threshold between public and private zones. A triple-volume atrium establishes a deliberate visual connection between these two zones; one urban, the other natural. This provides a physical transition between these contrasting environments.",
                    "The building is a bold rectangular mass, delineating its heavy-walled enclosure and light over-sailing roof. It’s experienced in a linear sequence. A curved wall extends into the entrance court, drawing visitors past the double-volume restaurant, gallery shop and into the generous reception. From here, visitors are directed to the central atrium which announces the main galleries. The materials palette is raw and honest, comprising primarily precast concrete, natural timber, granite and glass. This creates a striking contrast against the natural landscape. The primary internal and external finish is a combination of polished concrete, smooth class one precast concrete panels and textured precast concrete panels. Externally, the precast concrete is finished with a chamfered tartan grid, which draws the eye upwards and lengthways, emphasising the scale of the building. Internally, timber panelling brings warmth to the spaces.",
                    "The site incorporates an existing sensitive wetland ecosystem that had been historically neglected. The wetland was completely rehabilitated. Alien species were removed and its surrounding buffer zones were revived and replanted with locally indigenous fynbos, enhanced by other indigenous plants and naturalised species to attract a multitude of insects and birds onto the site. A landscaped sculpture park was introduced, bringing bold artworks into the wetland environment. Sustainability features include solar photovoltaic panels on the roof, a building management system to optimise performance, water saving measures, grey water purification system, return of storm water to the wetland system, and energy efficient glazing and solar shading on the façade. Wherever possible, natural light to the internal spaces has been maximised, with large full height and clerestory windows throughout, except for certain galleries."
                ],
                method: "Dave Southwood + Wieland Gleich - Photographers",
                client: "Village Trust",
                status: "built",
                year: "2018",
                services: ["architecture"],
                tags: [
                    "public + education"
                ],
                location: "https://maps.app.goo.gl/fNRmRJaChUZPwGjR8",
                sliderdata: [
                    {
                        image: norvalsliderimage1,
                        title: "Norval Foundation",
                        number: ""
                    },
                    {
                        image: norvalsliderimage2,
                        title: "primary entrance",
                        number: "1"
                    },
                    {
                        image: norvalsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: norvalsliderimage4,
                        title: "museum reception",
                        number: "3"
                    },
                    {
                        image: norvalsliderimage5,
                        title: "upstairs - wine bar",
                        number: "4"
                    },
                    {
                        image: norvalsliderimage6,
                        title: "view from the sculpture garden",
                        number: "5"
                    },
                    {
                        image: norvalsliderimage7,
                        title: "dave southwood - photographer",
                        number: "6"
                    },
                    {
                        image: norvalsliderimage8,
                        title: "east + west façade - elevations",
                        number: "7"
                    },
                    {
                        image: norvalsliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: norvalsliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: norvalsliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: norvalsliderimage12,
                        title: "",
                        number: "11"
                    },
                    {
                        image: norvalsliderimage13,
                        title: "weiland gleich - photographer",
                        number: "12"
                    },
                    {
                        image: sableparksliderimage1,
                        title: "Sable Park",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '34',
        title: 'Sable Park',
        location: 'Cape Town, South Africa',
        year: '2018',
        image: projectsimage34,
        data: [
            sableparkimage1,
            sableparkimage2,
            sableparkimage3,
            sableparkimage4,
            sableparkimage5
        ],
        pagedata: [
            {
                Pagetitle: "Sable Park",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "Sable Park is a commercial development we designed for Rabie Property Group in Century City, Cape Town, in 2018. Located at the southern edge of the thriving Bridgeways Precinct, it’s one of several dhk-designed buildings in the area. Our client Rabie Property Group needed a viable building that would sit at a prominent entry point into Century City, Cape Town, forming a recognisable front face for the suburb.",
                    "The development’s composition was inspired by shuffling multiple forms that operate independently while relating to their immediate context. The development was intentionally designed to appear as a single large complex and simultaneously as four small independent volumes depending on where it is viewed from. The four volumes are further broken down into thirds, a double height layered mass and a single height crystalline cube. Each of these thirds shift and jump on the horizontal and vertical plain to achieve maximum views and optimal orientation. A large part of the buildings’ concept was manifested in its structure, creating distinct floating boxes that veer off and cantilever beyond one another.",
                    "Internally, the buildings have two wings with a central core and full height atrium bringing light into the centre of the expansive floor plates. The wings are connected by a series of bridges spanning across the atrium at the edge of the main core. The core is a stand-alone element which is exposed on both sides of the building. From the rear, this concrete cube protrudes and is visible from over a kilometre away. It forms the proverbial ‘heart’ of the building, circulating people left to right, up and down and into different chambers in the building.",
                    "Each building encloses a landscaped courtyard, bringing nature into the very fabric of the structures and provides outdoor breakaway places for staff. On the upper levels, a wrap-around terrace takes advantage of the buildings’ prime position, providing additional outdoor spaces for the offices located on this level Sable Park office development holds a 5-Star Green Star Office v1.1 Design certification from the Green Building Council of South Africa. It is one of several buildings we’ve designed in Century City. Also located in the precinct is Bridge Park, a twin development with over 18 000 sqm of premium grade office space, and Axis, a development with 85 luxury residential apartments and penthouses, supplemented with small-scale commercial and retail space at ground level."
                ],
                method: "Dave Southwood + Wieland Glleich - Photographers",
                client: "Rabie Property Group",
                status: "built",
                year: "2018",
                services: ["architecture"],
                tags: [
                    "office",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/javTyR8BrpsiND4e7",
                sliderdata: [
                    {
                        image: sableparksliderimage1,
                        title: "Sable Park",
                        number: ""
                    },
                    {
                        image: sableparksliderimage2,
                        title: "Sable Park",
                        number: "1"
                    },
                    {
                        image: sableparksliderimage3,
                        title: "view from bridgeway lane",
                        number: "2"
                    },
                    {
                        image: sableparksliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: sableparksliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: sableparksliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: sableparksliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: sableparksliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: sableparksliderimage9,
                        title: "dave southwood + wieland geilich - photographers",
                        number: "8"
                    },
                    {
                        image: sableparksliderimage10,
                        title: "wbho - drone shots",
                        number: "9"
                    },
                    {
                        image: sableparksliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: waterwayhousesliderimage1,
                        title: "Waterway House",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '35',
        title: 'Waterway House',
        location: 'Cape Town, South Africa',
        year: '2017',
        image: projectsimage35,
        data: [
            waterwayhouseimage1,
            waterwayhouseimage2,
            waterwayhouseimage3,
            waterwayhouseimage4
        ],
        pagedata: [
            {
                Pagetitle: "Waterway House",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "Located at the V&A Waterfront in Cape Town, Waterway House is a commercial development comprising two four-storey buildings over a shared basement. The building was the first of our projects in the area, in the first phase of the area’s redevelopment. We’ve since designed Battery Park and 5 Dock Road, the recently launched residential project that kickstarts the second phase of the masterplan to be implemented alongside Battery Park",
                    "The brief by the V&A Waterfront was to design a gateway building to the vibrant mixed-use Canal District neighbourhood. The development occupies a narrow linear site between the canal and Dock Road, the key access route into the V&A Waterfront from the city.",
                    "Our response to the brief was to create a viable commercial building that provides sufficient floor space for users to allow for maximum flexibility. Each building is fragmented by a generous entrance, atrium and circulation core, breaking the building up into two further segments. The space between the buildings creates a view corridor from Table Bay to the Noon Gun on Signal Hill and aligns with the bridge over the canal that connects the site to the rest of the Canal District.",
                    "The recessed ground floor façade creates generous, sheltered walkways with retail frontage along the full length of the building. This activates the busy pedestrian route along Dock Road. At the same time, ground floor is also slightly raised above the road and pavement level giving the retail space greater visibility from Dock Road. The floor to ceiling height at this level is nearly 1.5 times that of the office floors above, creating a solid yet transparent base to the building, with views through the retail units to the canal and urban park beyond.",
                    "Waterway House features a crystalline glass façade which adds lightness. The façade is animated by reflections of the water-based activity on the canal. The integrated façade system comprises a combination of vision, fritted and spandrel panels designed to maximise natural light penetration into the offices. Aluminium fins help to control solar heat gain and glare. Each building culminates at the ends in a fully glazed cantilevered element. Screened terraces on every floor provide breakaway spaces for the offices, which enjoy striking city views to the south and harbour views to the north.",
                    "The building’s eyebrow unifies the two buildings and also practically conceals the anchor system for rope access window cleaners. Habitable bridges link the buildings on the second and third floors. These enable the two buildings to operate independently or as a single entity.",
                    "Waterway House also exemplifies our commitment to sustainability. It was designed according to best practice green principles and holds a 5-Star Green Star SA Design rating by the Green Building Council of South Africa."
                ],
                method: "Wieland Gleich - Photographer",
                client: "V&A Waterfront",
                status: "built",
                year: "2017",
                services: ["architecture", "urban design"],
                tags: [
                    "mixed-use",
                    "office",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/q99xqUjUXJJbALnq5",
                sliderdata: [
                    {
                        image: waterwayhousesliderimage1,
                        title: "Waterway House",
                        number: ""
                    },
                    {
                        image: waterwayhousesliderimage2,
                        title: "jean van meulen - photographer",
                        number: "1"
                    },
                    {
                        image: waterwayhousesliderimage3,
                        title: "view from alfred street - 2016",
                        number: "2"
                    },
                    {
                        image: waterwayhousesliderimage4,
                        title: "carriages - initial concept",
                        number: "3"
                    },
                    {
                        image: waterwayhousesliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: waterwayhousesliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: waterwayhousesliderimage7,
                        title: "custom façade solution",
                        number: "6"
                    },
                    {
                        image: waterwayhousesliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: waterwayhousesliderimage9,
                        title: "view from battery park - 2019",
                        number: "8"
                    },
                    {
                        image: waterwayhousesliderimage10,
                        title: "Wieland Gleich - Photographer",
                        number: "9"
                    },
                    {
                        image: waterwayhousesliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: waterwayhousesliderimage12,
                        title: "revolving door detail - custom print",
                        number: "11"
                    },
                    {
                        image: waterwayhousesliderimage13,
                        title: "early illustration",
                        number: "12"
                    },
                    {
                        image: waterwayhousesliderimage14,
                        title: "initial site plan - 2016",
                        number: "13"
                    },
                    {
                        image: baywestmallsliderimage1,
                        title: "Baywest Mall",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '36',
        title: 'Baywest Mall',
        location: 'Gqeberha, South Africa',
        year: '2015',
        image: projectsimage36,
        data: [
            baywestmallimage1,
            baywestmallimage2,
            baywestmallimage3,
            baywestmallimage4
        ],
        pagedata: [
            {
                Pagetitle: "Baywest Mall",
                pagelocation: "Gqeberha, South Africa",
                paragraphs: [
                    "Baywest Mall was developed in a joint venture by Abacus Asset Management and Billion Group on the urban edge of Gqeberha in the Eastern Cape. The brief was to design a 90 000m² super regional mall that would cater for various needs. It was envisaged as a catalyst for the Baywest City precinct development and the expansion of the city of Gqeberha. The centre is the largest retail development in the Eastern Cape, with over 250 shops over two levels catering for an estimated 800 000 visitors a month.",
                    "The success of the design lies in its simple plan: a crossed ring mall with retail anchors in each corner. The clearly defined vehicle and pedestrian entrances are on axis with the parking zones conveniently situated close to entrances. This allows for fast direct access and emphasises the arrival experience for shoppers. The parking cells are also interconnected for ease of access to any entrance. Back-of-house servicing is accessed either directly from the four anchor corners or from below ground via a basement tunnel and centrally located service lifts that feed both levels of retail."
                ],
                method: "Wieland Gleich - Photographer",
                client: "Abacus Asset Management + Billion Group",
                status: "built",
                year: "2015",
                services: ["architecture"],
                tags: [
                    "retail"
                ],
                location: "https://maps.app.goo.gl/iv2fsyWdR3zW3ams9",
                sliderdata: [
                    {
                        image: baywestmallsliderimage1,
                        title: "Baywest Mall",
                        number: ""
                    },
                    {
                        image: baywestmallsliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: baywestmallsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: baywestmallsliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: baywestmallsliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: baywestmallsliderimage6,
                        title: "wieland gleich - photographer",
                        number: "5"
                    },
                    {
                        image: bridgeparksliderimage1,
                        title: "Bridge Park",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '37',
        title: 'Bridge Park',
        location: 'Cape Town, South Africa',
        year: '2015',
        image: projectsimage37,
        data: [
            bridgeparkimage1,
            bridgeparkimage2,
            bridgeparkimage3,
            bridgeparkimage4
        ],
        pagedata: [
            {
                Pagetitle: "Bridge Park",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "Developed in a joint venture between Rabie Property Group and Growthpoint Properties, Bridge Park is a commercial development in the Bridgeways Precinct in Century City, Cape Town. We were commissioned to design a functional office space, not just in terms of environmental factors but the overall user experience of the building.",
                    "The two buildings, Bridge Park West and Bridge Park East, occupy a central position within the mixed-use precinct, taking advantage of its panoramic views and access to transport routes. Each four-storey building is positioned on a podium, with a recessed façade at ground level, providing shade to the fully glazed ground floor.",
                    "A full height glazed setback in the façade articulates the main entrance. The façade of the office floors is of aluminium panelling. This is punctuated with vertical glazing, providing ample daylight to the workspaces and views throughout the building. Each building encloses a landscaped courtyard, bringing nature into the fabric of the building and providing outdoor breakaway places for staff. In 2015, the Green Building Council of South Africa awarded a 5-Star Green Star Office rating v1 Design rating recognising Bridge Park’s sustainable design principles."
                ],
                method: "Wieland Gleich - Photographer",
                client: "Rabie Property Group + Growth Point Properties",
                status: "built",
                year: "2015",
                services: ["architecture"],
                tags: [
                    "office",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/68v2pgYBoQi3hJMw8",
                sliderdata: [
                    {
                        image: bridgeparksliderimage1,
                        title: "Bridge Park",
                        number: ""
                    },
                    {
                        image: bridgeparksliderimage2,
                        title: "view from sable way",
                        number: "1"
                    },
                    {
                        image: bridgeparksliderimage3,
                        title: "pedestrian entrance - facing bridgeway",
                        number: "2"
                    },
                    {
                        image: bridgeparksliderimage4,
                        title: "facade details",
                        number: "3"
                    },
                    {
                        image: bridgeparksliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: bridgeparksliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: bridgeparksliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: bridgeparksliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: bridgeparksliderimage9,
                        title: "primary reception area",
                        number: "8"
                    },
                    {
                        image: bridgeparksliderimage10,
                        title: "outdoor quads",
                        number: "9"
                    },
                    {
                        image: bridgeparksliderimage11,
                        title: "interior quad",
                        number: "10"
                    },
                    {
                        image: bridgeparksliderimage12,
                        title: "",
                        number: "11"
                    },
                    {
                        image: bridgeparksliderimage13,
                        title: "wieland gleich - photographer",
                        number: "12"
                    },
                    {
                        image: bridgeparksliderimage14,
                        title: "east + west wings - elevation",
                        number: "13"
                    },
                    {
                        image: bridgeparksliderimage15,
                        title: "inhouse - early illustrations",
                        number: "14"
                    },
                    {
                        image: bridgeparksliderimage16,
                        title: "",
                        number: "15"
                    },
                    {
                        image: bridgeparksliderimage17,
                        title: "",
                        number: "16"
                    },
                    {
                        image: bridgeparksliderimage18,
                        title: "",
                        number: "17"
                    },
                    {
                        image: dainfernsliderimage1,
                        title: "Dainfern Square",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '38',
        title: 'Dainfern Square',
        location: 'Johannesburg, South Africa',
        year: '2015',
        image: projectsimage38,
        data: [
            dainfernimage1,
            dainfernimage2,
            dainfernimage3
        ],
        pagedata: [
            {
                Pagetitle: "Dainfern Square",
                pagelocation: "Johannesburg, South Africa",
                paragraphs: [
                    "Dainfern Square is a retail development in Johannesburg. Abacus Asset Management briefed us to design a space that combined 14 952m² of retail, banks and restaurants on the ground floor and 7 835m² of offices and a gym on the first floor. There was also a requirement for parking on the ground floor level and in two levels of basement.",
                    "The building’s form is defined by a solid frame with floor to ceiling glazing that draws in abundant natural light and connects to views of the landscape beyond. The centre is positioned on the edges of the site, creating a central arrival point that invites the users into the heart of the building. A combination of internal and external walkways and courtyards surrounded by retail and restaurants open out onto these spaces. This approach breaks up the footprint of the plan into smaller defined spaces. The result is a modern centre with a village feel to provide a unique shopping and dining experience. Walkways covered by large roof lights connect the mall to separately defined office blocks which look out onto the mall spaces.",
                    "In 2016, Dainfern Square won a Retail Design and Development award at the South African Council of Shopping Centres Congress."
                ],
                method: "Wieland Gleich - Photographer",
                client: "Abacus Asset Management",
                status: "built",
                year: "2015",
                services: ["architecture"],
                tags: [
                    "retail",
                    "office"
                ],
                location: "https://maps.app.goo.gl/Kusm9wJ1UnP67SgL6",
                sliderdata: [
                    {
                        image: dainfernsliderimage1,
                        title: "Dainfern Square",
                        number: ""
                    },
                    {
                        image: dainfernsliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: dainfernsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: dainfernsliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: dainfernsliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: dainfernsliderimage6,
                        title: "wieland gleich - photographer",
                        number: "5"
                    },
                    {
                        image: newtownsliderimage1,
                        title: "Newtown Junction",
                        number: ""
                    }
                ]
            }
        ]
    },
    {
        number: '39',
        title: 'Newtown Junction',
        location: 'Johannesburg, South Africa',
        year: '2015',
        image: projectsimage39,
        data: [
            newtownimage1,
            newtownimage2,
            newtownimage3,
            newtownimage4,
            newtownimage5
        ],
        pagedata: [
            {
                Pagetitle: "Newtown Junction",
                pagelocation: "Johannesburg, South Africa",
                paragraphs: [
                    "Newtown Junction is an 85 000m² mixed-use development in the west of Johannesburg’s central business district (CBD). Our clients, Atterbury Property Development Company, envisioned Newtown Junction to be an important commercial catalyst for the Newtown area, a precinct long established as the cultural heart of the city. They wanted the development to provide new retail and office space and reinvigorate the existing arts and entertainment venues, representing a substantial investment in inner city regeneration.",
                    "The site is bounded by significant buildings including the Market Theatre and Museum Africa, Mary Fitzgerald Square, the M1 freeway overpass and Nelson Mandela Bridge. It contains several historic structures such as the Potato Shed, Edwardian railway sidings and smaller heritage buildings such as the Majestic complex, an Edwardian toilet block, and the popular Kippies Jazz Club.",
                    "A significant approach was to retain the heritage elements of the site. In particular, the historic Potato Sheds were dismantled, fully restored and reinstated on site in their original position. The Edwardian railway bridge was also restored and re-established as a link between the existing Market Theatre and the adjacent new buildings.",
                    "It was important to ensure the new buildings could respond clearly to the surrounding historic buildings both in materiality and detailing, reflecting the industrial context of steel and brickwork in a distinctly urban environment. These materials are offset with contemporary glazing, clean lines and bold proportions which locate the new buildings confidently within their surroundings. New interventions to historic portions of the site are unapologetically contemporary, in contrast to the delicate Edwardian steelwork and detailing. This bold approach in design maintained the diverse spirit of Newtown."
                ],
                method: "Wieland Gleich - Photographer",
                client: "Atterbury Property Development Company",
                status: "built",
                year: "2015",
                services: ["architecture", "urban design"],
                tags: [
                    "mixed-use",
                    "office",
                    "retail",
                    "urban design"
                ],
                location: "https://maps.app.goo.gl/VcJjkJZegaVSbjyp7",
                sliderdata: [
                    {
                        image: newtownsliderimage1,
                        title: "Newtown Junction",
                        number: ""
                    },
                    {
                        image: newtownsliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: newtownsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: newtownsliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: newtownsliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: newtownsliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: newtownsliderimage7,
                        title: "potato sheds - access",
                        number: "6"
                    },
                    {
                        image: newtownsliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: newtownsliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: newtownsliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: newtownsliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: newtownsliderimage12,
                        title: "wieland gleich - photographer",
                        number: "11"
                    },
                    {
                        image: newtownsliderimage13,
                        title: "site visit - 2014",
                        number: "12"
                    },
                    {
                        image: newtownsliderimage14,
                        title: "early illustrations",
                        number: "13"
                    },
                    {
                        image: newtownsliderimage15,
                        title: "",
                        number: "14"
                    },
                    {
                        image: newtownsliderimage16,
                        title: "",
                        number: "15"
                    },
                    {
                        image: oxfordparkssliderimage1,
                        title: "Oxford Parks, Rosebank",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '40',
        title: 'Oxford Parks, Rosebank',
        location: 'Johannesburg, Gauteng',
        year: '2015',
        image: projectsimage40,
        data: [
            oxfordparksimage1,
            oxfordparksimage2,
            oxfordparksimage3,
            oxfordparksimage4,
            oxfordparksimage5
        ],
        pagedata: [
            {
                Pagetitle: "Oxford Parks, Rosebank",
                pagelocation: "Johannesburg, Gauteng",
                paragraphs: [
                    "In 2015, we were commissioned to develop the Dunkeld Public Realm Design Manual, which seeks to ensure a high quality, comfortable pedestrian environment as the precinct is developed. The Design Manual reinforces and complements creates effective pedestrian links between Rosebank and Illovo and formulates the delivery of a reliable and efficient public transport system along Oxford Road. To achieve this, the design manual defines a network of public spaces throughout the development and establishes public realm design guidelines for these and the streets and walkways that connect them.",
                    "The Oxford Parks development draws on the guidance set out in the Design Manual. We designed a masterplan for Oxford Parks that extends the vibrant, pedestrian-friendly environment of Rosebank, in Johannesburg, along the Oxford Road corridor, linking it to the adjacent emerging retail and office node of Illovo. Situated between Cradock Avenue and Oxford Road, Oxford Parks creates a walkable, mixed-use town centre in Johannesburg's emerging multipolar structure."
                ],
                method: "Sean Gibson - Photographer",
                client: "Intaprop",
                status: "completed",
                year: "2015",
                services: ["urban design"],
                tags: [
                    "urban design",
                    "retail",
                    "office",
                    "mixed-use",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/vFHyuHrtAJHQyBBd7",
                sliderdata: [
                    {
                        image: oxfordparkssliderimage1,
                        title: "Oxford Parks, Rosebank",
                        number: ""
                    },
                    {
                        image: oxfordparkssliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: oxfordparkssliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: oxfordparkssliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: oxfordparkssliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: oxfordparkssliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: oxfordparkssliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: oxfordparkssliderimage8,
                        title: "sean gibson - photographer",
                        number: "7"
                    },
                    {
                        image: oxfordparkssliderimage9,
                        title: "site visit - 2017",
                        number: "8"
                    },
                    {
                        image: oxfordparkssliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: oxfordparkssliderimage11,
                        title: "early illustrations",
                        number: "10"
                    },
                    {
                        image: oxfordparkssliderimage12,
                        title: "",
                        number: "11"
                    },
                    {
                        image: oxfordparkssliderimage13,
                        title: "dunkeld precinct design manual overlay",
                        number: "12"
                    },
                    {
                        image: portsidesliderimage1,
                        title: "Portside",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '41',
        title: 'Portside',
        location: 'Cape Town, South Africa',
        year: '2015',
        image: projectsimage41,
        data: [
            portsideimage1,
            portsideimage2,
            portsideimage3,
            portsideimage4,
            portsideimage5
        ],
        pagedata: [
            {
                Pagetitle: "Portside",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "Portside is a striking office development strategically and prominently located in Cape Town’s central business district (CBD, developed in a joint venture between Old Mutual and FirstRand Bank. The brief was to design a building that would encapsulate the energy of a rapidly evolving world-class city, with progressive architectural design features, inspired by a firm commitment to sustainable and responsible development, within a unique location and landscape.",
                    "Intended to be an urban marker, the building also needed to respond to its context in the greater CBD as much as the local precinct and its immediate surroundings. The concept also needed to address the building’s urban functioning in terms of movement systems, public space, land use and building interface.",
                    "Our design addressed the building’s urban form through its massing, height and composition, and its relationship with the urban environment. We carefully considered the building’s visual impact, creating a legible identity on three scales, at the distant, middle and immediate perspectives.",
                    "A key requirement was to provide two clear addresses for the respective corporate owners. We achieved this by creating two separate entrances on opposite sides of the building, each with its own plaza, with Old Mutual’s on Bree Street and FirstRand’s on Buitengracht Street. The entrance to the parking and service vehicle access is located on the upper ground level off Mechau Street.",
                    "The character of the built form was paramount, in particular the height, massing and proportion. The building’s transparent double-glazed façade and its strong verticality gives a crystalline slenderness to its mass and capitalises on panoramic views for tenants. While development rights permitted building heights to 147 metres, we determined that a slightly lower tower was more appropriate to the nature and character of the precinct. The lower scale would also reduce the visual impact of the building in relation to the larger urban and geographical context of the CBD and Table Mountain.",
                    "We also considered the public realm around the building. A vibrant mix of cafes and restaurants on the ground floor activated its frontages and revitalised street life in the area.",
                    "We prioritised the design to ensure it could be a benchmark integrated sustainability. We incorporated features that would raise the standards of green design, by optimising indoor environmental quality and reducing energy, potable water consumption, stormwater run-off, waste production and negative emissions for tall buildings. In 2015, Portside was delivered as one of Africa’s most sustainable buildings, achieving a 5-Star Green Star rating from the Green Building Council of South Africa (GBCSA), and earning the mantle ‘tallest green star rated building in Africa’."
                ],
                method: "Sean Gibson + Wieland Gleich - Photographers",
                client: "First Rand Bank + Old Mutual",
                status: "built",
                year: "2015",
                services: ["architecture"],
                tags: [
                    "mixed-use",
                    "office",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/4Us6snZmN6HDU3Yk7",
                sliderdata: [
                    {
                        image: portsidesliderimage1,
                        title: "Portside",
                        number: ""
                    },
                    {
                        image: portsidesliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: portsidesliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: portsidesliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: portsidesliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: portsidesliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: portsidesliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: portsidesliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: portsidesliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: portsidesliderimage10,
                        title: "sean gibson + wieland gleich - photographers",
                        number: "9"
                    },
                    {
                        image: portsidesliderimage11,
                        title: "initial sketches",
                        number: "10"
                    },
                    {
                        image: portsidesliderimage12,
                        title: "",
                        number: "11"
                    },
                    {
                        image: drostdyhotelsliderimage1,
                        title: "Drostdy Hotel",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '42',
        title: 'Drostdy Hotel',
        location: 'Graaff-Reinet, Eastern Cape',
        year: '2014',
        image: projectsimage42,
        data: [
            drostdyhotelimage1,
            drostdyhotelimage2,
            drostdyhotelimage3
        ],
        pagedata: [
            {
                Pagetitle: "Drostdy Hotel",
                pagelocation: "Graaff-Reinet, Eastern Cape",
                paragraphs: [
                    "The Drostdy Hotel is situated in the historic centre of Graaff-Reinet in the Eastern Cape’s Karoo. Designed by Louis Michel Thibault in the Cape Dutch Style and built by local tradesmen in 1804/5, the Drostdy building and its courtyard garden are structures of great historic and cultural significance as they played a central role in the civic life of the town.",
                    "The Drostdy Hotel first opened its doors in 1977, having previously served first as a Magistrate’s Court and then as a private home. The hotel quickly established a reputation as one of the finest heritage hotels in the country. Despite undergoing extensive restorations and alterations during the course of the building’s life, the old hotel had become fairly run down in recent years. The hotel was purchased in its run down state by its new owners, who shortly afterwards decided to close the hotel in order to allow for the development of a proposal for the extensive refurbishment and restoration of the hotel buildings and to allow for the construction work that will follow.",
                    "The new owners’ vision for the property was to undertake an extensive refurbishment project on the property, carefully restoring the existing historic buildings and adding a number of new facilities in order to create a luxury country hotel with between 45 and 50 rooms. Their vision was for the Drostdy to be restored to the stately property it once was and to re-establish its reputation as the best accommodation in Graaff Reinet and the surrounding area.",
                    "Our approach to the restoration was to integrate the historic fabric with new interventions throughout the property, creating a seamless experience of the rich heritage of the site, while bringing the hotel provision up to the 5-star luxury country hotel standard envisioned by the owners. The project included the masterplan of the entire site, sensitive restoration of significant historic buildings and architectural design of discreet new insertions.",
                    "The reinvigorated Drostdy Hotel property now accommodates 48 new luxury hotel rooms with three swimming pools, a fine dining restaurant, bar and lounges, art gallery, wine shop, vinotheque and spa, as well as associated hotel amenities, all set within fully landscaped grounds. The precinct was designed with an urban design approach, and highlighting the importance of the spaces between the buildings as much as the buildings themselves. Open spaces between the various complexes were reactivated through the introduction of courtyards, swimming pools and terraces. This  creates a sense of community and opens up circulation routes that help to create a village feel. New interventions were designed to sit sensitively within the historic fabric, and to respond in design and material to the contrasting Cape Dutch and Victorian aesthetics.",
                    "Given that the property has operated as a hotel on a continuous basis since 1867, it has played a significant historic role in the tourism of the town, in addition to the cultural, civic and agricultural importance of the site. The restoration project has returned the Drostdy Hotel to the stately property it once was and has re-established its reputation as the finest accommodation in Graaff-Reinet and the surrounding area."
                ],
                method: "Wieland Gleich + Emma Jane Truter - Photographers",
                client: "De Oude Graaff Reinetse Drostdy",
                status: "built",
                year: "2014",
                services: ["architecture", "urban design"],
                tags: [
                    "hospitality",
                    "urban design"
                ],
                location: "https://maps.app.goo.gl/gNjA1iEPAidMyab86",
                sliderdata: [
                    {
                        image: drostdyhotelsliderimage1,
                        title: "Drostdy Hotel",
                        number: ""
                    },
                    {
                        image: drostdyhotelsliderimage2,
                        title: "view from church street",
                        number: "1"
                    },
                    {
                        image: drostdyhotelsliderimage3,
                        title: "corner of church + parliament street",
                        number: "2"
                    },
                    {
                        image: drostdyhotelsliderimage4,
                        title: "main entrance driveway",
                        number: "3"
                    },
                    {
                        image: drostdyhotelsliderimage5,
                        title: "view from the restaurant",
                        number: "4"
                    },
                    {
                        image: drostdyhotelsliderimage6,
                        title: "de camdeboo wjinkamer",
                        number: "5"
                    },
                    {
                        image: drostdyhotelsliderimage7,
                        title: "immibala gallery",
                        number: "6"
                    },
                    {
                        image: drostdyhotelsliderimage8,
                        title: "guest pool",
                        number: "7"
                    },
                    {
                        image: drostdyhotelsliderimage9,
                        title: "vinoteque",
                        number: "8"
                    },
                    {
                        image: drostdyhotelsliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: drostdyhotelsliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: drostdyhotelsliderimage12,
                        title: "green tunnel",
                        number: "11"
                    },
                    {
                        image: drostdyhotelsliderimage13,
                        title: "stretch's court cottages",
                        number: "12"
                    },
                    {
                        image: drostdyhotelsliderimage14,
                        title: "",
                        number: "13"
                    },
                    {
                        image: drostdyhotelsliderimage15,
                        title: "",
                        number: "14"
                    },
                    {
                        image: drostdyhotelsliderimage16,
                        title: "cottage gardens",
                        number: "15"
                    },
                    {
                        image: drostdyhotelsliderimage17,
                        title: "emma jane truter + wieland gleich - photographers",
                        number: "16"
                    },
                    {
                        image: drostdyhotelsliderimage18,
                        title: "early sketches",
                        number: "17"
                    },
                    {
                        image: drostdyhotelsliderimage19,
                        title: "",
                        number: "18"
                    },
                    {
                        image: fabrikmasterplansliderimage1,
                        title: "Fabrik Masterplan",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '43',
        title: 'Fabrik Masterplan',
        location: 'Pretoria, South Africa',
        year: '2014',
        image: projectsimage43,
        data: [
            fabrikmasterplanimage1,
            fabrikmasterplanimage2,
            fabrikmasterplanimage3,
            fabrikmasterplanimage4
        ],
        pagedata: [
            {
                Pagetitle: "Fabrik Masterplan",
                pagelocation: "Pretoria, South Africa",
                paragraphs: [
                    "We developed the Fabrik masterplan for City Prop Administration. The masterplan project formed part of a greater urban design framework for the CBD, set out to regenerate this part of the city. The plan covers two city blocks in the north-east of the Pretoria CBD which had suffered a substantial decline over the years.",
                    "The surrounding city grid has a coarse grain, characterised by large impermeable blocks and wide traffic-congested streets. A key element of the design strategy was to use buildings to define the street edges, opening up these boundaries and stimulating street activity.",
                    "The masterplan retains several architecturally significant 20th century buildings, including industrial sheds, mid-rise residential buildings and 17-storey office buildings. Fabrik includes a diverse mix of uses such as retail, offices, studios, workshops, business incubation spaces, a hotel, residential apartments, event space and a permanent market. The new buildings are arranged around public spaces and a pedestrian route that passes between the two city blocks. This arrangement reinforces positive connections in the urban city fabric."
                ],
                method: "",
                client: "City Prop Administration",
                status: "completed",
                year: "2014",
                services: ["urban design"],
                tags: [
                    "urban design"
                ],
                location: "https://maps.app.goo.gl/CYQSEGbyAdMDBD23A",
                sliderdata: [
                    {
                        image: fabrikmasterplansliderimage1,
                        title: "Fabrik Masterplan",
                        number: ""
                    },
                    {
                        image: fabrikmasterplansliderimage2,
                        title: "area development vision framework plan",
                        number: "1"
                    },
                    {
                        image: fabrikmasterplansliderimage3,
                        title: "site study - view from helen joseph",
                        number: "2"
                    },
                    {
                        image: fabrikmasterplansliderimage4,
                        title: "master plan",
                        number: "3"
                    },
                    {
                        image: fabrikmasterplansliderimage5,
                        title: "theatre precinct",
                        number: "4"
                    },
                    {
                        image: nieuwesteenbergsliderimage1,
                        title: "Nieuwe Steenberg",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '44',
        title: 'Nieuwe Steenberg',
        location: 'Cape Town, South Africa',
        year: '2014',
        image: projectsimage44,
        data: [
            nieuwesteenbergimage1,
            nieuwesteenbergimage2,
            nieuwesteenbergimage3
        ],
        pagedata: [
            {
                Pagetitle: "Nieuwe Steenberg",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "Designed for The Property Partnership, Nieuwe Steenberg is a luxury residential development on the slopes of the Constantiaberg mountain in Cape Town. The development overlooks False Bay towards the Hottentots Holland Mountain range. The challenge was to conceptualise a high-end development for one of the last sites available for development in the exclusive Steenberg area.",
                    "We responded by conceptualising a contemporary residential estate that follows the natural contours of the mountain. The arrangement of the well-appointed homes provides privacy through traditional werf walls surrounding each property, while maintaining a strong sense of community. The design incorporates features that respond directly to the rural context of the setting, including low werf walls, outside spaces open to the street, off-street entrances, pergolas, gabled walls and Victorian profile roof sheeting",
                    "The white-walled houses have traditional high-pitched roofs that allow for generous interiors. Spacious open-plan ground floor living spaces lead onto outdoor living areas and private gardens. Large windows and sliding doors open onto upstairs balconies and ground level covered terraces, filling the spaces with natural light and providing panoramic views across the vineyards and mountain landscape."
                ],
                method: "Wieland Gleich - Photographer",
                client: "The Property Partnership",
                status: "built",
                year: "2014",
                services: ["architecture"],
                tags: [
                    "residential"
                ],
                location: "https://maps.app.goo.gl/TsmpvuW6S43NggEx5",
                sliderdata: [
                    {
                        image: nieuwesteenbergsliderimage1,
                        title: "Nieuwe Steenberg",
                        number: ""
                    },
                    {
                        image: nieuwesteenbergsliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: nieuwesteenbergsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: nieuwesteenbergsliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: nieuwesteenbergsliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: nieuwesteenbergsliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: nieuwesteenbergsliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: nieuwesteenbergsliderimage8,
                        title: "wieland gleich - photographer",
                        number: "7"
                    },
                    {
                        image: theshedssliderimage1,
                        title: "The Sheds",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '45',
        title: 'The Sheds',
        location: 'Pretoria, South Africa',
        year: '2014',
        image: projectsimage45,
        data: [
            theshedsimage1,
            theshedsimage2,
            theshedsimage3,
            theshedsimage4
        ],
        pagedata: [
            {
                Pagetitle: "The Sheds",
                pagelocation: "Pretoria, South Africa",
                paragraphs: [
                    "012 Central in Pretoria, South Africa’s administrative capital, is one example of the diversity in our design portfolio. We were tasked by City Property Administration to complete a renovation of a large industrial shed tucked away in the city’s CBD. Our light-touch insertion provides amenities to support its use as an events space, while maintaining the integrity of the historic industrial fabric. We used shipping containers to form some key new facilities alongside the existing structure, celebrating the industrial warehouse aesthetic. Most of the existing brick fabric of the building was retained, including broken parts of the building such as the existing windows."
                ],
                method: "",
                client: "City Property Administration",
                status: "built",
                year: "2014",
                services: ["architecture"],
                tags: [
                    "mixed-use"
                ],
                location: "https://maps.app.goo.gl/bNVSCFDwVy33r9xs9",
                sliderdata: [
                    {
                        image: theshedssliderimage1,
                        title: "The Sheds",
                        number: ""
                    },
                    {
                        image: theshedssliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: theshedssliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: theshedssliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: theshedssliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: theshedssliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: theshedssliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: theshedssliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: theshedssliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: thefringesliderimage1,
                        title: "The Fringe",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '46',
        title: 'The Fringe',
        location: 'Cape Town, South Africa',
        year: '2012',
        image: projectsimage46,
        data: [
            thefringeimage1,
            thefringeimage2,
            thefringeimage3
        ],
        pagedata: [
            {
                Pagetitle: "The Fringe",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "Collaboration is at the heart of our work. We're proud to be working in association with U+A on a luxury residential development currently underway in the United Arab Emirates, located on Al Marjan Island in Ras Al Khaimah. Our team worked closely with U+A on the design philosophy, coordination and building information modelling (BIM) to create a luxurious yet functional living environment that harmonises with its beachfront location.",
                    "The Al Marjan Beach Club is a prestigious residential development nestled on Al Marjan Island in Ras Al Khaimah. Conveniently located just a 45-minute drive away from both Dubai and Sharjah International Airports, this exclusive enclave offers a luxurious lifestyle, featuring a total of 2000 residential and branded apartments.",
                    "With the breathtaking Arabian Peninsula as its backdrop, the development places a strong emphasis on family-oriented waterfront leisure, complemented by a robust wellness theme. Along the charming promenade, a delightful array of food and beverage options adds to the island's unique allure, solidifying its position as the ultimate destination for those seeking an upscale lifestyle by the water's edge."
                ],
                method: "Binyan + Red Vertex - Renders",
                client: "Aldar Properties",
                status: "on site",
                year: "2028",
                services: ["architecture", "urban design"],
                tags: [
                    "mixed-use",
                    "residential",
                    "hospitality"
                ],
                location: "https://maps.app.goo.gl/HLjRCMfL1BDo9k1KA",
                sliderdata: [
                    {
                        image: thefringesliderimage1,
                        title: "The Fringe",
                        number: ""
                    },
                    {
                        image: thefringesliderimage2,
                        title: "framework plan - urban design",
                        number: "1"
                    },
                    {
                        image: thefringesliderimage3,
                        title: "early inhouse illustrations",
                        number: "2"
                    },
                    {
                        image: thefringesliderimage4,
                        title: "view from east",
                        number: "3"
                    },
                    {
                        image: thefringesliderimage5,
                        title: "view from south",
                        number: "4"
                    },
                    {
                        image: thefringesliderimage6,
                        title: "view from north",
                        number: "5"
                    },
                    {
                        image: thefringesliderimage7,
                        title: "environmental landscape analysis",
                        number: "6"
                    },
                    {
                        image: thefringesliderimage8,
                        title: "open space proposal",
                        number: "7"
                    },
                    {
                        image: thefringesliderimage9,
                        title: "communities - informant",
                        number: "8"
                    },
                    {
                        image: thefringesliderimage10,
                        title: "art + historical - informant",
                        number: "9"
                    },
                    {
                        image: thefringesliderimage11,
                        title: "vegetation - informant + opportunity",
                        number: "10"
                    },
                    {
                        image: thefringesliderimage12,
                        title: "water - informant + opportunity",
                        number: "11"
                    },
                    {
                        image: thefringesliderimage13,
                        title: "waterpedestrian movement",
                        number: "12"
                    },
                    {
                        image: thefringesliderimage14,
                        title: "vehicular access movement",
                        number: "13"
                    },
                    {
                        image: thefringesliderimage15,
                        title: "integrated rapid transit system",
                        number: "14"
                    },
                    {
                        image: thefringesliderimage16,
                        title: "transport + parking",
                        number: "15"
                    },
                    {
                        image: doubletreesliderimage1,
                        title: "DoubleTree Hilton",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '47',
        title: 'DoubleTree Hilton',
        location: 'Veneto, Italy',
        year: '2011',
        image: projectsimage47,
        data: [
            doubletreeimage1,
            doubletreeimage2,
            doubletreeimage3,
            doubletreeimage4
        ],
        pagedata: [
            {
                Pagetitle: "DoubleTree Hilton",
                pagelocation: "Veneto, Italy",
                paragraphs: [
                    "The 200-key four-star hotel was designed as part of a larger complex of buildings. The hotel is strategically located in a semi-rural setting adjacent to a major highway interchange, providing guests easy access to Venice and Marco Polo airport. The hotel and adjoining commercial office building form a semi-circular composition around an existing villa. This building was retained, forming a focal point for the complex.",
                    "The semi-circular main hotel building is accessed off a landscaped parking forecourt that turns its back to the highway. The lowest floor of the three-storey building is constructed below ground level opening out to a garden and open space. Guests enter via a central steel and glass porte cochere into a highly transparent glazed treble-volume lobby on axis with the villa. The lobby houses a central reception desk, a lounge with bar, and a restaurant which all extend in a linear form. The back-of-house kitchen and support accommodation is located in the wing to the right. To the left wing are the administration office, baggage handling, garden suites and rooms.",
                    "The main feature staircase is positioned to maximise the views to the central garden. It extends vertically to form a light weight semi-transparent, mesh clad campanile. The buildings pivot around this structure, easily visible from the highway beyond. Glass balustraded bridges link the upper wings of rooms on either side of the central volume. Externally, the rooms on two upper floors are defined by strong stucco frames housing a carefully structured alternating pattern of modular, vertical windows and natural timber panel infill.",
                    "The strong geometric arc of buildings embraces and encloses the landscaped garden and courtyard spaces. A fully divisible multi-functional conference centre, assembly area, breakaway spaces and support facilities are all linked directly to the main kitchen and back-of-house areas. The gymnasium and indoor/outdoor pool pavilion and outdoor recreation areas are all set below ground level within a green landscaped park. This configuration completes the complex of buildings in the courtyard. The courtyard buildings are angular and orthogonal in plan, contrasting with the soft arc of the main building.",
                    "Materials include off-shutter concrete and stucco for the primary structure, with cladding and sun control elements in horizontal timber panelling responding to the main building’s superstructure. Transparent steel and glass internal, umbilical tunnel and walkways provide year round access to the central buildings, protecting guests in inclement weather. Steel, glass and timber, weather canopies and sun protection pergolas are also provided along the fringes of the buildings."
                ],
                method: "",
                client: "FINPRO s.r.l.",
                status: "built",
                year: "2011",
                services: ["architecture"],
                tags: [
                    "hospitality",
                    "mixed-use",
                    "office"
                ],
                location: "https://maps.app.goo.gl/NKCiEg9Xeuc4KKX49",
                sliderdata: [
                    {
                        image: doubletreesliderimage1,
                        title: "DoubleTree Hilton",
                        number: ""
                    },
                    {
                        image: doubletreesliderimage2,
                        title: "view of conference center from quad",
                        number: "1"
                    },
                    {
                        image: doubletreesliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: doubletreesliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: doubletreesliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: doubletreesliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: doubletreesliderimage7,
                        title: "first + second floor - plan",
                        number: "6"
                    },
                    {
                        image: doubletreesliderimage8,
                        title: "early illustrations - 2006",
                        number: "7"
                    },
                    {
                        image: doubletreesliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: eikestadmallsliderimage1,
                        title: "Eikestad Mall",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '48',
        title: 'Eikestad Mall',
        location: 'Stellenbosch, South Africa',
        year: '2011',
        image: projectsimage48,
        data: [
            eikestadmallimage1,
            eikestadmallimage2
        ],
        pagedata: [
            {
                Pagetitle: "Eikestad Mall",
                pagelocation: "Stellenbosch, South Africa",
                paragraphs: [
                    "The Eikestad Urban Renewal project was developed to upgrade a central part of the historic town of Stellenbosch into a mixed-use and retail development. The Eikestad Mall was the first phase of the regeneration project. Completed in 2011, the centre was designed for clients Abacus Asset Management and Key Capital.",
                    "The mall is located in the central hub of the urban precinct. It was redeveloped and upgraded to form a premium shopping centre. The mall offers street-edge retail on the ground level and two levels of retail above. New shopfronts were created and ceilings were upgraded to improve the mall’s external and internal character. The mall also includes anew food and entertainment component on the third level. This level links the existing centre with a new mixed-use development to the north of Beyers Street, which was planned for phase two. The link is expressed as a glass box which creates a subtle transparent link between the two existing buildings. The upgraded building façades feature solid elements with large openings in the mall spaces and smaller openings in the upper-level offices."
                ],
                method: "Adam Letch - Photographer",
                client: "Abacus Asset Management + Key Capital",
                status: "built",
                year: "2011",
                services: ["architecture", "urban design"],
                tags: [
                    "retail"
                ],
                location: "https://maps.app.goo.gl/dopTyCGqr53kR4JG8",
                sliderdata: [
                    {
                        image: eikestadmallsliderimage1,
                        title: "Eikestad Mall",
                        number: ""
                    },
                    {
                        image: eikestadmallsliderimage2,
                        title: "pedestrian spine - bird street to adringa street",
                        number: "1"
                    },
                    {
                        image: eikestadmallsliderimage3,
                        title: "exterior view - overhead passages",
                        number: "2"
                    },
                    {
                        image: eikestadmallsliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: eikestadmallsliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: eikestadmallsliderimage6,
                        title: "adam letch - photographer",
                        number: "5"
                    },
                    {
                        image: kempsinkisliderimage1,
                        title: "Kempsinki Seychelles",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '49',
        title: 'Kempsinki Seychelles',
        location: 'Mahe, Seychelles',
        year: '2011',
        image: projectsimage49,
        data: [
            kempsinkiimage1,
            kempsinkiimage2
        ],
        pagedata: [
            {
                Pagetitle: "Kempsinki Seychelles",
                pagelocation: "Mahe, Seychelles",
                paragraphs: [
                    "The Kempinski Seychelles hotel project was formerly the Plantation Club Resort and Casino on the island of Mahe, Seychelles. The building was redesigned and redeveloped for European Hotels and Resorts.",
                    "The development includes three distinct components of luxury accommodation located on different parts of the site. The first phase comprised a 166 all-suite four-star hotel on the site of the existing derelict hotel, including a new main building, new staff accommodation and a new spa. Phase two included a six-key luxury beach lodge and a 40-key luxury mountainside lodge."
                ],
                method: "",
                client: "European Hotels & Resorts",
                status: "built",
                year: "2011",
                services: ["architecture"],
                tags: [
                    "hospitality"
                ],
                location: "https://maps.app.goo.gl/E1xiw8GP7XJE7VwF6",
                sliderdata: [
                    {
                        image: kempsinkisliderimage1,
                        title: "Kempsinki Seychelles",
                        number: ""
                    },
                    {
                        image: kempsinkisliderimage2,
                        title: "main building - overhead view",
                        number: "1"
                    },
                    {
                        image: kempsinkisliderimage3,
                        title: "olympic length swimming pool",
                        number: "2"
                    },
                    {
                        image: kempsinkisliderimage4,
                        title: "main lobby + reception area",
                        number: "3"
                    },
                    {
                        image: kempsinkisliderimage5,
                        title: "main building",
                        number: "4"
                    },
                    {
                        image: kempsinkisliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: melrosearchsliderimage1,
                        title: "Melrose Arch Piazza",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '50',
        title: 'Melrose Arch Piazza',
        location: 'Johannesburg, South Africa',
        year: '2010',
        image: projectsimage50,
        data: [
            melrosearchimage1,
            melrosearchimage2,
            melrosearchimage3,
            melrosearchimage4,
            melrosearchimage5
        ],
        pagedata: [
            {
                Pagetitle: "Melrose Arch Piazza",
                pagelocation: "Johannesburg, South Africa",
                paragraphs: [
                    "Designed for Melrose Investment Holdings, the Melrose Arch Piazza precinct integrates seamlessly into the existing Melrose Arch development. Our design response included a new public piazza space connecting to an additional pedestrian route. This created a natural and permeable link between the existing Melrose Square and the rest of the development. The piazza comprises mixed-use retail, offices, leisure and residential components.",
                    "The pedestrian route is lined with high street retail that connects to the new piazza, creating a permeable mall route that is partially covered and partially open. The design features ample glazing to draw in plenty of natural light, which protecting people from rain. The various high street shopping routes intersect at the permeable Galleria, which forms a convenient pedestrianised retail route leading back towards the piazza."
                ],
                method: "",
                client: "Melrose Investment Holdings",
                status: "built",
                year: "2010",
                services: ["architecture", "urban design"],
                tags: [
                    "retail",
                    "residential",
                    "mixed-use",
                    "office"
                ],
                location: "https://maps.app.goo.gl/4DiL36ma7ZAmxhHbA",
                sliderdata: [
                    {
                        image: melrosearchsliderimage1,
                        title: "Melrose Arch Piazza",
                        number: ""
                    },
                    {
                        image: melrosearchsliderimage2,
                        title: "pedestrian view",
                        number: "1"
                    },
                    {
                        image: melrosearchsliderimage3,
                        title: "view from the retail laneway",
                        number: "2"
                    },
                    {
                        image: melrosearchsliderimage4,
                        title: "view down a retail laneway",
                        number: "3"
                    },
                    {
                        image: melrosearchsliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: melrosearchsliderimage6,
                        title: "shopping center - interior",
                        number: "5"
                    },
                    {
                        image: melrosearchsliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: melrosearchsliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: melrosearchsliderimage9,
                        title: "alternative retail + laneway entrance",
                        number: "8"
                    },
                    {
                        image: melrosearchsliderimage10,
                        title: "retail façade detail",
                        number: "9"
                    },
                    {
                        image: melrosearchsliderimage11,
                        title: "laneway view to the piazza",
                        number: "10"
                    },
                    {
                        image: melrosearchsliderimage12,
                        title: "early illustrations - identifying design languages",
                        number: "11"
                    },
                    {
                        image: tajpalacehotelsliderimage1,
                        title: "Taj Palace Hotel",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '51',
        title: 'Taj Palace Hotel',
        location: 'Cape Town, South Africa',
        year: '2010',
        image: projectsimage51,
        data: [
            tajpalacehotelimage1,
            tajpalacehotelimage2,
            tajpalacehotelimage3,
            tajpalacehotelimage4
        ],
        pagedata: [
            {
                Pagetitle: "Taj Palace Hotel",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "The Taj Palace Hotel in Cape Town was the first luxury hotel to be opened by the Taj Group in South Africa. The project comprised the partial demolition, refurbishment and extensive preservation of two important historic buildings – the Old Reserve Bank building and the Temple Chambers building – along with contemporary in fill and additions. The challenge was to celebrate the old and the new equally, creating a synthesis between the historic fabric and the more modern interventions on the site.",
                    "The concept was designed to retain and carefully restore as much of the two historic buildings as possible, which would house the grand public spaces of the hotel. The contemporary additions were an infimport { uctchemicalsliderimage1 } from '';import { uctchemicalsliderimage1 } from '' ill building on St George’s Mall and a new tower that rises out of the centre of the city block. This building accommodates the back-of-house spaces and 167 hotel rooms. A skeletal steel grid covers part of the tower facade to create a dynamic contrast with the historical aesthetic of the existing buildings."
                ],
                method: "Alain Proust - Photographer",
                client: "Good Hope Palace Hotels",
                status: "built",
                year: "2010",
                services: ["architecture"],
                tags: [
                    "hospitality"
                ],
                location: "https://maps.app.goo.gl/SEFwcuzDk9bQ4XmC8",
                sliderdata: [
                    {
                        image: tajpalacehotelsliderimage1,
                        title: "Taj Palace Hotel",
                        number: ""
                    },
                    {
                        image: tajpalacehotelsliderimage2,
                        title: "lower-wale street",
                        number: "1"
                    },
                    {
                        image: tajpalacehotelsliderimage3,
                        title: "corner of wale and adderley street",
                        number: "2"
                    },
                    {
                        image: tajpalacehotelsliderimage4,
                        title: "st. georges mall entrance - from wale street",
                        number: "3"
                    },
                    {
                        image: tajpalacehotelsliderimage5,
                        title: "façade detail - preserved street signage",
                        number: "4"
                    },
                    {
                        image: tajpalacehotelsliderimage6,
                        title: "restored banking hall",
                        number: "5"
                    },
                    {
                        image: tajpalacehotelsliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: tajpalacehotelsliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: tajpalacehotelsliderimage9,
                        title: "preserved facade details",
                        number: "8"
                    },
                    {
                        image: tajpalacehotelsliderimage10,
                        title: "elevation - west",
                        number: "9"
                    },
                    {
                        image: tajpalacehotelsliderimage11,
                        title: "elevation - south",
                        number: "10"
                    },
                    {
                        image: tajpalacehotelsliderimage12,
                        title: "entrance to current pedestrian mall, circa 1932",
                        number: "11"
                    },
                    {
                        image: tajpalacehotelsliderimage13,
                        title: "view from lower wale street, circa 1896",
                        number: "12"
                    },
                    {
                        image: uwclifesliderimage1,
                        title: "UWC Life Sciences Building",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '52',
        title: 'UWC Life Sciences Building',
        location: 'Cape Town, South Africa',
        year: '2010',
        image: projectsimage52,
        data: [
            uwclifeimage1,
            uwclifeimage2,
            uwclifeimage3
        ],
        pagedata: [
            {
                Pagetitle: "UWC Life Sciences Building",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "Designed for the University of the Western Cape in Cape Town, the Life Sciences building is a cutting-edge institutional research laboratory. The University commissioned us to design a building that would place the institution on the world map as a centre of teaching excellence in Africa. The design intent was to create a facility that would embody social and environmental scientific research and promote inter-departmental and inter-disciplinary research.",
                    "Completed in 2010, the project brought together several science departments and research institutes formerly located in several old, separate buildings. These were incorporated into a single development including two floors of instruction, anatomy and specialised laboratories, and four floors of research and development labs, including a Bioinformatics Institute, the Dean’s office and faculty teaching facilities.",
                    "The design comprises two distinctly different buildings joined by a multi-volume glazed entry lobby. The lobby leads into a gathering space that is shaded by trees and over-sailed by a dynamic shading canopy supported on tree-like columns. The laboratory building is constructed from conventional reinforced concrete which contrasts against the curved plan and irregular column grid of the learning centre. An innovative system of shading structures was designed for the north-east and east façades.",
                    "The UWC Life Sciences Building was presented with an award at the 2011/12 Corobrik-SAIA Awards of Merit and Awards for Excellence. The judges noted that “the building successfully showcases a commitment to sustainable building practice and resource efficiency in the way that it responds to the environment and demonstrates cost-effective strategies, placing this building at the forefront of responsible architecture in the country”."
                ],
                method: "",
                client: "University of the Western Cape",
                status: "built",
                year: "2010",
                services: ["architecture", "urban design"],
                tags: [
                    "public + education",
                    "sustainable"
                ],
                location: "https://maps.app.goo.gl/raM6f6AbkMJrxoEz5",
                sliderdata: [
                    {
                        image: uwclifesliderimage1,
                        title: "UWC Life Sciences Building",
                        number: ""
                    },
                    {
                        image: uwclifesliderimage2,
                        title: "uwc entry court + learning center",
                        number: "1"
                    },
                    {
                        image: uwclifesliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: uwclifesliderimage4,
                        title: "pergolas",
                        number: "3"
                    },
                    {
                        image: uwclifesliderimage5,
                        title: "view from modderdam road",
                        number: "4"
                    },
                    {
                        image: uwclifesliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: uwclifesliderimage7,
                        title: "auditorium",
                        number: "6"
                    },
                    {
                        image: uwclifesliderimage8,
                        title: "alternative view - entrance + learning center",
                        number: "7"
                    },
                    {
                        image: wangarimathaisliderimage1,
                        title: "Wangari Mathai Institute",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '53',
        title: 'Wangari Mathai Institute',
        location: 'Nairobi, Kenya',
        year: '2010',
        image: projectsimage53,
        data: [
            wangarimathaiimage1,
            wangarimathaiimage2,
            wangarimathaiimage3
        ],
        pagedata: [
            {
                Pagetitle: "Wangari Mathai Institute",
                pagelocation: "Nairobi, Kenya",
                paragraphs: [
                    "The Wangarĩ Maathai Institute for Peace and Environmental Studies is located on a gently sloping 50-acre site at the University of Nairobi Kabete campus, Kenya. It was envisaged to inspire a hub of activities focused on natural resource management and education for sustainable development. The building was expected to meet stringent sustainability and conservation criteria, aiming to achieve close to 100% carbon neutrality and self-sufficiency.",
                    " Wangarĩ Maathai was an environmental activist. The design gives expression to her vision for a democratic space that would facilitate sustainable management of environmental resources, education and empowerment. A tree at the centre of the space represents Maathai’s commitment to tree planting and her collaborations with the Green Belt Movement, a non-governmental organisation that uses tree planting as an entry point for self-determination, equity, improved livelihoods and security and environmental conservation.",
                    " The roof of the building floats over the facilities below like a dramatic flowing tree canopy resting on tree-like steel columns. The building form seems to blend with the topography of the surrounding landscape, yet at certain key points the canopy is raised up to receive visitors into the building. The architectural quality, material and detailing of the building were crucial, in terms of the external envelope and the indoor spatial environment in terms of occupant comfort. The relationship to the public realm, street level activation, scale, legibility and permeability were key drivers in the design that could help to addressing its social context and urban regeneration."
                ],
                method: "",
                client: "Wangari Maathai Foundation",
                status: "proposed",
                year: "2010",
                services: ["architecture"],
                tags: [
                    "public + education"
                ],
                location: "https://maps.app.goo.gl/pfYvGDpqW6exmDp76",
                sliderdata: [
                    {
                        image: wangarimathaisliderimage1,
                        title: "Wangari Mathai Institute",
                        number: ""
                    },
                    {
                        image: wangarimathaisliderimage2,
                        title: "early illustrations",
                        number: "1"
                    },
                    {
                        image: wangarimathaisliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: wangarimathaisliderimage4,
                        title: "'democratic space'",
                        number: "3"
                    },
                    {
                        image: wangarimathaisliderimage5,
                        title: "'dynamic exhibition facilities'",
                        number: "4"
                    },
                    {
                        image: wangarimathaisliderimage6,
                        title: "early illustrations of views",
                        number: "5"
                    },
                    {
                        image: wangarimathaisliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: wangarimathaisliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: wangarimathaisliderimage9,
                        title: "masterplan",
                        number: "8"
                    },
                    {
                        image: wangarimathaisliderimage10,
                        title: "original concept sketches",
                        number: "9"
                    },
                    {
                        image: wangarimathaisliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: wangarimathaisliderimage12,
                        title: "",
                        number: "11"
                    },
                    {
                        image: ahmedbabasliderimage1,
                        title: "Ahmed Baba Institute",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '54',
        title: 'Ahmed Baba Institute',
        location: 'Timbuktu, Mali',
        year: '2009',
        image: projectsimage54,
        data: [
            ahmedbabaimage1,
            ahmedbabaimage2,
            ahmedbabaimage3,
            ahmedbabaimage4,
            ahmedbabaimage5
        ],
        pagedata: [
            {
                Pagetitle: "Ahmed Baba Institute",
                pagelocation: "Timbuktu, Mali",
                paragraphs: [
                    "Timbuktu was a thriving university city for over a thousand years. It was historically a seat of Islamic learning housing many ancient Islamic texts and books. Written in almost forgotten languages and dialects of North Africa, these priceless but decaying collections were being stored in private homes throughout the city. The Ahmed Baba centre was established to restore the scattered collection.",
                    "The project was conceived when then-South African President Thabo Mbeki established a presidential project as a gift from the people of South Africa to the people",
                    "of Mali, reflecting his concern for the preservation of African heritage. The centre is located on the world heritage site in the Sankore Precinct, occupying a zone between the old mud-brick city and the more modern periphery. Over time, pedestrian movement carved the old city into a complex urban grain of narrow and secretive streets.",
                    "Our design response sought to capture these unique qualities. The new buildings were formulated as a microcosm of greater Timbuktu; an experiential route uniting the programmatic functions to form an interactive whole. At ground level, the complex comprises a covered ceremonial arrival galleria on axis with the minaret of the old Sankore mosque, a book restoration and digitising workshop, photographic studio, meeting spaces, library and guest house for visiting academics. These spaces are linked by a system of internal ‘streets’ and courtyards, reflecting the historic context.",
                    "A cool, temperature-stable basement houses the archive, storage and reading room. The auditorium, used for lectures and public functions, lies in the central courtyard at the heart of the complex. The first floor houses offices and visitor accommodation. The building extends to include a raked amphitheatre fronting the arrival galleria. Its single storey outer edges are activated with retail uses around the square. The balance of the public square is left as found, giving the mosque pride of place at the heart of the local community.",
                    "The architectural expression is a synthesis of old and new building traditions. Thick sun-baked mud brick walls with deeply recessed openings represent the old, while the overarching off-shutter concrete provide a contemporary expression of shelter and shade. These two materials form the main compositional elements.",
                    "Hand chiselled stone screens filter the sun and animate the façade. Crafted by local artisans, these screens respond to the Moroccan influence on the local vernacular. Internally these decorative yet practical devices provide a tranquil and cool environment away from the unrelenting desert sun."
                ],
                method: "Iwan Baan - Photographer",
                client: "COESSA Holdings",
                status: "built",
                year: "2009",
                services: ["architecture"],
                tags: [
                    "public + education"
                ],
                location: "https://maps.app.goo.gl/GAJmrYMpHyQyG2uNA",
                sliderdata: [
                    {
                        image: ahmedbabasliderimage1,
                        title: "Ahmed Baba Institute",
                        number: ""
                    },
                    {
                        image: ahmedbabasliderimage2,
                        title: "local context",
                        number: "1"
                    },
                    {
                        image: ahmedbabasliderimage3,
                        title: "primary entrance",
                        number: "2"
                    },
                    {
                        image: ahmedbabasliderimage4,
                        title: "main passageway",
                        number: "3"
                    },
                    {
                        image: ahmedbabasliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: ahmedbabasliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: ahmedbabasliderimage7,
                        title: "library entrance",
                        number: "6"
                    },
                    {
                        image: ahmedbabasliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: ahmedbabasliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: ahmedbabasliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: ahmedbabasliderimage11,
                        title: "",
                        number: "10"
                    },
                    {
                        image: ahmedbabasliderimage12,
                        title: "",
                        number: "11"
                    },
                    {
                        image: ahmedbabasliderimage13,
                        title: "",
                        number: "12"
                    },
                    {
                        image: ahmedbabasliderimage14,
                        title: "",
                        number: "13"
                    },
                    {
                        image: ahmedbabasliderimage15,
                        title: "iwan baan - photographer",
                        number: "14"
                    },
                    {
                        image: delairegraffwinerysliderimage1,
                        title: "Delaire Graff Winery",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '55',
        title: 'Delaire Graff Winery',
        location: 'Stellenbosch, South Africa',
        year: '2009',
        image: projectsimage55,
        data: [
            delairegraffwineryimage1,
            delairegraffwineryimage2,
            delairegraffwineryimage3,
            delairegraffwineryimage4
        ],
        pagedata: [
            {
                Pagetitle: "Delaire Graff Winery",
                pagelocation: "Stellenbosch, South Africa",
                paragraphs: [
                    "Delaire Graff Estate includes 7000 m² of buildings that include a winery, tasting room and restaurant. These three buildings are defined separately on the site though connected by a stone wall that forms a spine that runs along the length of the site. The winery is tucked away behind the stone wall and the tasting and restaurant buildings sit in front. The breaking down of the bulk of the building into three separate forms creates a sense of intimacy and a human scale.",
                    "The design of each of building is articulated according to its function, connection to the greater site, and its relationship to the other buildings and the spine wall.",
                    "They are tied together using common materials and architectural elements to form a cohesive whole. The circulation and service spaces for the building are defined",
                    "as stitching elements between the three core buildings. An outside entrance courtyard and a large foyer create a dynamic arrival experience."
                ],
                method: "",
                client: "Laurence Graff Wines",
                status: "built",
                year: "2009",
                services: ["architecture"],
                tags: [
                    "hospitality"
                ],
                location: "https://maps.app.goo.gl/L4yrpke1Lq1vfwMp7",
                sliderdata: [
                    {
                        image: delairegraffwinerysliderimage1,
                        title: "Delaire Graff Winery",
                        number: ""
                    },
                    {
                        image: delairegraffwinerysliderimage2,
                        title: "main entrance - exterior",
                        number: "1"
                    },
                    {
                        image: delairegraffwinerysliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: delairegraffwinerysliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: delairegraffwinerysliderimage5,
                        title: "view of the main entrance - interior",
                        number: "4"
                    },
                    {
                        image: delairegraffwinerysliderimage6,
                        title: "view of the cellars from reception",
                        number: "5"
                    },
                    {
                        image: delairegraffwinerysliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: delairegraffwinerysliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: delairegraffwinerysliderimage9,
                        title: "delaire plant",
                        number: "8"
                    },
                    {
                        image: delairegraffwinerysliderimage10,
                        title: "",
                        number: "9"
                    },
                    {
                        image: delairegraffwinerysliderimage11,
                        title: "passageway to restaurant",
                        number: "10"
                    },
                    {
                        image: delairegraffwinerysliderimage12,
                        title: "delaire restaurant - interiors",
                        number: "11"
                    },
                    {
                        image: delairegraffwinerysliderimage13,
                        title: "delaire tasting lounge - interiors + views",
                        number: "12"
                    },
                    {
                        image: delairegraffwinerysliderimage14,
                        title: "delaire vinoteque - interiors",
                        number: "13"
                    },
                    {
                        image: delairegraffwinerysliderimage15,
                        title: "restaurant terrace",
                        number: "14"
                    },
                    {
                        image: delairegraffwinerysliderimage16,
                        title: "zen pool",
                        number: "15"
                    },
                    {
                        image: delairegraffwinerysliderimage17,
                        title: "sections",
                        number: "16"
                    },
                    {
                        image: delairegraffwinerysliderimage18,
                        title: "early model mock-up",
                        number: "17"
                    },
                    {
                        image: delairegraffwinerysliderimage19,
                        title: "site plan",
                        number: "18"
                    },
                    {
                        image: delairegraffwinerysliderimage20,
                        title: "first concept sketch",
                        number: "19"
                    },
                    {
                        image: theboulevardslideimage1,
                        title: "The Boulevard",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '56',
        title: 'The Boulevard',
        location: 'Cape Town, South Africa',
        year: '2009',
        image: projectsimage56,
        data: [
            theboulevardimage1,
            theboulevardimage2,
            theboulevardimage3
        ],
        pagedata: [
            {
                Pagetitle: "The Boulevard",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "The Boulevard is situated on a two-hectare site facing the Eastern Boulevard at the entrance to Cape Town.",
                    "Faircape Property Developers, in partnership with Trematon Capital Investments Ltd, commissioned us to design a distinct office park that would accommodate various tenants while contributing to Woodstock's revitalisation. Our scope included the spatial design and basement parking levels.",
                    "The contemporary buildings we designed surround a central piazza and feature striking faceted glass façades, external columns and flush glazing."
                ],
                method: "",
                client: "Faircape Property Developers + Trematon Capital Investments Ltd",
                status: "built",
                year: "2009",
                services: ["architecture"],
                tags: [
                    "office"
                ],
                location: "https://maps.app.goo.gl/B9fBFmxGzbWKBpb16",
                sliderdata: [
                    {
                        image: theboulevardslideimage1,
                        title: "The Boulevard",
                        number: ""
                    },
                    {
                        image: theboulevardslideimage2,
                        title: "primary entrance - vehicular + pedestrians",
                        number: "1"
                    },
                    {
                        image: theboulevardslideimage3,
                        title: "main avenue - access points to tenant offices",
                        number: "2"
                    },
                    {
                        image: theboulevardslideimage4,
                        title: "main piazza",
                        number: "3"
                    },
                    {
                        image: theboulevardslideimage5,
                        title: "piazza edge - view of block a",
                        number: "4"
                    },
                    {
                        image: theboulevardslideimage6,
                        title: "view of piazza from block b",
                        number: "5"
                    },
                    {
                        image: theboulevardslideimage7,
                        title: "façade detail",
                        number: "6"
                    },
                    {
                        image: thecrystalsliderimage1,
                        title: "The Crystal",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '57',
        title: 'The Crystal',
        location: 'Cape Town, South Africa',
        year: '2009',
        image: projectsimage57,
        data: [
            thecrystalimage1,
            thecrystalimage2,
            thecrystalimage3
        ],
        pagedata: [
            {
                Pagetitle: "The Crystal",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "The Crystal is a residential development in Camps Bay, South Africa, a popular destination among tourists and locals. It offers luxury apartments, including studios, one-, two-bedroom apartments as well as two-bedroom loft apartments, all featuring private balconies or patios. It also features a swimming pool on the terrace with panoramic views of the Atlantic Ocean. Residents seeking both luxury and safety in one of Cape Town's most desirable neighbourhoods also enjoy amenities including secure underground parking and convenient access to essential services and entertainment venues."
                ],
                method: "Wieland Gleich - Photographer",
                client: "ALSO Projects Global",
                status: "built",
                year: "2009",
                services: ["architecture"],
                tags: [
                    "residential"
                ],
                location: "https://maps.app.goo.gl/RG21CycKQub6VvKM9",
                sliderdata: [
                    {
                        image: thecrystalsliderimage1,
                        title: "The Crystal",
                        number: ""
                    },
                    {
                        image: thecrystalsliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: thecrystalsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: thecrystalsliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: thecrystalsliderimage5,
                        title: "wieland gleich - photographer",
                        number: "4"
                    },
                    {
                        image: projectsimage58,
                        title: "Tower Docks",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '58',
        title: 'Tower Docks',
        location: 'Venice, Italy',
        year: '2009',
        image: projectsimage58,
        data: [],
        pagedata: [
            {
                Pagetitle: "Tower Docks",
                pagelocation: "Venice, Italy",
                paragraphs: [],
                method: "",
                client: "",
                status: "built",
                year: "2009",
                services: ["architecture", "urban design", "interior design"],
                tags: [
                    "hospitality",
                    "residential",
                    "retail",
                    "mixed-use",
                    "office"
                ],
                location: "",
                sliderdata: [
                    {
                        image: projectsimage58,
                        title: "Tower Docks",
                        number: "1"
                    },
                    {
                        image: mandelarhodesplacesliderimage1,
                        title: "Mandela Rhodes Place",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '59',
        title: 'Mandela Rhodes Place',
        location: 'Cape Town, South Africa',
        year: '2008',
        image: projectsimage59,
        data: [
            mandelarhodesplaceimage1,
            mandelarhodesplaceimage2,
            mandelarhodesplaceimage3,
            mandelarhodesplaceimage4
        ],
        pagedata: [
            {
                Pagetitle: "Mandela Rhodes Place",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "The Mandela Rhodes Place mixed-use development was the first phase of a broader urban renewal scheme in the Cape Town CBD. The project came about as the winning design from a limited competition between five invited architectural studios.",
                    "Materially the building blends in with the rest of the campus using “university plaster”, however it blends this with contemporary elements in order to contrast the new with the old. The base of the building is clad in stone and three storeys are raised up on piloti to form aglazed entrance on ground level. The plastered facade steps away from the glazed skin of the building in orderto provide shading to the inside spaces, while allowingviews and ventilation. The top storey steps back tocreate balconies that also have picturesque views ofthe city. Meshed “fins” attach to the edges of the roof inorder to shade the inside spaces on this level",
                    "The residential complex comprises a total of 180 luxury apartments and penthouses and approximately 300 parking bays. The upper floors of the Kendal, Fairbairn and Court Chambers Buildings have been converted to apartments facing St George’s Mall and Wale Streets respectively, while the ground floors have been opened up to increase visibility of the active retail edges. A contemporary residential tower with 42 luxury apartments rises a further 10 floors above the existing building to a height of 60 metres, limited by the inner-city height restriction."
                ],
                method: "",
                client: "Eurocape Investments",
                status: "built",
                year: "2008",
                services: ["architecture", "urban design", "interior design"],
                tags: [
                    "hospitality",
                    "residential",
                    "retail",
                    "mixed-use",
                    "office"
                ],
                location: "https://maps.app.goo.gl/bvmeacKC5E9Bh7CL8",
                sliderdata: [
                    {
                        image: mandelarhodesplacesliderimage1,
                        title: "Tower Docks",
                        number: ""
                    },
                    {
                        image: mandelarhodesplacesliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: mandelarhodesplacesliderimage3,
                        title: "view of table bay from mandela rhodes place",
                        number: "2"
                    },
                    {
                        image: mandelarhodesplacesliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: mandelarhodesplacesliderimage5,
                        title: "interior atrium",
                        number: "4"
                    },
                    {
                        image: mandelarhodesplacesliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: mandelarhodesplacesliderimage7,
                        title: "pool deck",
                        number: "6"
                    },
                    {
                        image: uctchemicalsliderimage1,
                        title: "UCT Chemical Engineering Building",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '60',
        title: 'UCT Chemical Engineering Building',
        location: 'Cape Town, South Africa',
        year: '2005',
        image: projectsimage60,
        data: [
            uctchemicalimage1,
            uctchemicalimage2,
            uctchemicalimage3,
            uctchemicalimage4,
            uctchemicalimage5
        ],
        pagedata: [
            {
                Pagetitle: "UCT Chemical Engineering Building",
                pagelocation: "Cape Town, South Africa",
                paragraphs: [
                    "The Chemical Engineering Building, situated on the upper campus of the University of Cape Town, was theproduct of a three-year collaborative process involvingacademics, researchers, architects, engineers, artists,builders and students.",
                    "Materially the building blends in with the rest of the campus using “university plaster”, however it blends this with contemporary elements in order to contrast the new with the old. The base of the building is clad in stone and three storeys are raised up on piloti to form aglazed entrance on ground level. The plastered facade steps away from the glazed skin of the building in orderto provide shading to the inside spaces, while allowingviews and ventilation. The top storey steps back tocreate balconies that also have picturesque views ofthe city. Meshed “fins” attach to the edges of the roof inorder to shade the inside spaces on this level"
                ],
                method: "",
                client: "University of Cape Town",
                status: "built",
                year: "2005",
                services: ["architecture"],
                tags: [
                    "public + education"
                ],
                location: "https://maps.app.goo.gl/wsdob4HywJEyuEru6",
                sliderdata: [
                    {
                        image: uctchemicalimage1,
                        title: "UCT Chemical Engineering Building",
                        number: ""
                    },
                    {
                        image: uctchemicalsliderimage2,
                        title: "pedestrian view from the campus south lane",
                        number: "1"
                    },
                    {
                        image: uctchemicalsliderimage3,
                        title: "pedestrian view from parking-lot",
                        number: "2"
                    },
                    {
                        image: uctchemicalsliderimage4,
                        title: "uct campus view",
                        number: "3"
                    },
                    {
                        image: uctchemicalsliderimage5,
                        title: "façade design language",
                        number: "4"
                    },
                    {
                        image: uctchemicalsliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: uctchemicalsliderimage7,
                        title: "ground-floor lobby",
                        number: "6"
                    },
                    {
                        image: uctchemicalsliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: uctchemicalsliderimage9,
                        title: "",
                        number: "8"
                    },
                    {
                        image: uctchemicalsliderimage10,
                        title: "thoroughfare system",
                        number: "9"
                    },
                    {
                        image: uctchemicalsliderimage11,
                        title: "access-controlled parking",
                        number: "10"
                    },
                    {
                        image: lavelasliderimage1,
                        title: "La Vela",
                        number: ""
                    }
                ]
            }
        ]
    },
    {
        number: '61',
        title: 'La Vela',
        location: 'Mestre, Italy',
        year: '2004',
        image: projectsimage61,
        data: [
            lavelaimage1,
            lavelaimage2,
            lavelaimage3,
            lavelaimage4
        ],
        pagedata: [
            {
                Pagetitle: "La Vela",
                pagelocation: "Mestre, Italy",
                paragraphs: [
                    "The Venezia Futura project in Italy is located on an existing dock lined with light industrial sheds. A grand vision was conceived for the head of this dock tore-establish a tourist link from the heart of mainland Venice (Mestre) into the lagoon and to Venice beyond.",
                    "La Vela is a four-storey commercial office building situated on the edge of the dock and a new road, forming a highly visible landmark for passing vehicle and boat traffic. It is an elegant glass building which draws in plenty of light and ventilation, creating a stimulating and comfortable office environment for its occupants. The building’s plan is divided into three zones each served by a circulation core. The flexible plan layout accommodates a range of office sizes. Steel columns support the dynamic steel roof. Its sharp point projects over the building’s footprint, giving the effect of a navigation point for traffic."
                ],
                method: "",
                client: "Venezia Futura s.r.l.",
                status: "built",
                year: "2004",
                services: ["architecture"],
                tags: [
                    "office",
                    "mixed-use"
                ],
                location: "https://maps.app.goo.gl/etx74p8bunSFKUH88",
                sliderdata: [
                    {
                        image: lavelasliderimage1,
                        title: "La Vela",
                        number: ""
                    },
                    {
                        image: lavelasliderimage2,
                        title: "view from vie ancona drive",
                        number: "1"
                    },
                    {
                        image: lavelasliderimage3,
                        title: "view from the canal",
                        number: "2"
                    },
                    {
                        image: lavelasliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: lavelasliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: lavelasliderimage6,
                        title: "façade details",
                        number: "5"
                    },
                    {
                        image: lavelasliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: lavelasliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: lavelasliderimage9,
                        title: "2004 - site visit",
                        number: "8"
                    },
                    {
                        image: lavelasliderimage10,
                        title: "initial illustrations",
                        number: "9"
                    },
                    {
                        image: lagunapalacehotelsliderimage1,
                        title: "Laguna Palace Hotel",
                        number: ""
                    },
                ]
            }
        ]
    },
    {
        number: '62',
        title: 'Laguna Palace Hotel',
        location: 'Venice, Italy',
        year: '2004',
        image: projectsimage62,
        data: [
            lagunapalacehotelimage1,
            lagunapalacehotelimage2,
            lagunapalacehotelimage3,
            lagunapalacehotelimage4
        ],
        pagedata: [
            {
                Pagetitle: "Laguna Palace Hotel",
                pagelocation: "Venice, Italy",
                paragraphs: [
                    "The Laguna Palace development comprises two six-storey buildings on either side of a newly extended and widened dock in Mestre, on the mainland of Venice, Italy. The first building is a 400-key luxury hotel and conference centre and the second is an all-suite hotel with two floors of parking constructed below the water level.",
                    "The two buildings are separated by a 56-metre-wide body of water. This is bridged by a flat glass and steel roof, which at the time was the largest in Europe. The bold tensile roof structure was designed in collaboration with Favero & Milan Ingegneria.",
                    "Our inspiration for the structural supports was the vast floating cranes of the shipping yards silhouetted on the skyline beyond the site. The roof appears to hover over the buildings and the water, belying its weight and span. The roof creates an arch for boats as they enter the dock. It was envisioned as a gateway that would re-establish the water link between Mestre and Venice."
                ],
                method: "",
                client: "Alemagnauno",
                status: "built",
                year: "2004",
                services: ["architecture"],
                tags: [
                    "hospitality"
                ],
                location: "https://maps.app.goo.gl/KxBbagdzbv5KSQoCA",
                sliderdata: [
                    {
                        image: lagunapalacehotelsliderimage1,
                        title: "Laguna Palace Hotel",
                        number: ""
                    },
                    {
                        image: lagunapalacehotelsliderimage2,
                        title: "",
                        number: "1"
                    },
                    {
                        image: lagunapalacehotelsliderimage3,
                        title: "",
                        number: "2"
                    },
                    {
                        image: lagunapalacehotelsliderimage4,
                        title: "",
                        number: "3"
                    },
                    {
                        image: lagunapalacehotelsliderimage5,
                        title: "",
                        number: "4"
                    },
                    {
                        image: lagunapalacehotelsliderimage6,
                        title: "",
                        number: "5"
                    },
                    {
                        image: lagunapalacehotelsliderimage7,
                        title: "",
                        number: "6"
                    },
                    {
                        image: lagunapalacehotelsliderimage8,
                        title: "",
                        number: "7"
                    },
                    {
                        image: projectsimage1,
                        title: "red vertex - render",
                        number: ""
                    },
                ]
            }
        ]
    },
]

export default projects;